export default {
    "en": {
        "http-statuses": {
            "0": "Unknown Error",
            "100": "Continue",
            "101": "Switching Protocols",
            "102": "Processing",
            "200": "OK",
            "201": "Created",
            "202": "Accepted",
            "203": "Non-Authoritative Information",
            "204": "No Content",
            "205": "Reset Content",
            "206": "Partial Content",
            "207": "Multi-Status",
            "208": "Already Reported",
            "226": "IM Used",
            "300": "Multiple Choices",
            "301": "Moved Permanently",
            "302": "Found",
            "303": "See Other",
            "304": "Not Modified",
            "305": "Use Proxy",
            "307": "Temporary Redirect",
            "308": "Permanent Redirect",
            "400": "Bad Request",
            "401": "Unauthorized",
            "402": "Payment Required",
            "403": "Forbidden",
            "404": "Not Found",
            "405": "Method Not Allowed",
            "406": "Not Acceptable",
            "407": "Proxy Authentication Required",
            "408": "Request Timeout",
            "409": "Conflict",
            "410": "Gone",
            "411": "Length Required",
            "412": "Precondition Failed",
            "413": "Payload Too Large",
            "414": "URI Too Long",
            "415": "Unsupported Media Type",
            "416": "Range Not Satisfiable",
            "417": "Expectation Failed",
            "418": "I'm a teapot",
            "419": "Session Has Expired",
            "421": "Misdirected Request",
            "422": "Unprocessable Entity",
            "423": "Locked",
            "424": "Failed Dependency",
            "425": "Too Early",
            "426": "Upgrade Required",
            "428": "Precondition Required",
            "429": "Too Many Requests",
            "431": "Request Header Fields Too Large",
            "444": "Connection Closed Without Response",
            "449": "Retry With",
            "451": "Unavailable For Legal Reasons",
            "499": "Client Closed Request",
            "500": "Internal Server Error",
            "501": "Not Implemented",
            "502": "Bad Gateway",
            "503": "Maintenance Mode",
            "504": "Gateway Timeout",
            "505": "HTTP Version Not Supported",
            "506": "Variant Also Negotiates",
            "507": "Insufficient Storage",
            "508": "Loop Detected",
            "509": "Bandwidth Limit Exceeded",
            "510": "Not Extended",
            "511": "Network Authentication Required",
            "520": "Unknown Error",
            "521": "Web Server is Down",
            "522": "Connection Timed Out",
            "523": "Origin Is Unreachable",
            "524": "A Timeout Occurred",
            "525": "SSL Handshake Failed",
            "526": "Invalid SSL Certificate",
            "527": "Railgun Error",
            "598": "Network Read Timeout Error",
            "599": "Network Connect Timeout Error",
            "unknownError": "Unknown Error"
        },
        "ricven": {
            "scan_barcode_to_increment": "Scan the barcode to increase the amount of received",
            "reception_data": "Reception data",
            "confirm_mismatched_quantities": "Confirm mismatched quantities",
            "confirm_mismatched_quantities_description": "Some rows have a total quantity (registered + to be registered) different from the order quantity.<br>Do you want to continue anyway?<br>",
            "item_not_found_or_already_pickedup": "Item {item} not found or already picked up in the list of these orders",
            "barcode_mismatched": "Barcode mismatch",
            "normal": "Normal",
            "descriptive": "Descriptive",
            "kitchen": "Cucina",
            "enter_the_quantity_to_be_shipped": "Enter the quantity to be shipped of",
            "warehouse_choice": "Warehouse choice",
            "add_selected_items": "Add selected items",
            "insert_qty": "Insert quantity",
            "insert_qty_for": "Insert the quantity for",
            "article_details": "Article details",
            "select_inventory_session": "Select the inventory session",
            "choose_session": "Choose a session",
            "created_by": "Created by",
            "deposit": "Deposit",
            "delete_session": "Delete session",
            "create_new_inventory_session": "Create new inventory session",
            "choose_a_warehouse": "Choose a warehouse",
            "confirm_session_deletion": "Confirm session deletion",
            "confirm_session_deletion_confirm": "Are you sure you want to delete this inventory session? This action is irreversible.",
            "confirm_inventory": "Confirm inventory",
            "confirm_inventory_confirmation": "Do you want to confirm and close this inventory session? It will no longer be editable.",
            "list_supplier_orders": "List supplier orders",
            "list_client_orders": "List client orders",
            "filter_by": "Filter by",
            "client": "client",
            "confirm": "Confirm"
        },
        "core": {
            "order_number": "Order Number",
            "supplier": "Supplier",
            "supplier_docno": "Supplier Doc No",
            "customer": "Customer",
            "searching": "Searching",
            "on_date": "On",
            "date": "Date",
            "load": "Load",
            "inventory_management": "Inventory Management",
            "receiving_goods": "Receiving goods",
            "order_fulfillment": "Order Fulfillment",
            "order": "Order",
            "position": "Pos.",
            "item": "Item",
            "description": "Description",
            "qty_order": "Qty Ordered",
            "qty_registered": "Qty Reg.",
            "qty_to_register": "Qty to Register",
            "registration": "Registr.",
            "order_details": "Order Details",
            "barcode_search": "Barcode Search",
            "item_search": "Item Search",
            "qty_received_of": "Enter the quantity received of",
            "in_order": "in the order",
            "set": "Set",
            "confirm_receive": "Confirm Receive",
            "document": "Document",
            "item_not_found": "Item not found",
            "successful_operation": "Operation successful",
            "error": "Error",
            "receiving": "Receiving",
            "shipped": "Shipped",
            "to_be_shipped": "To Be Shipped",
            "shipping": "Shipping",
            "destination": "Destination",
            "shipping_type": "Shipping Type",
            "gross_weight": "Gross Weight",
            "net_weight": "Net Weight",
            "number_of_packages": "Number of Packages",
            "article_list": "Article List",
            "available": "Available",
            "code": "Code",
            "product_category": "Product Category",
            "homogeneous_category": "Homogeneous Category",
            "lot": "Lot",
            "storage": "Warehouse",
            "price": "Price",
            "discount": "Discount",
            "lot_required_warning": "Warning: Lot has not been set for all items with quantity to register",
            "bin_required_warning": "Warning: Bin has not been set for all items with quantity to register",
            "generate_lot": "Generate Lot",
            "lot_prefix": "Lot Prefix",
            "lot_year_format": "Year Format",
            "lot_separator": "Separator",
            "lot_suffix": "Lot Suffix",
            "choose_item": "Choose an item",
            "bol_number": "Bill of Lading Number",
            "reference": "Ref.",
            "bin": "Bin",
            "icam_status": "ICAM Status",
            "save": "Save",
            "line": "Line",
            "billofladings": "Bills of Lading",
            "saving_data": "Saving data",
            "items_list": "Items List",
            "bill_number": "Bill of Lading Number",
            "commodity_ctg": "Product Category",
            "homogeneous_ctg": "Homogeneous Category",
            "search": "Search",
            "close_and_continue": "Close and continue",
            "barcode_lot_search": "Barcode or Lot Search",
            "company_name": "Company Name",
            "server_error": "Internal server error",
            "connection_error": "Unable to establish connection, check your network",
            "unit_value": "Unit Value",
            "item_supplier_code": "Supplier Code"
        },
        "actions": {
            "accept": "Accept",
            "action": "Action",
            "actions": "Actions",
            "add": "Add",
            "admin": "Admin",
            "agree": "Agree",
            "archive": "Archive",
            "assign": "Assign",
            "associate": "Associate",
            "attach": "Attach",
            "browse": "Browse",
            "cancel": "Cancel",
            "choose": "Choose",
            "choose_file": "Choose File",
            "choose_image": "Choose Image",
            "click_to_copy": "Click to copy",
            "close": "Close",
            "collapse": "Collapse",
            "collapse_all": "Collapse All",
            "comment": "Comment",
            "confirm": "Confirm",
            "confirm_and_save": "Confirm & Save",
            "connect": "Connect",
            "create": "Create",
            "delete": "Delete",
            "detach": "Detach",
            "details": "Details",
            "disable": "Disable",
            "discard": "Discard",
            "done": "Done",
            "down": "Down",
            "duplicate": "Duplicate",
            "edit": "Edit",
            "enable": "Enable",
            "expand": "Expand",
            "expand_all": "Expand All",
            "explanation": "Explanation",
            "export": "Export",
            "file": "File",
            "files": "Files",
            "go_home": "Go Home",
            "hide": "Hide",
            "home": "Home",
            "image": "Image",
            "impersonate": "Impersonate",
            "impersonation": "Impersonation",
            "import": "Import",
            "introduction": "Introduction",
            "like": "Like",
            "load": "Load",
            "localize": "Localize",
            "log_in": "Log In",
            "log_out": "Log Out",
            "named": {
                "add": "Add {name}",
                "choose": "Choose {name}",
                "create": "Create {name}",
                "delete": "Delete {name}",
                "duplicate": "Duplicate {name}",
                "edit": "Edit {name}",
                "export": "Export {name}",
                "hide": "Hide {name}",
                "import": "Import {name}",
                "new": "New {name}",
                "restore": "Restore {name}",
                "save": "Save {name}",
                "search": "Search {name}",
                "show": "Show {name}",
                "update": "Update {name}",
                "view": "View {name}"
            },
            "new": "New",
            "no": "No",
            "open": "Open",
            "open_website": "Open on the website",
            "preview": "Preview",
            "price": "Price",
            "record": "Record",
            "restore": "Restore",
            "save": "Save",
            "save_and_close": "Save & Close",
            "save_and_return": "Save & Return",
            "search": "Search",
            "select": "Select",
            "select_all": "Select All",
            "send": "Send",
            "settings": "Settings",
            "show": "Show",
            "show_all": "Show All",
            "sign_in": "Sign In",
            "solve": "Solve",
            "start": "Start",
            "stop": "Stop",
            "submit": "Submit",
            "subscribe": "Subscribe",
            "switch": "Switch",
            "switch_to_role": "Switch To Role",
            "tag": "Tag",
            "tags": "Tags",
            "target_link": {
                "blank": "Open in a new window",
                "parent": "Open in a parent frame",
                "self": "Open in a current window",
                "top": "Open in the topmost frame"
            },
            "translate": "Translate",
            "translate_it": "Translate It",
            "unpack": "Unpack",
            "unsubscribe": "Unsubscribe",
            "up": "Up",
            "update": "Update",
            "user": "User",
            "view": "View",
            "yes": "Yes",
            "filters": "Filters",
            "apply": "Apply",
            "empty": "Empty",
            "reset": "Reset",
            "set": "Set",
            "zero": "Zero",
            "clear": "Clear",
            "confirm_selected": "Confirm Selected",
            "import_csv": "Import CSV",
            "confirming_picking": "Creating/updating picking in progress"
        },
        "rp": {
            "import": {
                "button": "Import CSV/XLSX",
                "title": "CSV/XLSX Import",
                "steps": {
                    "upload": "Upload",
                    "mapping": "Mapping",
                    "validation": "Validation",
                    "confirm": "Confirm"
                },
                "common": {
                    "next": "Next",
                    "back": "Back",
                    "thousandsNone": "None"
                },
                "types": {
                    "text": "Text",
                    "number": "Number",
                    "date": "Date",
                    "select": "Select",
                    "magoquery": "Mago Query",
                    "portalquery": "Portal Query"
                },
                "lookupModes": {
                    "value": "Code/value",
                    "label": "Description",
                    "value_or_label": "Code first, then description"
                },
                "upload": {
                    "dropHint": "Select a .csv or .xlsx file to import",
                    "selectFile": "Select file",
                    "fileName": "File name",
                    "fileSize": "Size",
                    "rowsCount": "Rows",
                    "headers": "Columns",
                    "preview": "Preview (first 10 rows)",
                    "invalidExtension": "Unsupported format. Only .csv and .xlsx files are allowed.",
                    "tooLarge": "The file exceeds the maximum size of {max} MB.",
                    "empty": "The file contains no rows."
                },
                "mapping": {
                    "field": "Registry field",
                    "type": "Type",
                    "required": "Required",
                    "sourceColumn": "File column",
                    "interpretation": "Interpretation",
                    "selectColumn": "Select column",
                    "doNotImport": "Do not import",
                    "requiredNotMapped": "Required field: mapping needed.",
                    "decimalSeparator": "Decimal separator",
                    "thousandsSeparator": "Thousands separator",
                    "dateFormat": "Source date format",
                    "allowedOptions": "Allowed options",
                    "recognizeBoolean": "Recognize yes/no synonyms",
                    "lookupMode": "Look up value as"
                },
                "validation": {
                    "running": "Validating…",
                    "total": "Total rows",
                    "valid": "Valid rows",
                    "invalid": "Invalid rows",
                    "errorsTable": "Errors",
                    "rowNumber": "Row",
                    "field": "Field",
                    "sourceColumn": "Source column",
                    "originalValue": "Original value",
                    "message": "Message",
                    "noErrors": "No errors detected.",
                    "blocked": "There are invalid rows: fix the file or the mapping to proceed."
                },
                "confirm": {
                    "registry": "Target registry",
                    "file": "File",
                    "rowsToImport": "Rows to import",
                    "atomicWarning": "The operation is atomic: if a single row is invalid, no record will be inserted.",
                    "import": "Import records",
                    "importing": "Importing…",
                    "success": "Import completed: {count} records created.",
                    "backToRegistry": "Back to registry"
                },
                "errors": {
                    "generic": "Unable to read the file.",
                    "http": "An error occurred while communicating with the server."
                }
            }
        },
        "validation": {
            "accepted": "The {attribute} field must be accepted.",
            "accepted_if": "The {attribute} field must be accepted when {other} is {value}.",
            "active_url": "The {attribute} field must be a valid URL.",
            "after": "The {attribute} field must be a date after {date}.",
            "after_or_equal": "The {attribute} field must be a date after or equal to {date}.",
            "alpha": "The {attribute} field must only contain letters.",
            "alpha_dash": "The {attribute} field must only contain letters, numbers, dashes, and underscores.",
            "alpha_num": "The {attribute} field must only contain letters and numbers.",
            "array": "The {attribute} field must be an array.",
            "ascii": "The {attribute} field must only contain single-byte alphanumeric characters and symbols.",
            "before": "The {attribute} field must be a date before {date}.",
            "before_or_equal": "The {attribute} field must be a date before or equal to {date}.",
            "between": {
                "array": "The {attribute} field must have between {min} and {max} items.",
                "file": "The {attribute} field must be between {min} and {max} kilobytes.",
                "numeric": "The {attribute} field must be between {min} and {max}.",
                "string": "The {attribute} field must be between {min} and {max} characters."
            },
            "boolean": "The {attribute} field must be true or false.",
            "can": "The {attribute} field contains an unauthorized value.",
            "confirmed": "The {attribute} field confirmation does not match.",
            "contains": "The {attribute} field is missing a required value.",
            "current_password": "The password is incorrect.",
            "date": "The {attribute} field must be a valid date.",
            "date_equals": "The {attribute} field must be a date equal to {date}.",
            "date_format": "The {attribute} field must match the format {format}.",
            "decimal": "The {attribute} field must have {decimal} decimal places.",
            "declined": "The {attribute} field must be declined.",
            "declined_if": "The {attribute} field must be declined when {other} is {value}.",
            "different": "The {attribute} field and {other} must be different.",
            "digits": "The {attribute} field must be {digits} digits.",
            "digits_between": "The {attribute} field must be between {min} and {max} digits.",
            "dimensions": "The {attribute} field has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "doesnt_end_with": "The {attribute} field must not end with one of the following: {values}.",
            "doesnt_start_with": "The {attribute} field must not start with one of the following: {values}.",
            "email": "The {attribute} field must be a valid email address.",
            "ends_with": "The {attribute} field must end with one of the following: {values}.",
            "enum": "The selected {attribute} is invalid.",
            "exists": "The selected {attribute} is invalid.",
            "extensions": "The {attribute} field must have one of the following extensions: {values}.",
            "file": "The {attribute} field must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "array": "The {attribute} field must have more than {value} items.",
                "file": "The {attribute} field must be greater than {value} kilobytes.",
                "numeric": "The {attribute} field must be greater than {value}.",
                "string": "The {attribute} field must be greater than {value} characters."
            },
            "gte": {
                "array": "The {attribute} field must have {value} items or more.",
                "file": "The {attribute} field must be greater than or equal to {value} kilobytes.",
                "numeric": "The {attribute} field must be greater than or equal to {value}.",
                "string": "The {attribute} field must be greater than or equal to {value} characters."
            },
            "hex_color": "The {attribute} field must be a valid hexadecimal color.",
            "image": "The {attribute} field must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field must exist in {other}.",
            "integer": "The {attribute} field must be an integer.",
            "ip": "The {attribute} field must be a valid IP address.",
            "ipv4": "The {attribute} field must be a valid IPv4 address.",
            "ipv6": "The {attribute} field must be a valid IPv6 address.",
            "json": "The {attribute} field must be a valid JSON string.",
            "list": "The {attribute} field must be a list.",
            "lowercase": "The {attribute} field must be lowercase.",
            "lt": {
                "array": "The {attribute} field must have less than {value} items.",
                "file": "The {attribute} field must be less than {value} kilobytes.",
                "numeric": "The {attribute} field must be less than {value}.",
                "string": "The {attribute} field must be less than {value} characters."
            },
            "lte": {
                "array": "The {attribute} field must not have more than {value} items.",
                "file": "The {attribute} field must be less than or equal to {value} kilobytes.",
                "numeric": "The {attribute} field must be less than or equal to {value}.",
                "string": "The {attribute} field must be less than or equal to {value} characters."
            },
            "mac_address": "The {attribute} field must be a valid MAC address.",
            "max": {
                "array": "The {attribute} field must not have more than {max} items.",
                "file": "The {attribute} field must not be greater than {max} kilobytes.",
                "numeric": "The {attribute} field must not be greater than {max}.",
                "string": "The {attribute} field must not be greater than {max} characters."
            },
            "max_digits": "The {attribute} field must not have more than {max} digits.",
            "mimes": "The {attribute} field must be a file of type: {values}.",
            "mimetypes": "The {attribute} field must be a file of type: {values}.",
            "min": {
                "array": "The {attribute} field must have at least {min} items.",
                "file": "The {attribute} field must be at least {min} kilobytes.",
                "numeric": "The {attribute} field must be at least {min}.",
                "string": "The {attribute} field must be at least {min} characters."
            },
            "min_digits": "The {attribute} field must have at least {min} digits.",
            "missing": "The {attribute} field must be missing.",
            "missing_if": "The {attribute} field must be missing when {other} is {value}.",
            "missing_unless": "The {attribute} field must be missing unless {other} is {value}.",
            "missing_with": "The {attribute} field must be missing when {values} is present.",
            "missing_with_all": "The {attribute} field must be missing when {values} are present.",
            "multiple_of": "The {attribute} field must be a multiple of {value}.",
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} field format is invalid.",
            "numeric": "The {attribute} field must be a number.",
            "password": {
                "letters": "The {attribute} field must contain at least one letter.",
                "mixed": "The {attribute} field must contain at least one uppercase and one lowercase letter.",
                "numbers": "The {attribute} field must contain at least one number.",
                "symbols": "The {attribute} field must contain at least one symbol.",
                "uncompromised": "The given {attribute} has appeared in a data leak. Please choose a different {attribute}."
            },
            "present": "The {attribute} field must be present.",
            "present_if": "The {attribute} field must be present when {other} is {value}.",
            "present_unless": "The {attribute} field must be present unless {other} is {value}.",
            "present_with": "The {attribute} field must be present when {values} is present.",
            "present_with_all": "The {attribute} field must be present when {values} are present.",
            "prohibited": "The {attribute} field is prohibited.",
            "prohibited_if": "The {attribute} field is prohibited when {other} is {value}.",
            "prohibited_if_accepted": "The {attribute} field is prohibited when {other} is accepted.",
            "prohibited_if_declined": "The {attribute} field is prohibited when {other} is declined.",
            "prohibited_unless": "The {attribute} field is prohibited unless {other} is in {values}.",
            "prohibits": "The {attribute} field prohibits {other} from being present.",
            "regex": "The {attribute} field format is invalid.",
            "required": "The {attribute} field is required.",
            "required_array_keys": "The {attribute} field must contain entries for: {values}.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_if_accepted": "The {attribute} field is required when {other} is accepted.",
            "required_if_declined": "The {attribute} field is required when {other} is declined.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} field must match {other}.",
            "size": {
                "array": "The {attribute} field must contain {size} items.",
                "file": "The {attribute} field must be {size} kilobytes.",
                "numeric": "The {attribute} field must be {size}.",
                "string": "The {attribute} field must be {size} characters."
            },
            "starts_with": "The {attribute} field must start with one of the following: {values}.",
            "string": "The {attribute} field must be a string.",
            "timezone": "The {attribute} field must be a valid timezone.",
            "ulid": "The {attribute} field must be a valid ULID.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "uppercase": "The {attribute} field must be uppercase.",
            "url": "The {attribute} field must be a valid URL.",
            "uuid": "The {attribute} field must be a valid UUID.",
            "attributes": {
                "address": "address",
                "affiliate_url": "affiliate URL",
                "age": "age",
                "amount": "amount",
                "announcement": "announcement",
                "area": "area",
                "audience_prize": "audience prize",
                "audience_winner": "audience winner",
                "available": "available",
                "birthday": "birthday",
                "body": "body",
                "city": "city",
                "company": "company",
                "compilation": "compilation",
                "concept": "concept",
                "conditions": "conditions",
                "content": "content",
                "contest": "contest",
                "country": "country",
                "cover": "cover",
                "created_at": "created at",
                "creator": "creator",
                "currency": "currency",
                "current_password": "current password",
                "customer": "customer",
                "date": "date",
                "date_of_birth": "date of birth",
                "dates": "dates",
                "day": "day",
                "deleted_at": "deleted at",
                "description": "description",
                "display_type": "display type",
                "district": "district",
                "duration": "duration",
                "email": "email",
                "excerpt": "excerpt",
                "filter": "filter",
                "finished_at": "finished at",
                "first_name": "first name",
                "gender": "gender",
                "grand_prize": "grand prize",
                "group": "group",
                "hour": "hour",
                "image": "image",
                "image_desktop": "desktop image",
                "image_main": "main image",
                "image_mobile": "mobile image",
                "images": "images",
                "is_audience_winner": "is audience winner",
                "is_hidden": "is hidden",
                "is_subscribed": "is subscribed",
                "is_visible": "is visible",
                "is_winner": "is winner",
                "items": "items",
                "key": "key",
                "last_name": "last name",
                "lesson": "lesson",
                "line_address_1": "line address 1",
                "line_address_2": "line address 2",
                "login": "login",
                "message": "message",
                "middle_name": "middle name",
                "minute": "minute",
                "mobile": "mobile",
                "month": "month",
                "name": "name",
                "national_code": "national code",
                "number": "number",
                "password": "password",
                "password_confirmation": "password confirmation",
                "phone": "phone",
                "photo": "photo",
                "portfolio": "portfolio",
                "postal_code": "postal code",
                "preview": "preview",
                "price": "price",
                "product_id": "product ID",
                "product_uid": "product UID",
                "product_uuid": "product UUID",
                "promo_code": "promo code",
                "province": "province",
                "quantity": "quantity",
                "reason": "reason",
                "recaptcha_response_field": "recaptcha response field",
                "referee": "referee",
                "referees": "referees",
                "reject_reason": "reject reason",
                "remember": "remember",
                "restored_at": "restored at",
                "result_text_under_image": "result text under image",
                "role": "role",
                "rule": "rule",
                "rules": "rules",
                "second": "second",
                "sex": "sex",
                "shipment": "shipment",
                "short_text": "short text",
                "size": "size",
                "skills": "skills",
                "slug": "slug",
                "specialization": "specialization",
                "started_at": "started at",
                "state": "state",
                "status": "status",
                "street": "street",
                "student": "student",
                "subject": "subject",
                "tag": "tag",
                "tags": "tags",
                "teacher": "teacher",
                "terms": "terms",
                "test_description": "test description",
                "test_locale": "test locale",
                "test_name": "test name",
                "text": "text",
                "time": "time",
                "title": "title",
                "type": "type",
                "updated_at": "updated at",
                "user": "user",
                "username": "username",
                "value": "value",
                "winner": "winner",
                "work": "work",
                "year": "year"
            }
        },
        "an": {
            "breadcrumb": {
                "anagrafiche": "Master data",
                "clienti_fornitori": "Customers and suppliers",
                "contatti": "Contacts"
            },
            "fields": {
                "id": "ID",
                "company_name": "Company name",
                "city": "City",
                "address": "Address",
                "zip_code": "ZIP code",
                "county": "Province",
                "country": "Country",
                "latitude": "Latitude",
                "longitude": "Longitude",
                "phone1": "Phone 1",
                "phone2": "Phone 2",
                "phone": "Phone",
                "email_certified": "Certified email",
                "vat": "VAT number",
                "fiscal_code": "Tax code",
                "sdi_code": "SDI code",
                "abi": "ABI",
                "cab": "CAB",
                "bank": "Bank",
                "payment": "Payment",
                "typical_discount": "Typical discount",
                "account": "Account",
                "agent": "Agent",
                "type": "Type",
                "customer_notes": "Customer notes",
                "actions": "Actions",
                "contact": "Contact"
            },
            "actions": {
                "choose_agent": "Select agent",
                "update": "Update",
                "add": "Add",
                "close": "Close",
                "edit": "Edit",
                "details": "Details",
                "sites": "Sites",
                "select_type": "Select type",
                "searching": "🔍 Searching...",
                "start_typing": "Start typing..."
            },
            "gestione_clienti_fornitori": {
                "add_button": "Add record",
                "search_placeholder": "Search code/company name",
                "customers": "Customers",
                "suppliers": "Suppliers",
                "modal_edit_title": "Edit Customer/Supplier",
                "modal_add_title": "Add Customer/Supplier",
                "sites_of": "Sites of",
                "no_sites": "No sites found"
            },
            "gestione_contatti": {
                "add_button": "Add Contact",
                "search_placeholder": "Search code/company name",
                "modal_edit_title": "Edit Contact",
                "modal_add_title": "Add Contact"
            },
            "parameters": {
                "filter_entries_by_agent_label": "Filter entries by agent",
                "filter_entries_by_agent_description": "If enabled, only entries associated with the agent linked to the logged-in account will be shown",
                "electronic_invoicing_label": "Electronic invoicing",
                "electronic_invoicing_description": "If enabled, customers are created with the ElectronicInvoicing field set to 1, otherwise 0"
            },
            "validation": {
                "custsupptype_required": "The customer/supplier type is required.",
                "taxid_already_exists": "The provided VAT number is already present.",
                "company_name_required": "The company name is required."
            },
            "messages": {
                "client_supplier_added": "Customer/Supplier added successfully.",
                "contact_added": "Contact added successfully."
            }
        },
        "pv": {
            "breadcrumb": {
                "percorsi_vettori": "Carrier Routes",
                "gestione_itinerari": "Saved Routes",
                "generazione_itinerari": "Create Route",
                "confronto_stradari": "Address Comparison"
            },
            "parameters": {
                "group_by_companyName_and_address_label": "Group by",
                "group_by_companyName_and_address_description": "Group stops by delivery address (CompanyName + Address) instead of by single address.",
                "custom_carriers_label": "Custom carriers",
                "custom_carriers_description": "If enabled, only shows carriers with the \"Custom\" flag checked in MAGO",
                "usa_categoria_cliente_label": "Use customer category",
                "usa_categoria_cliente_description": "If set, displays branch code only for customers belonging to this category"
            },
            "flash": {
                "travel_saved": "Route saved successfully!",
                "travel_save_error": "Error while saving: ",
                "travel_updated": "Route updated successfully!",
                "travel_update_error": "Error while updating: ",
                "travel_deleted": "Itinerary deleted successfully.",
                "travel_delete_error": "Error while deleting: ",
                "address_not_available": "Address not available for this branch",
                "error_missing_carrier": "Unable to generate the route: the following orders do not have an assigned carrier: {orders}.",
                "error_no_trips_found_for_orders": "No trips found for the selected orders: please check that they have already been shipped/invoiced.",
                "error_orders_not_found": "No picking document found for the following orders: {orders}. Please check that they have already been shipped/invoiced.",
                "error_multiple_carriers": "Unable to generate the route: the selected orders are associated with different carriers ({carriers}). Please select orders with the same carrier."
            },
            "confronto_headers": {
                "code": "Code",
                "company_name": "Company Name",
                "status": "Status"
            },
            "csv_headers": {
                "stop": "Stop",
                "company_name": "Company Name",
                "customer_code": "Customer Code",
                "address": "Address",
                "doc_num": "Doc No.",
                "doc_type": "Doc Type",
                "packages": "Packages",
                "rimes": "Returns",
                "mdp": "PoP",
                "notes": "Notes",
                "warnings": "Warnings",
                "departure": "DEPARTURE",
                "arrival": "ARRIVAL"
            },
            "shared": {
                "add_waypoint": "Add Stop",
                "search_address_placeholder": "Search address...",
                "delete_waypoint_title": "Delete stop",
                "options": "Options",
                "avoid_tolls": "Avoid Tolls",
                "avoid_highways": "Avoid Highways",
                "avoid_ferries": "Avoid Ferries",
                "distance_label": "Distance:",
                "duration_label": "Duration:",
                "saving": "Saving...",
                "calculating": "Calculating...",
                "geocode_failed": "Geocoding failed: ",
                "new_waypoint": "New Stop",
                "departure": "Departure",
                "arrival": "Arrival"
            },
            "confronto": {
                "title": "Address comparison",
                "verify_page_button": "Verify all addresses on the page",
                "verifying_in_progress": "Verification in progress…",
                "th_branch": "Branch",
                "th_registered_address": "Registered Address",
                "th_google_address": "Google Address",
                "th_status": "Status",
                "main_branch": "★ Main Office",
                "branch_label": "Branch",
                "address_not_found": "Address not found on Google",
                "partial_match": "(partial match)",
                "verification_failed": "verification failed",
                "error_prefix": "Error:",
                "to_verify": "To verify…",
                "verify": "Verify",
                "verify_all_branches": "Verify all branches",
                "no_secondary_branches": "No secondary branches",
                "unknown_error": "Unknown error",
                "badge_ok": "✓ OK",
                "badge_partial": "~ Partial",
                "badge_mismatch": "✗ Different",
                "badge_not_found": "∅ Not found",
                "badge_error": "! Error",
                "badge_to_verify": "To verify",
                "badge_global_to_verify": "⏳ To verify",
                "badge_global_verified": "🔄 {done}/{total} verified",
                "badge_global_all_ok": "✓ All OK ({total})",
                "badge_global_discrepancies": "⚠ {issues}/{total} discrepancies",
                "label_via": "Street",
                "label_cap": "ZIP",
                "label_city": "City",
                "label_county": "County",
                "label_country": "Country"
            },
            "gestione": {
                "history_title": "Itinerary History",
                "page_summary": "Page {current} of {last} — {total} total itineraries",
                "previous": "← Previous",
                "next": "Next →",
                "field_date": "Date",
                "field_travel_name": "Trip Name",
                "field_distance_stops": "Distance / Stops",
                "custom_options_active": "Custom options active",
                "carrier_label": "Carrier:",
                "route_config_label": "Route Configuration:",
                "tag_optimized": "Optimized",
                "tag_no_tolls": "No Tolls",
                "tag_no_highways": "No Highways",
                "tag_no_ferries": "No Ferries",
                "standard_options": "Standard options",
                "stops_detail": "Stops Detail:",
                "packages_short": "Packages:",
                "btn_edit_route": "Edit Route",
                "btn_print": "Print",
                "btn_delete_route": "Delete Route",
                "btn_export_excel": "Export Excel",
                "no_saved_itineraries": "No saved itineraries found.",
                "modal_edit_route_title": "Edit Route",
                "modal_route_stops": "Route Stops",
                "avoid_pedaggi_short": "Avoid Tolls",
                "avoid_highways_short": "Avoid Highways",
                "avoid_ferries_short": "Avoid Ferries",
                "travel_data": "Trip Data",
                "btn_optimize": "Optimize",
                "btn_recalculate": "Recalculate",
                "btn_save_itinerary": "Save Itinerary",
                "confirm_delete": "Are you sure you want to delete the itinerary \"{name}\"? This action is irreversible.",
                "delete_error": "Error while deleting the itinerary.",
                "recalc_before_save": "Recalculate before saving.",
                "no_route_data": "No route data available. Recalculate the route before saving.",
                "save_error": "Save error.",
                "confirm_remove_grouped_docs": "This stop contains {count} grouped documents ({name}). Remove the stop and all associated documents?"
            },
            "generazione": {
                "header_title": "TRIP TABLE",
                "travel_of": "Trip of",
                "travel_until": "to",
                "driver_label": "DRIVER / NAME:",
                "notes_label": "NOTES:",
                "total_distance": "Total Distance",
                "expected_time": "Expected Time",
                "route_configuration": "Route Configuration",
                "tag_avoid_tolls": "Avoid Tolls",
                "tag_avoid_highways": "Avoid Highways",
                "tag_avoid_ferries": "Avoid Ferries",
                "tag_tolls_allowed": "Tolls Allowed",
                "tag_highways_allowed": "Highways Allowed",
                "tag_ferries_allowed": "Ferries Allowed",
                "btn_route": "Route",
                "btn_print": "Print",
                "btn_export_excel": "Export Excel",
                "btn_new": "New",
                "btn_reload": "Reload",
                "departure_point": "Departure Point",
                "add_custom_address": "+ Add custom address",
                "add_departure_address": "Add departure address",
                "search_google_placeholder": "Search address on Google...",
                "arrival_point": "Arrival Point",
                "add_arrival_address": "Add arrival address",
                "route_name_label": "Route Name (Optional)",
                "route_name_placeholder": "Example: North Delivery Tour, Test Trip...",
                "qr_waiting": "QR Code waiting for the route",
                "merge_same_address": "Merge stops with the same address",
                "loading_trips": "Loading trips...",
                "th_n": "No.",
                "th_company_name": "Company Name",
                "th_shipping_address": "Shipping Address",
                "th_doc_num": "Doc No.",
                "th_warnings": "Warnings",
                "th_nc": "P.C.",
                "th_rimes": "Returns",
                "th_mdp": "PoP",
                "row_partenza_prefix": "DEPARTURE:",
                "row_arrivo_prefix": "ARRIVAL:",
                "tag_manual": "MANUAL",
                "no_trips_found": "No trips found for the selected criteria.",
                "select_carrier_period": "Select a carrier and a period",
                "modal_title": "Select Carrier and Period",
                "carrier_label": "Carrier",
                "carrier_placeholder": "Select a carrier...",
                "search_mode": "Search Mode",
                "single_date": "Single Date",
                "date_range": "Date Range",
                "select_date": "Select Date",
                "select_dates": "Select Dates",
                "date_from": "From",
                "date_to": "To",
                "btn_search_trips": "Search Trips",
                "route_editor_title": "Edit Route",
                "stops_count": "Stops",
                "saving_in_progress": "Saving in progress...",
                "route_calculating": "Calculating route...",
                "option_avoid_tolls_desc": "Routes without highways",
                "option_avoid_highways_desc": "State, provincial or municipal roads. Also avoids free highways",
                "option_avoid_ferries_desc": "Land routes only",
                "btn_optimize_route": "Optimize Route",
                "btn_calculate_route": "🔄 Calculate Route",
                "route_info_title": "📊 Information",
                "distance_label": "Distance:",
                "duration_label": "Duration:",
                "btn_save_route": "✓ Save Route",
                "route_error_min_stops": "At least 2 stops required",
                "route_error_maps_not_init": "Google Maps not initialized",
                "route_error_origin_dest_missing": "Departure or arrival point missing",
                "route_error_calc_prefix": "Route calculation error: ",
                "route_error_generic_prefix": "Error: ",
                "fetch_error_default": "Error loading trips. Please try again.",
                "partenza_marker_title": "Departure",
                "arrivo_marker_title": "Arrival",
                "stop_marker_title": "Stop {index}: {name}",
                "alert_select_address_from_suggestions": "Select an address from the suggestions",
                "alert_select_from_google_suggestions": "Please select an address from the Google suggestions.",
                "alert_no_geometry": "The selected address does not contain geographic coordinates.",
                "alert_calc_route_first": "Calculate the route on the map before saving.",
                "alert_save_before_export": "Save the route before exporting.",
                "alert_route_save_default_error": "Error while saving the route.",
                "alert_route_saved": "Route saved successfully!",
                "manual_waypoint_note": "Manually added stop",
                "default_travel_name": "Carrier {carrier} - Route of {date}",
                "confirm_remove_grouped_docs": "This stop contains {count} grouped documents ({name}). Remove the stop and all associated documents?",
                "label_sede_legale": "Headquarters",
                "label_deposito": "Depot",
                "generate_ddt": "Generate DDT",
                "vehicle_selection": "Vehicle Selection"
            }
        },
        "at": {
            "breadcrumb": {
                "pianificazione_attivita": "Activity planning",
                "lista_attivita": "Activity list",
                "lista_ordini": "Order list"
            },
            "fields": {
                "title": "Title",
                "description": "Description",
                "client": "Client",
                "job": "Job",
                "owner": "Assignee",
                "start_date": "Start Date",
                "end_date": "End Date",
                "delivery_date": "Delivery date",
                "priority": "Priority",
                "status": "Status",
                "date": "Date",
                "user": "User",
                "hours": "Hours",
                "total_hours": "Total hours",
                "work_date": "Work date",
                "hours_worked": "Hours worked",
                "work_description": "Description of work performed",
                "order_number": "Order No.",
                "order_date": "Of",
                "actions": "Actions",
                "expected_delivery_date": "Expected delivery"
            },
            "filters": {
                "all_select": "All"
            },
            "actions": {
                "new_activity": "+ New Activity",
                "edit": "Edit",
                "add": "Add",
                "update": "Update",
                "close": "Close",
                "details": "Details",
                "register_time": "Register time",
                "work_details": "Work details",
                "delete": "Delete",
                "cancel": "Cancel",
                "confirm": "Confirm",
                "generate_activities": "Generate activities",
                "add_activity_btn": "+ Add activity",
                "remove_activity": "Remove activity",
                "select_user": "Select a user",
                "searching": "🔍 Searching...",
                "start_typing_client": "Start typing to search for a client..."
            },
            "priority": {
                "bassa": "Low",
                "media": "Medium",
                "alta": "High",
                "critica": "Critical"
            },
            "status": {
                "nuova": "New",
                "assegnata": "Assigned",
                "schedulata": "Scheduled",
                "in_lavorazione": "In Progress",
                "completata": "Completed"
            },
            "messages": {
                "success": "Success",
                "error": "Error",
                "creating": "Creating...",
                "updating": "Updating...",
                "deleting": "Deleting...",
                "registering": "Registering...",
                "activity_created": "Activity successfully created",
                "activity_updated": "Activity successfully updated",
                "activity_deleted": "Activity successfully deleted",
                "error_create": "An error occurred while creating the activity",
                "error_update": "An error occurred while updating the activity",
                "error_delete": "An error occurred while deleting the activity",
                "time_registered_title": "Time registered",
                "creation_completed_title": "Activity creation completed",
                "loading_details": "Loading details...",
                "loading_activities": "Loading activities...",
                "no_time_records": "No time records found for this activity.",
                "activity_not_found": "Activity not found",
                "work_time_registered": "Work time successfully registered"
            },
            "lista_attivita": {
                "title": "Activity List",
                "details_modal_title": "Activity details",
                "edit_modal_title": "Edit activity",
                "add_modal_title": "Add activity",
                "time_modal_title": "Register Work Time",
                "work_details_modal_title": "Work Details",
                "delete_confirm_title": "Confirm Activity Deletion",
                "delete_confirm_text": "Are you sure you want to proceed with the activity deletion?",
                "client_label": "Client:",
                "total_hours_label": "Total hours:",
                "current_total_hours": "Current total hours:",
                "total_registered_hours": "Total registered hours:",
                "hours_placeholder": "E.g. 2.5",
                "work_description_placeholder": "Briefly describe the work performed...",
                "work_date_placeholder": "Select the work date"
            },
            "lista_ordini": {
                "preview_modal_title": "Preview Activities to Create",
                "activities_to_create_prefix": "Will be created",
                "activities_to_create_suffix": "new activities for the selected order",
                "existing_activities_suffix": "activities already exist",
                "invalid_activities_suffix": "invalid activities (missing description)",
                "description_label": "Description:",
                "description_placeholder": "Enter the activity description",
                "description_required": "The description is required",
                "start_date_label": "Start date:",
                "end_date_label": "End date:",
                "delivery_date_label": "Expected delivery:",
                "owner_label": "Assignee:",
                "creating": "Creating...",
                "confirm_creation": "Confirm Creation",
                "activities_created_count_suffix": "activities were created."
            }
        },
        "go": {
            "breadcrumb": {
                "gestione_ordini": "Order Management",
                "lista_ordini": "Order List",
                "lista_proposte_offerte": "Proposals/Quotes List",
                "visualizza_mail": "View Email"
            },
            "doc_status": {
                "order": "Order",
                "offert": "Quote",
                "draft": "Proposal"
            },
            "tabs": {
                "main": "MAIN DATA",
                "document_notes": "DOCUMENT NOTES",
                "shipping": "SHIPPING",
                "charges": "CHARGES"
            },
            "actions": {
                "save_changes": "Save changes",
                "save_changes_unsaved": "⚠️ Save changes",
                "convert_to_offer": "Convert to quote",
                "import_from_offer": "Import from quote",
                "send_to_mago": "Send to Mago",
                "edit_on_mago": "Edit on Mago",
                "customer_signature": "Customer Signature",
                "dms": "DMS",
                "delete": "Delete",
                "cancel": "Cancel",
                "confirm": "Confirm",
                "apply": "Apply",
                "send": "Send",
                "save": "Save",
                "new": "New",
                "open": "Open",
                "continue": "Continue",
                "back_to_orders": "Back to order management",
                "back_to_list": "Back to list",
                "download_eml": "Download .EML",
                "new_order": "New order",
                "open_related_order": "Open related order",
                "clear_signature": "Clear signature",
                "save_signature": "Save signature",
                "load_customer_notes": "Load customer notes",
                "request_approval": "Request Approval",
                "request_correction": "Request Correction",
                "approve_document": "Approve document",
                "reject_document": "Reject document",
                "add_goods": "Add Goods",
                "add_service": "Add Service",
                "add_note": "Add Note",
                "add_descriptive": "Add Descriptive",
                "insert_as_out_of_stock": "Insert as out of stock",
                "no_only_main": "No, main only",
                "yes_include_all": "Yes, include all",
                "print": "Print document",
                "select": "Select",
                "send_mail": "Send Email"
            },
            "fields": {
                "number": "Number",
                "doc_type": "Document type",
                "customer": "Customer",
                "contact": "Contact",
                "date": "Date",
                "validity_end": "Validity End",
                "expected_delivery": "Expected delivery date",
                "mago_order_number": "Mago order number",
                "mago_quota_number": "Mago offer number",
                "customer_order_ref": "Customer Order Ref.",
                "agent": "Agent",
                "customer_discount": "Customer discount",
                "payment": "Payment",
                "priority": "Priority",
                "created_by": "Created by:",
                "last_modified_by": "Last modified by:",
                "document_details": "Document details",
                "row_type": "Row type",
                "item_code": "Item Code",
                "description": "Description",
                "position": "Position",
                "row_status": "Status",
                "pricelist": "Price list",
                "uom": "Unit of Measure",
                "uom_short": "UoM",
                "qty": "Quantity",
                "price": "Price",
                "discount": "Discount",
                "taxable": "Taxable",
                "row_note": "Note",
                "tax_code_col": "VAT Code",
                "row_total": "Row Total",
                "tax_code_full": "VAT Code",
                "tax_amount": "Tax",
                "total": "Total",
                "item_article": "Item",
                "homogeneous_ctg": "Homogeneous Category",
                "commodity_ctg": "Commodity Category",
                "product_ctg": "Product Category",
                "item_type": "Item Type",
                "producer": "Producer",
                "info": "Info",
                "subject": "Subject",
                "sender": "Sender",
                "date_label": "Date",
                "assigned_user": "Assigned user",
                "priority_label": "Priority:",
                "tax_code_iva": "VAT Code",
                "taxable_total": "Total Taxable",
                "vat_percentage": "VAT %",
                "vat_amount": "VAT Amount",
                "row_total_vat": "Row Total (VAT included)",
                "allowances": "Allowance Amount",
                "goods_total": "Goods total",
                "services_total": "Services total",
                "discount_total": "Discount total",
                "vat_total": "Total VAT",
                "document_total": "Document Total",
                "freesample_total": "Free samples total",
                "to_pay": "Total to pay",
                "raee_total": "RAEE total",
                "transport_charges": "Transport charges:",
                "collection_charges": "Collection charges:",
                "accessory_charges": "Accessory charges:",
                "vat_breakdown": "VAT Breakdown",
                "delivery_branch": "Delivery branch",
                "generic_branch": "Generic branch",
                "selected_branch": "Selected branch:",
                "carrier": "First Carrier",
                "select_carrier": "Select carrier",
                "to_determine": "To be determined",
                "select_placeholder": "Select",
                "sale_type": "Sale Type",
                "sale_type_normal": "Normal",
                "sale_type_total_free_sample": "Total free sample",
                "sale_type_taxable_free_sample": "Taxable free sample",
                "none_specified": "None specified",
                "unit_value": "Unit value",
                "net_price": "Net price",
                "extra_discount_default": "Default extra discount:",
                "item_notes": "Item notes",
                "cod_iva_label": "VAT Code:",
                "packages": "Packages",
                "exclude_print": "Exclude from print",
                "exclude_invoice": "Exclude from invoice",
                "exclude_ddt": "Exclude from DDT"
            },
            "line_types": {
                "goods": "Goods",
                "service": "Service",
                "descriptive": "Descriptive",
                "note": "Note"
            },
            "availability": {
                "available": "Available",
                "not_available_with_orders": "Not available with incoming orders",
                "not_available": "Not available",
                "no_info": "Information not available"
            },
            "vat_breakdown": {
                "no_details": "No VAT details available",
                "total_row": "TOTAL"
            },
            "document_notes_placeholder": "Enter document notes (will be included in print and on Mago)",
            "private_note_placeholder": "Enter internal-use notes (will not be included in print)",
            "modals": {
                "confirm_delete_title": "Confirm deletion",
                "confirm_delete_content": "Are you sure you want to delete this document?",
                "confirm_delete_mago_note": "(The corresponding MAGO document {doc_no} will also be deleted.)",
                "confirm_delete_mago_quota_note": "(The corresponding MAGO offer {doc_no} will also be deleted.)",
                "confirm_delete_row_title": "Confirm row deletion",
                "confirm_delete_row_content": "Are you sure you want to delete this row? Changes will only be applied when saving the document.",
                "confirm_signature_title": "Confirm signature registration",
                "confirm_signature_content": "Are you sure you want to register the signature? This will block any future changes to the document.",
                "min_reorder_qty_title": "Minimum reorder quantity",
                "min_reorder_qty_content": "The selected quantity exceeds total availability. This item has a minimum supplier reorder quantity of {qty}, do you want to continue?",
                "email_addresses_title": "Email Address Selection",
                "email_addresses_content": "Do you also want to include the email addresses of the contact persons linked to the customer?",
                "confirm_delete_mail_title": "Confirm email deletion",
                "confirm_delete_mail_content": "Are you sure you want to delete this email?",
                "detail_modal_title": "Row detail",
                "out_of_stock_label": "out of stock",
                "select_goods": "goods",
                "select_service": "service",
                "select_article": "item",
                "select_kit_component": "kit component",
                "customer_notes_title": "Customer Notes:",
                "internal_notes": "Internal use notes",
                "internal_notes_2": "Internal notes",
                "other_notes": "Other notes",
                "no_customer_notes": "No notes found for this customer.",
                "dms_attachments": "DMS Attachments",
                "attachment_label": "° Attachment",
                "email_send_title": "Send Email",
                "to_placeholder": "Recipients",
                "cc_placeholder": "Add to CC (separated by semicolon)",
                "subject_placeholder": "Subject",
                "body_placeholder": "Message text...",
                "document_locked_title": "Document in use",
                "document_locked_content": "This document is currently open by {user}. You cannot edit it until the other user closes it.",
                "document_locked_force_title": "Document in use by another user",
                "document_locked_force_content": "The document is open by {user}. Do you want to force access? The other user will be expelled.",
                "document_force_access": "Force access",
                "document_view_readonly": "View in read-only mode",
                "document_kicked_title": "Session terminated",
                "document_kicked_content": "An administrator has forced access to this document. You will be redirected to the list."
            },
            "deep_tables": {
                "select_payment": "Select Payment",
                "select_customer": "Select Customer",
                "select_contact": "Select Contact",
                "select_homogeneous_ctg": "Select Homogeneous Category",
                "select_commodity_ctg": "Select Commodity Category",
                "select_product_ctg": "Select Product Category",
                "select_producer": "Select Producer",
                "select_tax_code": "Select VAT Code",
                "select_collection_tax_code": "Select VAT Code for collection charges",
                "select_offer": "Select Quote",
                "select_item_type": "Select Item Type",
                "show_disabled": "Show disabled too",
                "use_contacts": "Use Contacts",
                "no_elements": "No elements available"
            },
            "lista_ordini": {
                "title": "Order List",
                "title_drafts": "Proposals/Quotes List",
                "label": "Web order list",
                "label_drafts": "Web proposals/quotes list"
            },
            "lista_mail": {
                "title": "Mail list",
                "show_filter": "Show Mail",
                "new_unread": "New/user",
                "all_active": "All active",
                "mail_detail": "Email Detail",
                "loading": "Loading...",
                "select_email": "Select an email to view it",
                "attachments_title": "Attachments List"
            },
            "messages": {
                "positions_modified": "Positions modified. Remember to save the document.",
                "import_success": "Import completed successfully",
                "import_error": "Error during import",
                "import_data_update_error": "Import completed but error updating data",
                "qty_must_be_positive": "Quantity must be greater than 0",
                "item_already_in_mago": "Item already registered in Mago, change the item code or use Add Goods/Service",
                "validation_error": "Error during custom row validation",
                "uom_required": "Unit of measure must be specified",
                "item_or_desc_required": "Item or description must be specified",
                "row_added": "Row added. Remember to save the document.",
                "changes_applied": "Changes applied. Remember to save the document.",
                "add_cancelled": "Item addition cancelled.",
                "row_removed": "Row removed. Remember to save the document.",
                "doc_deleted": "Document deleted successfully.",
                "delete_error": "Error during deletion",
                "doc_saved": "Document saved successfully",
                "save_error": "Error during save",
                "save_data_error": "Document saved but error updating data",
                "sending_to_mago": "Sending order to Mago...",
                "sending_quote_to_mago": "Sending quote to Mago...",
                "order_sent_to_mago": "Order successfully sent to Mago",
                "offer_sent_to_mago": "Offer successfully sent to Mago",
                "mago_send_error": "Error sending to Mago",
                "mago_data_update_error": "Order sent but error updating data",
                "saving": "Saving...",
                "saving_signature": "Saving signed document to Mago...",
                "signature_saved": "Signature saved successfully to Mago",
                "signature_error": "Error saving signature",
                "updating_prices": "Updating prices...",
                "deleting": "Deleting...",
                "signature_required": "Please complete the signature before saving.",
                "select_customer_before_mail": "Select a customer before sending the email",
                "select_contact_before_mail": "Select a contact before sending the email",
                "fetching_emails": "Fetching email addresses...",
                "generating_pdf": "Generating PDF and sending email...",
                "email_recipient_required": "Please enter at least one recipient",
                "doc_deleted_success": "Document deleted successfully.",
                "doc_not_found": "Document not found.",
                "invalid_doc_id": "Invalid document ID.",
                "loading": "Loading...",
                "unit_value_required": "Unit value must be specified",
                "error_loading_emails": "Error loading emails",
                "error_sending_email": "Error sending email",
                "email_body_template": "Dear customer {companyname},\nPlease find attached the above-mentioned document.\n\nBest regards."
            },
            "headers": {
                "sender": "Sender",
                "subject": "Subject",
                "date": "Date",
                "doc_number": "Number",
                "doc_date": "Date",
                "status": "Status",
                "customer_contact": "Customer/Contact",
                "customer": "Customer",
                "author": "Author",
                "approval": "Approval",
                "sent_to_mago": "Sent to Mago",
                "converted_to_order": "Converted to Order",
                "code": "Code",
                "company_name": "Company Name",
                "address": "Address",
                "zip_code": "ZIP Code",
                "city": "City",
                "county": "County",
                "country": "Country",
                "fiscal_code": "Fiscal Code",
                "email": "Email",
                "phone": "Phone",
                "payment_desc": "Description",
                "discount_pct": "Discount Percentage",
                "collection_charges": "Collection charges",
                "tax_rate": "Tax Rate %",
                "department": "Department",
                "producer": "Producer",
                "product_ctg": "Product Category",
                "item_type": "Item Type",
                "homogeneous_ctg": "Homogeneous Category",
                "commodity_ctg": "Commodity Category",
                "to_approve": "To approve",
                "to_correct": "To correct"
            },
            "approval_status": {
                "not_requested": "Not requested",
                "requested": "Requested",
                "approved": "Approved",
                "rejected": "Rejected"
            },
            "parameters": {
                "email_view_label": "Split View",
                "email_view_description": "Split email/order view",
                "email_send_label": "Email sending",
                "email_send_description": "Enable email sending from portal with attached PDF",
                "copy_docno_to_externalordno_label": "Copy portal document number to ExternalOrdNo",
                "copy_docno_to_externalordno_description": "Write the portal document number to Mago's ExternalOrdNo (ExternalOrderId will be populated regardless)",
                "block_changes_after_mago_sent_label": "Block changes after sending to Mago",
                "block_changes_after_mago_sent_description": "Prevent deletion and modification of document on Mago once sent (do not use together with email or signature management)",
                "filter_customers_by_agent_label": "Filter customers by agent",
                "filter_customers_by_agent_description": "If enabled, only customers associated with the logged-in account's agent will be shown",
                "block_pricelist_change_label": "Block price list change",
                "block_pricelist_change_description": "Prevents changing the price list in order rows",
                "check_available_on_row_insert_label": "Check availability on row creation",
                "check_available_on_row_insert_description": "Check item availability when inserting a new order row if the minimum supplier reorder quantity is > 0",
                "allow_pricerow_zero_label": "Allow zero-price rows",
                "allow_pricerow_zero_description": "Allows inserting rows with unit price of zero which will show \"to be determined\" also in print",
                "use_thousand_separator_label": "Thousands separator",
                "use_thousand_separator_description": "If enabled, document totals are displayed with the thousands separator (e.g. 1,234.56)",
                "handle_signature_label": "Signature management",
                "handle_signature_description": "Enable signature confirmation management for orders (0 disabled, 1 customer only)",
                "show_dms_content_label": "Show DMS contents",
                "show_dms_content_description": "Show documents linked via DMS in the order interface",
                "show_customers_extra_data_label": "Show additional data in customer search",
                "show_customers_extra_data_description": "Show the customer's fiscal code, email and phone number in the order search",
                "show_items_extra_data_label": "Show additional data in item search",
                "show_items_extra_data_description": "Show location, RAEE category and agent commission percentage. 0 = disabled, 1 = location (MA_ItemsGoodsData.Location), 2 = location (MA_ItemsWMSZones.FixedBinPicking)",
                "show_items_notes_label": "Show item notes",
                "show_items_notes_description": "Show item (sales) notes in row detail. Slows down row total calculation, use only if necessary",
                "divide_documents_by_creator_label": "Separate documents by author (admin sees all)",
                "divide_documents_by_creator_description": "If enabled, users will only see documents they created, admins will see all documents",
                "pricelist_imel_label": "IMEL custom price list management",
                "pricelist_imel_description": "If enabled, IMEL-specific price list selection criteria will be used",
                "force_admin_approval_label": "Force admin approval",
                "force_admin_approval_description": "If enabled, orders will require admin approval before they can be sent to Mago",
                "reset_qty_on_uom_change_label": "Reset quantity on unit of measure change",
                "reset_qty_on_uom_change_description": "If enabled, quantity will be reset when the unit of measure is changed",
                "filter_items_by_pricelist_label": "Filter items by price list",
                "filter_items_by_pricelist_description": "If this price list is specified, it is used to filter available items and set as default",
                "show_suggested_price_label": "Show suggested price",
                "show_suggested_price_description": "If enabled, the list price will be shown in the suggested price field in item info",
                "show_pricelist_info_label": "Show item pricelist info",
                "show_pricelist_info_description": "Shows an info button for item pricelists in the order row and item detail panel",
                "personalizzazioni_imel_label": "IMEL customizations",
                "personalizzazioni_imel_description": "Enable or disable IMEL-specific customizations"
            }
        },
        "modules": {
            "anagrafiche": "Personal data",
            "visite-commerciali": "Commercial visits",
            "reception-digitale": "Visitor register",
            "contratti": "Contracts",
            "attivita": "Activities",
            "estratto-conto": "Account statement",
            "gestione-magazzino": "Warehouse management",
            "inventario": "Inventory",
            "ricezione-merce": "Receiving goods from Supplier Order",
            "evasione-ordini": "Order fulfillment",
            "rettifica": "Adjustment",
            "calendario": "Calendar",
            "mappa": "Map",
            "contatti": "Contacts",
            "clienti-fornitori": "Clients and Suppliers",
            "registro": "Register",
            "visitatori-abituali": "Frequent visitors",
            "badge": "Badge",
            "report": "Report",
            "real-time": "Real-time",
            "rinnovo": "Renewal",
            "emissione": "Issuance",
            "ricerca-contratti": "Contract search",
            "nuovo-contratto": "New contract",
            "controllo-copie": "Copy control",
            "report-pacchetti-ore": "Hour package report",
            "lista-ordini": "Order list",
            "lista-attivita": "Activity list",
            "calendario-attivita": "Activity Calendar",
            "gantt-attivita": "Activity Gantt",
            "rapportini-intervento": "Intervention reports",
            "ricezione-veneta": "Receiving goods Veneta",
            "conferma_bolle_carico": "Management of Bills of Lading and Goods Positioning",
            "analisi": "Analysis",
            "ordinato-agente": "Sorted by Agent",
            "fatturato-agente": "Turnover per Agent",
            "generazione-itinerari": "Create Path",
            "gestione-itinerari": "Saved Paths",
            "ricezione-merce-senza-ordine": "Load goods without Supplier Order",
            "rilevazione-commesse": "Job tracking",
            "storico-rilevazioni": "Tracking History",
            "rilevazione-ora-su-commessa": "Job Hours Tracking",
            "info-articoli": "Item Info",
            "gestione-ordini": "Order Management",
            "gestione-modelli-contratti": "Contract Template Management",
            "lista-offerte": "Proposals/Offers List",
            "report-odierno": "Today's Report",
            "report-visite": "Visits Report",
            "report-consegne": "Deliveries Report",
            "sblocco-ingressi": "Entry Unlocking",
            "registro-uscita": "Exit Register",
            "scarico-componenti": "Component Unloading",
            "registri-personalizzati": "Custom Registers",
            "percorsi-vettori": "Carrier Routes",
            "gestione_ubicazioni_icam": "ICAM Location Management",
            "accesso-totem": "Totem Access",
            "commit-in-beta": "Beta Commits",
            "confronto-stradari": "Roadmap Comparison",
            "carica-excel": "Load Excel",
            "associa-barcode": "Associate Barcode",
            "approvazione-bolle-temp": "Approval of Temporary Delivery Notes",
            "registrazione-ticket": "Ticket Registration",
            "gestione-produzione": "Production Management",
            "buono-prelievo": "Picking Slip",
            "consuntiva-produzione": "Production Reporting",
            "resoconto-odp": "Production Orders Report",
            "picking-list": "Picking",
            "reminders-attivita": "Reminders",
            "riconoscimento-documenti": "Document Recognition",
            "simulazione-costificazione": "Cost Simulation",
            "riconoscimento-documenti-ai": "Document Recognition AI",
            "prove-di-consegna": "Proofs of Delivery",
            "affidamenti": "Assignments"
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "password": "The provided password is incorrect.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds.",
            "already_logged_in": "User is already logged in from another device or location.",
            "force_logout_prompt": "Click below to force logout the other session and continue.",
            "force_logout_button": "Force Logout and Continue",
            "too_many_customer_sessions": "Too many concurrent sessions for this customer.",
            "log_in_title": "Log in",
            "email": "Email",
            "password_label": "Password",
            "remember_me": "Remember me",
            "forgot_password": "Forgot your password?",
            "session_already_active": "Session Already Active"
        },
        "customers": {
            "molino-di-borgo": {
                "ui": {
                    "ulteriore_sconto": "Additional Discount"
                }
            }
        },
        "vc": [],
        "passwords": {
            "reset": "Your password has been reset.",
            "sent": "We have emailed your password reset link.",
            "throttled": "Please wait before retrying.",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that email address."
        },
        "sc": {
            "scarico_component_title": "Component Discharge",
            "article": "Article:",
            "description": "Description:",
            "available": "Available:",
            "minimum_stock": "Minimum stock:",
            "quantity_less_than_minimum_stock": "The picked quantity is below minimum stock",
            "lot": "Lot",
            "quantity_picked": "Picked quantity:",
            "enter_barcode_and_select_storage": "Enter a barcode and select a warehouse",
            "item_not_found": "Item not found",
            "search_error": "Search error",
            "product_not_available": "Product not available in warehouse",
            "quantity_reduced_to_max": "Quantity reduced to maximum available",
            "invalid_quantity": "Invalid quantity",
            "quantity_exceeds_availability": "Quantity exceeds availability",
            "discharge_completed": "Discharge completed successfully",
            "discharge_error": "Error during discharge",
            "loading_discharge": "Discharging... ",
            "magiclink_note": "Component discharge - {item}",
            "select_product": "Select Product",
            "multiple_products_found": "Multiple products found. Select the correct one:",
            "csv_preview": "CSV Preview",
            "quantity": "Quantity",
            "confirm_all": "Confirm all",
            "select_storage_first": "Please select a warehouse first",
            "empty_or_invalid_csv": "Empty or invalid CSV",
            "processing_csv": "Processing CSV...",
            "all_items_discharged": "All items successfully discharged",
            "discharge_with_errors": "Completed: {success} success, {errors} errors",
            "csv_data": "CSV Data",
            "not_found": "Not found",
            "found": "Found",
            "no_valid_items": "No valid items to discharge",
            "storage": "Site:",
            "storage_mismatch": "Storage mismatch",
            "lot_mismatch": "Lot mismatch",
            "insufficient_stock": "Insufficient stock",
            "storage_reason_mapping": "Storage - Reason Mapping",
            "movement_reason": "Movement Reason",
            "select_reason": "Select Reason",
            "invalid_csv_format": "Invalid CSV format. The header must have exactly {count} columns in this order: {header}",
            "to_discharge": "to discharge",
            "discharged": "discharged",
            "discharge_with_errors_summary": "Completed {success} out of {total} storages.",
            "missing_reason_for_storage": "Missing reason for storage {storage}",
            "no_items_to_process": "No valid items to process",
            "select_storage_placeholder": "-- Select warehouse --",
            "select_reason_placeholder": "-- Select Reason --",
            "reason_after_first_item_info": "The movement reason can be selected after adding the first item",
            "specificator_customer": "Customer",
            "specificator_supplier": "Supplier",
            "stock_short": "Stock:",
            "stock": "Stock:",
            "duplicate_item_title": "Item already scanned",
            "duplicate_item_message": "You have already scanned this product, do you want to add it again?",
            "pending_items_title": "Items to discharge",
            "discharge_all": "Discharge all",
            "reasons_per_storage": "Reasons per storage",
            "table_storage": "Storage",
            "table_reason": "Reason",
            "header_item": "Item",
            "header_description": "Description",
            "header_lot": "Lot",
            "header_quantity": "Quantity",
            "header_uom": "UoM",
            "csv_header_item": "Item",
            "csv_header_lot_comparison": "Lot (CSV - MAGO)",
            "csv_header_storage_comparison": "Storage (CSV - MAGO)",
            "csv_header_book_inv": "Stock",
            "csv_header_quantity": "Qty to discharge",
            "csv_header_status": "Status",
            "batch_processing_error": "Error during batch processing",
            "error_generic": "Error",
            "discharge_during_error": "Error during discharge",
            "lot_search": "Search by lot",
            "choose_quantity": "Choose quantity",
            "item": "Item",
            "item_or_barcode": "Item or Barcode"
        },
        "ec": {
            "parameters": {
                "force_agent_label": "Force agent",
                "force_agent_description": "If enabled, accounts with an assigned agent will not be able to change the agent on the account statement"
            }
        },
        "ui": {
            "welcome_back": "Welcome back",
            "user_profile": {
                "link_label": "User Profile",
                "profile_information": {
                    "title": "Profile Information",
                    "description": "Update your profile information and email address."
                },
                "password_update": {
                    "title": "Update Password",
                    "description": "Make sure to use a long, random password to stay secure."
                }
            },
            "user_management": "User Management",
            "customer_management": "Customer management",
            "customer_overview": "Customers Overview",
            "current_password": "Current Password",
            "new_password": "New Password",
            "confirm_password": "Confirm Password",
            "proceed": "Proceed",
            "name": "Name",
            "email": "Email",
            "choose_date": "Choose Date",
            "choose_expired": "Expiration Date",
            "delete_confirmation": {
                "title": "Confirm Deletion",
                "description": "Are you sure you want to delete this item? This action cannot be undone."
            },
            "cancel": "Cancel",
            "delete": "Delete",
            "filters": "Filters",
            "all_filters": "All filters",
            "change_customer": "Change Customer",
            "ui_policy": "UI Policy",
            "loading": "Loading...",
            "order_management": "Order management",
            "item_info": {
                "title": "Item Info",
                "loading": "Loading item data...",
                "general_data": "General Data",
                "warehouse_status": "Warehouse Status",
                "item_code": "Item",
                "description": "Description",
                "uom": "Unit of Measure",
                "homogeneous_ctg": "Homogeneous Category",
                "commodity_ctg": "Commodity Category",
                "item_type": "Item Type",
                "tax_code": "Tax Code",
                "base_price": "Base Price",
                "sale_bar_code": "Sales Barcode",
                "internal_note": "Internal Notes",
                "stock": "Stock",
                "availability": "Availability",
                "ordered_purch": "Ordered from Supplier",
                "reserved_sale_ord": "Reserved for Customer Orders",
                "reserved_by_prod": "Reserved for Production",
                "ordered_to_prod": "Quantity in Production",
                "theoretical_availability": "Theoretical Availability",
                "minimum_sale_qty": "Min Sale Quantity",
                "min_order_qty": "Min Supplier Reorder Qty",
                "expected_arrival_date": "Expected Arrival Date",
                "suggested_price": "Suggested Price",
                "no_data": "No data found for item {item}.",
                "pricelist_section_title": "Item Pricelists",
                "pricelist_loading": "Loading pricelists...",
                "pricelist_code": "Pricelist",
                "pricelist_qty": "Max Qty",
                "pricelist_price": "Price",
                "pricelist_uom": "UoM",
                "pricelist_discount": "Discount",
                "pricelist_no_data": "No pricelists found for this item.",
                "last_sale_value": "Customer last sale price",
                "never_sold_to_customer": "Item never sold to this customer"
            },
            "out_of_inventory": "Out of Stock",
            "loader": {
                "default_text": "Loading...",
                "subtitle": "Please wait"
            },
            "modal_message": {
                "close": "Close"
            },
            "notification": {
                "close": "Close"
            },
            "client_selector_modal": {
                "select_client": "Select client",
                "active_filter": "Active filter:",
                "remove_filter": "Remove filter",
                "choose_client_title": "Choose Client",
                "search_placeholder": "Search client...",
                "all_clients": "All clients",
                "no_clients_found": "No client found for \"{query}\"",
                "close": "Close"
            },
            "richiesta_assistenza": {
                "title_it": "Richiesta assistenza",
                "title_en": "Assistance request",
                "sure_it": "Sei sicuro di voler contattare l'assistenza?",
                "sure_en": "Are you sure you want to contact support?",
                "cancel_it": "Annulla",
                "cancel_en": "Cancel",
                "confirm_it": "Conferma",
                "confirm_en": "Confirm",
                "sending_it": "Invio in corso...",
                "sending_en": "Sending...",
                "error_alert": "An error occurred. Please try again later."
            },
            "emergency_info_modal": {
                "title": "Information for Guests",
                "understood": "I understand"
            },
            "tables": {
                "select_default": "Select",
                "all": "All",
                "filter_input_placeholder": "🔎︎ Filter",
                "sort_by": "Sort by",
                "ascending": "Ascending",
                "descending": "Descending",
                "no_sort": "No sorting"
            }
        },
        "gm": {
            "scan_barcode_to_increment": "Scan the barcode to increase the amount of received",
            "reception_data": "Reception data",
            "confirm_mismatched_quantities": "Confirm mismatched quantities",
            "confirm_mismatched_quantities_description": "Some rows have a total quantity (registered + to be registered) different from the order quantity.Do you want to continue anyway?",
            "item_not_found_or_already_pickedup": "Item {item} not found or already picked up in the list of these orders",
            "barcode_mismatched": "Barcode mismatch",
            "normal": "Normal",
            "descriptive": "Descriptive",
            "kitchen": "Cucina",
            "enter_the_quantity_to_be_shipped": "Enter the quantity to be shipped of",
            "warehouse_choice": "Warehouse choice",
            "add_selected_items": "Add selected items",
            "insert_qty": "Insert quantity",
            "insert_qty_for": "Insert quantity for",
            "article_details": "Article details",
            "select_inventory_session": "Select the inventory session",
            "choose_session": "Choose a session",
            "created_by": "Created by",
            "deposit": "Deposit",
            "delete_session": "Delete session",
            "create_new_inventory_session": "Create new inventory session",
            "choose_a_warehouse": "Choose a warehouse",
            "confirm_session_deletion": "Confirm session deletion",
            "confirm_session_deletion_confirm": "Are you sure you want to delete this inventory session? This action is irreversible.",
            "confirm_inventory": "Confirm inventory",
            "confirm_inventory_confirmation": "Do you want to confirm and close this inventory session? It will no longer be editable.",
            "list_supplier_orders": "List supplier orders",
            "list_client_orders": "List client orders",
            "orphan_picking": "Picking without order",
            "picking_rows": "Picking rows",
            "select_same_customer_orders": "Please select orders from the same customer.",
            "already_in_picking": "Already in picking",
            "open_picking_overview": "Open picking for this customer",
            "open_picking_overview_desc": "Document no. {docno} with {count} items, of which {other} from other orders of the same customer.",
            "other_order": "Other order",
            "confirm_picking": "Confirm Picking",
            "no_qty_to_confirm": "Please enter a quantity to pick for at least one row.",
            "customer_not_found": "Customer not found.",
            "picking_confirm_error": "An error occurred while confirming the picking.",
            "picking_confirmed": "Picking confirmed successfully.",
            "select_item_variant": "Select item variant",
            "create_picking": "Create picking",
            "search_customer": "Search customer...",
            "start_typing_customer": "Start typing to search for a customer...",
            "list_bills_of_lading": "Bills of lading list",
            "filter_by": "Filter by",
            "client": "client",
            "confirm": "Confirm",
            "icam_request_sent_successfully": "ICAM request sent successfully",
            "confirm_bol": "Confirm Bills of Lading",
            "confirm_bol_description": "Do you want to register the rows of the selected bills of lading? This operation is irreversible.",
            "send_request": "Send Request",
            "confirm_placing": "Confirm Placing",
            "order_by_sales_person": "List of orders by Sales Person",
            "fatturato_per_agente": "Turnover per Agent",
            "search_by_warehouse": "Search by warehouse",
            "search_by_lot_item": "Search by lot or item",
            "search_method": "Search method",
            "by_storage": "By Storage (Barcode)",
            "by_item": "By Item Code",
            "by_lot": "By Lot",
            "by_barcode": "Barcode Only",
            "select_item_lot": "Select Item/Lot",
            "insert_item_code": "Item Code...",
            "insert_lot": "Lot Number...",
            "list_locations": "Locations list by item",
            "gestione_ubicazioni_icam": "ICAM Location Management",
            "reset_filters": "Reset filters",
            "ordered_filter_period_1": "Ordered Filter 1st Period",
            "ordered_filter_period_2": "Ordered Filter 2nd Period",
            "fatturato_filter_period_1": "Invoiced Filter 1st Period",
            "fatturato_filter_period_2": "Invoiced Filter 2nd Period",
            "fatturato_filter_period_3": "Invoiced Filter 3rd Period",
            "from": "From",
            "to": "to",
            "agents_filter": "Agents Filter",
            "all_agents": "ALL (all agents)",
            "totals": "Totals",
            "agent": "Agent",
            "name": "Name",
            "company_name": "Company Name",
            "ordered": "Ordered",
            "ordered_period_2": "Ordered 2nd period",
            "agent_name": "Agent Name",
            "city": "City",
            "address": "Address",
            "phone": "Phone number",
            "fatturato_period_1": "Invoiced 1st period",
            "fatturato_period_2": "Invoiced 2nd period",
            "fatturato_period_3": "Invoiced 3rd period",
            "order_analysis_by_agent_client": "Order analysis by agent/customer",
            "date_range_error": "The \"From\" date must be less than or equal to the \"To\" date.",
            "overlap_error": "Warning!!! You have selected two overlapping time periods.",
            "storage": "Storage",
            "qty_already_set": "Quantity already set to maximum",
            "qty_exceeds_order": "The quantity for item {item} exceeds the ordered quantity (max: {max}). Continue?",
            "confirm_bin": "Confirm location",
            "insert_bin_to_confirm": "Enter the location to confirm",
            "qty_differs_from_bol": "The entered quantity differs from the bill of lading quantity",
            "qty_differs_from_remaining": "The entered quantity differs from the remaining order quantity",
            "item_not_managed_by_lots": "Item not managed by lots",
            "lot_config_not_available": "Lot configuration not available",
            "lot_generated": "Lot generated: ",
            "excess_material": "Excess material",
            "excess_reason": "Excess reason",
            "same_as_order": "Same as order",
            "item_found_not_in_order": "Item {item} ({description}) found but not present in the selected orders",
            "item_not_found_in_system": "Item not found in the system",
            "barcode_not_found": "Barcode not found in the system",
            "added_to_excess": "Item added to excess",
            "excess_items": "Excess items",
            "clear_all": "Clear all",
            "confirm_clear_excess": "Are you sure you want to clear the excess table?",
            "results_found": "Results found:",
            "show_zero_stock": "Also show items with stock equal to 0",
            "stock_short": "Stock:",
            "lot_short": "LOT:",
            "storage_short": "STO:",
            "customer_short": "Customer",
            "supplier_short": "Supplier",
            "carica_excel": {
                "drag_hint": "Drag the Excel file here",
                "click_hint": "or click to browse files",
                "select_file": "Select File",
                "upload_file": "Validate File",
                "upload_other_file": "Upload Another File",
                "cancel": "Cancel",
                "saving": "Saving…",
                "save_data": "Save data",
                "uploaded_files": "Uploaded files",
                "rows_info": "{rows} rows · uploaded on {date}",
                "delete": "Delete",
                "no_rows": "No rows.",
                "invalid_file_type": "Please upload only Excel (.xlsx) or CSV files",
                "xls_not_supported": "The .xls format is not supported. Save the file as .xlsx or .csv and try again.",
                "file_too_large": "The file is too large. Maximum allowed size: {size} MB.",
                "read_error": "Unable to read the file. Make sure it is a valid .xlsx or .csv file and try again.",
                "save_error": "Error while saving: ",
                "confirm_delete": "Delete this file?",
                "delete_error": "Error while deleting: ",
                "print": "Print for barcode reading"
            },
            "rettifica_headers": {
                "item": "Item",
                "description": "Description",
                "commodity_ctg": "Commodity Ctg.",
                "homogeneous_ctg": "Homogeneous Ctg.",
                "lot": "Lot",
                "storage": "Storage",
                "specificator": "Customer/Supplier",
                "resulting_qty": "Resulting Quantity",
                "current_qty": "Current Quantity"
            },
            "reg-confirm": "Confirm",
            "ddt_flow": {
                "confirm_title": "Confirm save - Excel Flow",
                "bills_to_create": "📋 Bills of lading to create:",
                "assignment_title": "⚠️ DDT Number Assignment",
                "assignment_description": "The following items were not found in the Excel file. Assign a DDT number to each one:",
                "choose_ddt": "-- Choose DDT --",
                "insert_ddt_placeholder": "Or enter DDT",
                "continue_save": "Continue saving",
                "assign_ddt_warning": "Assign a DDT to every item",
                "picking_no_orders": "(Pickings not generated - no related sales orders)",
                "bills_created_count": "Bills of lading created for {count} DDT",
                "error_ddt_assignment": "Error in DDT assignment"
            },
            "supplier_doc_date": "Supplier Document Date",
            "bill_of_lading_date": "Bill of Lading Registration Date",
            "print_pickings": "Generated Pickings"
        },
        "pagination": {
            "next": "Next &raquo;",
            "previous": "&laquo; Previous"
        }
    },
    "fr": {
        "http-statuses": {
            "0": "Errore sconosciuto",
            "100": "Continua",
            "101": "Scambiando protocolli",
            "102": "In processo",
            "200": "OK",
            "201": "Creato",
            "202": "Accettato",
            "203": "Informazione non autorevole",
            "204": "Nessun contenuto",
            "205": "Resetta il contenuto",
            "206": "Contenuto parziale",
            "207": "Stati multipli",
            "208": "Già riportato",
            "226": "IM utilizzati",
            "300": "Scelte multiple",
            "301": "Trasferito permanentemente",
            "302": "Trovato",
            "303": "Guarda altro",
            "304": "Non modificata",
            "305": "Usa un proxy",
            "307": "Re-indirizzamento temporaneo",
            "308": "Re-indirizzamento permanente",
            "400": "Cattiva richiesta",
            "401": "Non autorizzata",
            "402": "Pagamento richiesto",
            "403": "Accesso vietato",
            "404": "Pagina non trovata",
            "405": "Metodo non consentito",
            "406": "Non accettabile",
            "407": "Autenticazione al proxy richiesta",
            "408": "Tempo scaduto per la richiesta",
            "409": "Conflitto",
            "410": "Andata",
            "411": "Lunghezza necessaria",
            "412": "Precondizione fallita",
            "413": "Payload troppo grande",
            "414": "URI troppo lungo",
            "415": "Media Type non supportato",
            "416": "intervallo non soddisfacibile",
            "417": "Aspettativa fallita",
            "418": "Sono una teiera",
            "419": "Sessione scaduta",
            "421": "Richiesta mal indirizzata",
            "422": "Entità improcessabile",
            "423": "Bloccata",
            "424": "Dipendenza fallita",
            "425": "Troppo presto",
            "426": "Aggiornamento richiesto",
            "428": "Precondizione necessaria",
            "429": "Troppe richieste",
            "431": "Campi header della richiesta troppo grandi",
            "444": "Connessione chiusa senza risposta",
            "449": "Riprova con",
            "451": "Non disponibile per motivi legali",
            "499": "Richiesta chiusa del cliente",
            "500": "Errore interno al server",
            "501": "Non implementato",
            "502": "Gateway cattivo",
            "503": "In manutenzione",
            "504": "Tempo scaduto per il gateway",
            "505": "Versione HTTP non supportata",
            "506": "Variante anche negozia",
            "507": "Spazio insufficiente",
            "508": "Loop identificato",
            "509": "Limita di banda superato",
            "510": "Non esteso",
            "511": "Autenticazione di rete necessaria",
            "520": "Errore sconosciuto",
            "521": "Web server spento",
            "522": "Tempo scaduto per la connessione",
            "523": "Origine non raggiungibile",
            "524": "Un timeout è avvenuto",
            "525": "Handshake SSL fallita",
            "526": "Certificato SSL invalido",
            "527": "Errore del cannone a rotaia",
            "598": "Errore timeout lettura rete",
            "599": "Errore di timeout della connessione di rete",
            "unknownError": "Errore sconosciuto"
        },
        "core": {
            "order_number": "Numéro de commande",
            "supplier": "Fournisseur",
            "supplier_docno": "Num doc fournisseur",
            "customer": "Client",
            "searching": "Recherche en cours",
            "on_date": "Le",
            "date": "Date",
            "load": "Charger",
            "inventory_management": "Gestion des stocks",
            "receiving_goods": "Réception des marchandises",
            "order_fulfillment": "Exécution des commandes",
            "order": "Commande",
            "position": "Position",
            "item": "Article",
            "description": "Description",
            "qty_order": "Qté commandée",
            "qty_registered": "Qté enreg.",
            "qty_to_register": "Qté à enregistrer",
            "registration": "Enregistrement",
            "supplier_order_details": "Détails de la commande fournisseur",
            "barcode_search": "Recherche par code-barres",
            "item_search": "Recherche d'article",
            "qty_received_of": "Indiquer la quantité reçue de",
            "in_order": "dans la commande",
            "set": "Fixer",
            "confirm_receive": "Confirmer la réception",
            "document": "Document",
            "item_not_found": "Article non trouvé",
            "successful_operation": "Opération réussie",
            "error": "Erreur",
            "receiving": "Réception",
            "shipped": "Expédié",
            "to_be_shipped": "À expédier",
            "shipping": "Expédition",
            "destination": "Destination",
            "shipping_type": "Type de livraison",
            "gross_weight": "Poids brut",
            "net_weight": "Poids net",
            "number_of_packages": "Nombre de colis",
            "article_list": "Liste des articles",
            "available": "Disponible",
            "code": "Code",
            "product_category": "Catégorie de produit",
            "homogeneous_category": "Catégorie homogène",
            "choose_item": "Choisissez un article",
            "bol_number": "Bons de Livraison nr",
            "bol_confirm": "Confirmer les bons de livraison",
            "bin": "Emplacement",
            "storage": "Entrepôt",
            "price": "Prix",
            "discount": "Remise",
            "icam_status": "ICAM Status",
            "save": "Enregistrer",
            "line": "Ligne",
            "billofladings": "Bons de livraison",
            "saving_data": "Sauvegarde des données",
            "items_list": "Liste des articles",
            "bill_number": "N° de bon de livraison",
            "commodity_ctg": "Catégorie de produit",
            "homogeneous_ctg": "Catégorie homogène",
            "search": "Rechercher",
            "close_and_continue": "Fermer et continuer",
            "company_name": "Raison sociale",
            "server_error": "Erreur interne du serveur",
            "connection_error": "Impossible d'établir la connexion, vérifiez votre réseau",
            "unit_value": "Valeur unitaire",
            "reference": "Réf.",
            "item_supplier_code": "Code Fournisseur"
        },
        "actions": {
            "accept": "Accepter",
            "action": "Action",
            "actions": "Actions",
            "add": "Ajouter",
            "admin": "Admin",
            "agree": "Être d'accord",
            "archive": "Archive",
            "assign": "Attribuer",
            "associate": "Associer",
            "attach": "Attacher",
            "browse": "Naviguer",
            "cancel": "Annuler",
            "choose": "Choisir",
            "choose_file": "Choisir le fichier",
            "choose_image": "Choisir une image",
            "click_to_copy": "Cliquez pour copier",
            "close": "Fermer",
            "collapse": "Réduire",
            "collapse_all": "Réduire tout",
            "comment": "Commentaire",
            "confirm": "Confirmer",
            "confirm_and_save": "Confirmer et enregistrer",
            "connect": "Connecter",
            "create": "Créer",
            "delete": "Supprimer",
            "detach": "Détacher",
            "details": "Détails",
            "disable": "Désactiver",
            "discard": "Jeter",
            "done": "Fait",
            "down": "Bas",
            "duplicate": "Dupliquer",
            "edit": "Modifier",
            "enable": "Activer",
            "expand": "Développer",
            "expand_all": "Développer tout",
            "explanation": "Explication",
            "export": "Exporter",
            "file": "Fichier",
            "files": "Fichiers",
            "go_home": "Retour à l'accueil",
            "hide": "Cacher",
            "home": "Accueil",
            "image": "Image",
            "impersonate": "Usurper",
            "impersonation": "Usurpation",
            "import": "Importer",
            "introduction": "Introduction",
            "like": "J'aime",
            "load": "Charger",
            "localize": "Localiser",
            "log_in": "Se connecter",
            "log_out": "Se déconnecter",
            "named": {
                "add": "Ajouter {name}",
                "choose": "Choisir {name}",
                "create": "Créer {name}",
                "delete": "Supprimer {name}",
                "duplicate": "Dupliquer {name}",
                "edit": "Modifier {name}",
                "export": "Exporter {name}",
                "hide": "Cacher {name}",
                "import": "Importer {name}",
                "new": "Nouveau {name}",
                "restore": "Restaurer {name}",
                "save": "Enregistrer {name}",
                "search": "Rechercher {name}",
                "show": "Afficher {name}",
                "update": "Mettre à jour {name}",
                "view": "Voir {name}"
            },
            "new": "Nouveau",
            "no": "Non",
            "open": "Ouvrir",
            "open_website": "Ouvrir sur le site",
            "preview": "Aperçu",
            "price": "Prix",
            "record": "Enregistrement",
            "restore": "Restaurer",
            "save": "Enregistrer",
            "save_and_close": "Enregistrer et fermer",
            "save_and_return": "Enregistrer et revenir",
            "search": "Recherche",
            "select": "Sélectionner",
            "select_all": "Sélectionner tout",
            "send": "Envoyer",
            "settings": "Paramètres",
            "show": "Afficher",
            "show_all": "Afficher tout",
            "sign_in": "Se connecter",
            "solve": "Résoudre",
            "start": "Démarrer",
            "stop": "Arrêter",
            "submit": "Soumettre",
            "subscribe": "S'abonner",
            "switch": "Basculer",
            "switch_to_role": "Basculer vers le rôle",
            "tag": "Étiquette",
            "tags": "Étiquettes",
            "target_link": {
                "blank": "Ouvrir dans une nouvelle fenêtre",
                "parent": "Ouvrir dans un cadre parent",
                "self": "Ouvrir dans la fenêtre actuelle",
                "top": "Ouvrir dans le cadre supérieur"
            },
            "translate": "Traduire",
            "translate_it": "Traduire",
            "unpack": "Décompresser",
            "unsubscribe": "Se désabonner",
            "up": "Haut",
            "update": "Mettre à jour",
            "user": "Utilisateur",
            "view": "Afficher",
            "yes": "Oui",
            "filters": "Filtres",
            "apply": "Appliquer",
            "empty": "Vide",
            "confirming_picking": "Création/mise à jour du picking en cours"
        },
        "rp": {
            "import": {
                "button": "Importer CSV/XLSX",
                "title": "Importation CSV/XLSX",
                "steps": {
                    "upload": "Chargement",
                    "mapping": "Correspondance",
                    "validation": "Validation",
                    "confirm": "Confirmation"
                },
                "common": {
                    "next": "Suivant",
                    "back": "Retour",
                    "thousandsNone": "Aucun"
                },
                "types": {
                    "text": "Texte",
                    "number": "Nombre",
                    "date": "Date",
                    "select": "Sélection",
                    "magoquery": "Requête Mago",
                    "portalquery": "Requête Portail"
                },
                "lookupModes": {
                    "value": "Code/valeur",
                    "label": "Description",
                    "value_or_label": "D'abord le code, puis la description"
                },
                "upload": {
                    "dropHint": "Sélectionnez un fichier .csv ou .xlsx à importer",
                    "selectFile": "Sélectionner un fichier",
                    "fileName": "Nom du fichier",
                    "fileSize": "Taille",
                    "rowsCount": "Lignes",
                    "headers": "Colonnes",
                    "preview": "Aperçu (10 premières lignes)",
                    "invalidExtension": "Format non pris en charge. Seuls les fichiers .csv et .xlsx sont autorisés.",
                    "tooLarge": "Le fichier dépasse la taille maximale de {max} Mo.",
                    "empty": "Le fichier ne contient aucune ligne."
                },
                "mapping": {
                    "field": "Champ du registre",
                    "type": "Type",
                    "required": "Obligatoire",
                    "sourceColumn": "Colonne du fichier",
                    "interpretation": "Interprétation",
                    "selectColumn": "Sélectionner une colonne",
                    "doNotImport": "Ne pas importer",
                    "requiredNotMapped": "Champ obligatoire : correspondance requise.",
                    "decimalSeparator": "Séparateur décimal",
                    "thousandsSeparator": "Séparateur de milliers",
                    "dateFormat": "Format de date source",
                    "allowedOptions": "Options autorisées",
                    "recognizeBoolean": "Reconnaître les synonymes oui/non",
                    "lookupMode": "Rechercher la valeur comme"
                },
                "validation": {
                    "running": "Validation en cours…",
                    "total": "Lignes totales",
                    "valid": "Lignes valides",
                    "invalid": "Lignes erronées",
                    "errorsTable": "Erreurs",
                    "rowNumber": "Ligne",
                    "field": "Champ",
                    "sourceColumn": "Colonne source",
                    "originalValue": "Valeur originale",
                    "message": "Message",
                    "noErrors": "Aucune erreur détectée.",
                    "blocked": "Des lignes non valides sont présentes : corrigez le fichier ou la correspondance pour continuer."
                },
                "confirm": {
                    "registry": "Registre de destination",
                    "file": "Fichier",
                    "rowsToImport": "Lignes à importer",
                    "atomicWarning": "L'opération est atomique : si une seule ligne est invalide, aucun enregistrement ne sera inséré.",
                    "import": "Importer les enregistrements",
                    "importing": "Importation en cours…",
                    "success": "Importation terminée : {count} enregistrements créés.",
                    "backToRegistry": "Retour au registre"
                },
                "errors": {
                    "generic": "Impossible de lire le fichier.",
                    "http": "Une erreur s'est produite lors de la communication avec le serveur."
                }
            }
        },
        "validation": {
            "accepted": "{Attribute} doit être accepté.",
            "accepted_if": "{Attribute} doit être accepté quand {other} est {value}.",
            "active_url": "{Attribute} n'est pas une URL valide.",
            "after": "{Attribute} doit être une date postérieure à {date}.",
            "after_or_equal": "{Attribute} doit être une date postérieure ou égale à {date}.",
            "alpha": "{Attribute} ne peut contenir que des lettres.",
            "alpha_dash": "{Attribute} ne peut contenir que des lettres, des chiffres et des tirets.",
            "alpha_num": "{Attribute} ne peut contenir que des lettres et des chiffres.",
            "array": "{Attribute} doit être un tableau.",
            "ascii": "{Attribute} doit contenir uniquement des caractères alphanumériques et des symboles à un octet.",
            "before": "{Attribute} doit être une date antérieure à {date}.",
            "before_or_equal": "{Attribute} doit être une date antérieure ou égale à {date}.",
            "between": {
                "array": "{Attribute} doit avoir entre {min} et {max} éléments.",
                "file": "{Attribute} doit être compris entre {min} et {max} kilo-octets.",
                "numeric": "{Attribute} doit être compris entre {min} et {max}.",
                "string": "{Attribute} doit être compris entre {min} et {max} caractères."
            },
            "boolean": "Le champ {attribute} doit être vrai ou faux.",
            "can": "Le champ {attribute} contient une valeur non autorisée.",
            "confirmed": "Le champ de confirmation pour {attribute} ne correspond pas.",
            "contains": "Le champ {attribute} manque une valeur requise.",
            "current_password": "Mot de passe incorrect.",
            "date": "{Attribute} n'est pas une date valide.",
            "date_equals": "{Attribute} doit être une date égale à {date}.",
            "date_format": "{Attribute} ne correspond pas au format {format}.",
            "decimal": "{Attribute} doit avoir {decimal} décimales.",
            "declined": "{Attribute} doit être refusé.",
            "declined_if": "{Attribute} doit être refusé quand {other} est {value}.",
            "different": "{Attribute} et {other} doivent être différents.",
            "digits": "{Attribute} doit comporter {digits} chiffres.",
            "digits_between": "{Attribute} doit être compris entre {min} et {max} chiffres.",
            "dimensions": "Les dimensions de l'image {attribute} ne sont pas valides.",
            "distinct": "{Attribute} contient une valeur en double.",
            "doesnt_end_with": "{Attribute} ne peut pas se terminer par l'une des valeurs suivantes : {values}.",
            "doesnt_start_with": "{Attribute} ne peut pas commencer par l'une des valeurs suivantes : {values}.",
            "email": "{Attribute} doit être une adresse email valide.",
            "ends_with": "{Attribute} doit se terminer par l'une des valeurs suivantes : {values}.",
            "enum": "Le champ {attribute} n'est pas valide.",
            "exists": "{Attribute} sélectionné n'est pas valide.",
            "extensions": "Le champ {attribute} doit avoir l'une des extensions suivantes : {values}.",
            "file": "{Attribute} doit être un fichier.",
            "filled": "Le champ {attribute} doit avoir une valeur.",
            "gt": {
                "array": "{Attribute} doit contenir plus de {value} éléments.",
                "file": "{Attribute} doit être supérieur à {value} kilo-octets.",
                "numeric": "{Attribute} doit être supérieur à {value}.",
                "string": "{Attribute} doit contenir plus de {value} caractères."
            },
            "gte": {
                "array": "{Attribute} doit contenir au moins {value} éléments.",
                "file": "{Attribute} doit être supérieur ou égal à {value} kilo-octets.",
                "numeric": "{Attribute} doit être supérieur ou égal à {value}.",
                "string": "{Attribute} doit contenir au moins {value} caractères."
            },
            "hex_color": "Le champ {attribute} doit être une couleur hexadécimale valide.",
            "image": "{Attribute} doit être une image.",
            "in": "{Attribute} sélectionné n'est pas valide.",
            "in_array": "Le champ {attribute} n'existe pas dans {other}.",
            "integer": "{Attribute} doit être un entier.",
            "ip": "{Attribute} doit être une adresse IP valide.",
            "ipv4": "{Attribute} doit être une adresse IPv4 valide.",
            "ipv6": "{Attribute} doit être une adresse IPv6 valide.",
            "json": "{Attribute} doit être une chaîne JSON valide.",
            "list": "Le champ {attribute} doit être une liste.",
            "lowercase": "{Attribute} doit être en minuscules.",
            "lt": {
                "array": "{Attribute} doit contenir moins de {value} éléments.",
                "file": "{Attribute} doit être inférieur à {value} kilo-octets.",
                "numeric": "{Attribute} doit être inférieur à {value}.",
                "string": "{Attribute} doit contenir moins de {value} caractères."
            },
            "lte": {
                "array": "{Attribute} doit contenir au plus {value} éléments.",
                "file": "{Attribute} doit être inférieur ou égal à {value} kilo-octets.",
                "numeric": "{Attribute} doit être inférieur ou égal à {value}.",
                "string": "{Attribute} doit contenir au plus {value} caractères."
            },
            "mac_address": "Le champ {attribute} doit être une adresse MAC valide.",
            "max": {
                "array": "{Attribute} ne peut pas contenir plus de {max} éléments.",
                "file": "{Attribute} ne peut pas être supérieur à {max} kilo-octets.",
                "numeric": "{Attribute} ne peut pas être supérieur à {max}.",
                "string": "{Attribute} ne peut pas contenir plus de {max} caractères."
            },
            "max_digits": "{Attribute} ne peut pas contenir plus de {max} chiffres.",
            "mimes": "{Attribute} doit être un fichier de type : {values}.",
            "mimetypes": "{Attribute} doit être un fichier de type : {values}.",
            "min": {
                "array": "{Attribute} doit contenir au moins {min} éléments.",
                "file": "{Attribute} doit être d'au moins {min} kilo-octets.",
                "numeric": "{Attribute} doit être d'au moins {min}.",
                "string": "{Attribute} doit contenir au moins {min} caractères."
            },
            "min_digits": "{Attribute} doit contenir au moins {min} chiffres.",
            "missing": "Le champ {attribute} doit être manquant.",
            "missing_if": "Le champ {attribute} doit être manquant lorsque {other} est {value}.",
            "missing_unless": "Le champ {attribute} doit être manquant sauf si {other} est {value}.",
            "missing_with": "Le champ {attribute} doit être manquant lorsque {values} est présent.",
            "missing_with_all": "Le champ {attribute} doit être manquant lorsque {values} sont présents.",
            "multiple_of": "{Attribute} doit être un multiple de {value}.",
            "not_in": "{Attribute} sélectionné n'est pas valide.",
            "not_regex": "Le format {attribute} n'est pas valide.",
            "numeric": "{Attribute} doit être un nombre.",
            "password": {
                "letters": "{Attribute} doit contenir au moins une lettre.",
                "mixed": "{Attribute} doit contenir au moins une majuscule et une minuscule.",
                "numbers": "{Attribute} doit contenir au moins un chiffre.",
                "symbols": "{Attribute} doit contenir au moins un symbole.",
                "uncompromised": "{Attribute} est présent dans une fuite de données. Veuillez choisir une autre valeur pour {attribute}."
            },
            "present": "Le champ {attribute} doit être présent.",
            "present_if": "Le champ {attribute} doit être présent lorsque {other} est {value}.",
            "present_unless": "Le champ {attribute} doit être présent sauf si {other} est {value}.",
            "present_with": "Le champ {attribute} doit être présent lorsque {values} est présent.",
            "present_with_all": "Le champ {attribute} doit être présent lorsque {values} sont présents.",
            "prohibited": "Le champ {attribute} est interdit.",
            "prohibited_if": "Le champ {attribute} est interdit lorsque {other} est {value}.",
            "prohibited_if_accepted": "Le champ {attribute} est interdit lorsque {other} est accepté.",
            "prohibited_if_declined": "Le champ {attribute} est interdit lorsque {other} est refusé.",
            "prohibited_unless": "Le champ {attribute} est interdit sauf si {other} est dans {values}.",
            "prohibits": "Le champ {attribute} interdit la présence de {other}.",
            "regex": "Le format du champ {attribute} n'est pas valide.",
            "required": "Le champ {attribute} est obligatoire.",
            "required_array_keys": "Le champ {attribute} doit contenir des entrées pour : {values}.",
            "required_if": "Le champ {attribute} est obligatoire lorsque {other} est {value}.",
            "required_if_accepted": "Le champ {attribute} est obligatoire lorsque {other} est accepté.",
            "required_if_declined": "Le champ {attribute} est obligatoire lorsque {other} est refusé.",
            "required_unless": "Le champ {attribute} est obligatoire sauf si {other} est dans {values}.",
            "required_with": "Le champ {attribute} est obligatoire lorsque {values} est présent.",
            "required_with_all": "Le champ {attribute} est obligatoire lorsque {values} sont présents.",
            "required_without": "Le champ {attribute} est obligatoire lorsque {values} n'est pas présent.",
            "required_without_all": "Le champ {attribute} est obligatoire lorsqu'aucun de {values} n'est présent.",
            "same": "{Attribute} et {other} doivent correspondre.",
            "size": {
                "array": "{Attribute} doit contenir {size} éléments.",
                "file": "{Attribute} doit être de {size} kilo-octets.",
                "numeric": "{Attribute} doit être de {size}.",
                "string": "{Attribute} doit contenir {size} caractères."
            },
            "starts_with": "{Attribute} doit commencer par l'une des valeurs suivantes : {values}.",
            "string": "{Attribute} doit être une chaîne de caractères.",
            "timezone": "{Attribute} doit être un fuseau horaire valide.",
            "ulid": "{Attribute} doit être un ULID valide.",
            "unique": "{Attribute} a déjà été utilisé.",
            "uploaded": "{Attribute} n'a pas été téléchargé.",
            "uppercase": "{Attribute} doit être en majuscules.",
            "url": "Le format de {attribute} n'est pas valide.",
            "uuid": "{Attribute} doit être un UUID valide.",
            "attributes": {
                "address": "adresse",
                "affiliate_url": "URL d'affiliation",
                "age": "âge",
                "amount": "montant",
                "announcement": "annonce",
                "area": "zone",
                "audience_prize": "prix du public",
                "audience_winner": "gagnant du public",
                "available": "disponible",
                "birthday": "date de naissance",
                "body": "corps",
                "city": "ville",
                "company": "entreprise",
                "compilation": "compilation",
                "concept": "concept",
                "conditions": "conditions",
                "content": "contenu",
                "contest": "concours",
                "country": "pays",
                "cover": "couverture",
                "created_at": "créé le",
                "creator": "créateur",
                "currency": "devise",
                "current_password": "mot de passe actuel",
                "customer": "client",
                "date": "date",
                "date_of_birth": "date de naissance",
                "dates": "dates",
                "day": "jour",
                "deleted_at": "supprimé le",
                "description": "description",
                "display_type": "type d'affichage",
                "district": "district",
                "duration": "durée",
                "email": "e-mail",
                "excerpt": "extrait",
                "filter": "filtre",
                "finished_at": "terminé le",
                "first_name": "prénom",
                "gender": "genre",
                "grand_prize": "grand prix",
                "group": "groupe",
                "hour": "heure",
                "image": "image",
                "image_desktop": "image de bureau",
                "image_main": "image principale",
                "image_mobile": "image mobile",
                "images": "images",
                "is_audience_winner": "est le gagnant du public",
                "is_hidden": "est caché",
                "is_subscribed": "est abonné",
                "is_visible": "est visible",
                "is_winner": "est gagnant",
                "items": "éléments",
                "key": "clé",
                "last_name": "nom de famille",
                "lesson": "leçon",
                "line_address_1": "adresse de la ligne 1",
                "line_address_2": "adresse de la ligne 2",
                "login": "identifiant",
                "message": "message",
                "middle_name": "deuxième prénom",
                "minute": "minute",
                "mobile": "portable",
                "month": "mois",
                "name": "nom",
                "national_code": "code national",
                "number": "nombre",
                "password": "mot de passe",
                "password_confirmation": "confirmation du mot de passe",
                "phone": "téléphone",
                "photo": "photo",
                "portfolio": "portefeuille",
                "postal_code": "Code Postal",
                "preview": "aperçu",
                "price": "prix",
                "product_id": "Code produit",
                "product_uid": "ID du produit",
                "product_uuid": "UUID du produit",
                "promo_code": "code promo",
                "province": "Province",
                "quantity": "quantité",
                "reason": "raison",
                "recaptcha_response_field": "champ de réponse recaptcha",
                "referee": "arbitre",
                "referees": "arbitres",
                "reject_reason": "raison du refus",
                "remember": "se souvenir",
                "restored_at": "restauré le",
                "result_text_under_image": "texte du résultat sous l'image",
                "role": "rôle",
                "rule": "règle",
                "rules": "règles",
                "second": "seconde",
                "sex": "sexe",
                "shipment": "expédition",
                "short_text": "texte court",
                "size": "taille",
                "skills": "compétences",
                "slug": "slug",
                "specialization": "spécialisation",
                "started_at": "commencé à",
                "state": "état",
                "status": "statut",
                "street": "rue",
                "student": "étudiant",
                "subject": "sujet",
                "tag": "étiquette",
                "tags": "tags",
                "teacher": "enseignant",
                "terms": "termes",
                "test_description": "description du test",
                "test_locale": "locale de test",
                "test_name": "nom du test",
                "text": "texte",
                "time": "heure",
                "title": "titre",
                "type": "type",
                "updated_at": "mis à jour le",
                "user": "utilisateur",
                "username": "nom d'utilisateur",
                "value": "valeur",
                "winner": "gagnant",
                "work": "travail",
                "year": "année"
            }
        },
        "an": {
            "breadcrumb": {
                "anagrafiche": "Fiches",
                "clienti_fornitori": "Clients et fournisseurs",
                "contatti": "Contacts"
            },
            "fields": {
                "id": "ID",
                "company_name": "Raison sociale",
                "city": "Ville",
                "address": "Adresse",
                "zip_code": "Code postal",
                "county": "Province",
                "country": "Pays",
                "latitude": "Latitude",
                "longitude": "Longitude",
                "phone1": "Téléphone 1",
                "phone2": "Téléphone 2",
                "phone": "Téléphone",
                "email_certified": "Email certifié",
                "vat": "N° TVA",
                "fiscal_code": "Code fiscal",
                "sdi_code": "Code SDI",
                "abi": "ABI",
                "cab": "CAB",
                "bank": "Banque",
                "payment": "Paiement",
                "typical_discount": "Remise typique",
                "account": "Compte",
                "agent": "Agent",
                "type": "Type",
                "customer_notes": "Notes client",
                "actions": "Actions",
                "contact": "Contact"
            },
            "actions": {
                "choose_agent": "Choisir l'agent",
                "update": "Mettre à jour",
                "add": "Ajouter",
                "close": "Fermer",
                "edit": "Modifier",
                "details": "Détails",
                "sites": "Sites",
                "select_type": "Sélectionner le type",
                "searching": "🔍 Recherche en cours...",
                "start_typing": "Commencez à taper..."
            },
            "gestione_clienti_fornitori": {
                "add_button": "Ajouter une fiche",
                "search_placeholder": "Recherche code/raison sociale",
                "customers": "Clients",
                "suppliers": "Fournisseurs",
                "modal_edit_title": "Modifier Client/Fournisseur",
                "modal_add_title": "Ajouter Client/Fournisseur",
                "sites_of": "Sites de",
                "no_sites": "Aucun site trouvé"
            },
            "gestione_contatti": {
                "add_button": "Ajouter Contact",
                "search_placeholder": "Recherche code/raison sociale",
                "modal_edit_title": "Modifier Contact",
                "modal_add_title": "Ajouter Contact"
            },
            "parameters": {
                "filter_entries_by_agent_label": "Filtrer les éléments par agent",
                "filter_entries_by_agent_description": "Si activé, seuls les éléments associés à l'agent lié au compte connecté seront affichés",
                "electronic_invoicing_label": "Facturation électronique",
                "electronic_invoicing_description": "Si activé, les clients sont créés avec le champ ElectronicInvoicing à 1, sinon à 0"
            },
            "validation": {
                "custsupptype_required": "Le type de client/fournisseur est obligatoire.",
                "taxid_already_exists": "Le N° TVA indiqué est déjà présent.",
                "company_name_required": "La raison sociale est obligatoire."
            },
            "messages": {
                "client_supplier_added": "Client/Fournisseur ajouté avec succès.",
                "contact_added": "Contact ajouté avec succès."
            }
        },
        "pv": {
            "breadcrumb": {
                "percorsi_vettori": "Itinéraires Transporteurs",
                "gestione_itinerari": "Itinéraires Enregistrés",
                "generazione_itinerari": "Créer un Itinéraire",
                "confronto_stradari": "Comparaison d'Adresses"
            },
            "parameters": {
                "group_by_companyName_and_address_label": "Grouper par",
                "group_by_companyName_and_address_description": "Grouper les arrêts par adresse de livraison (CompanyName + Address) au lieu de par adresse unique.",
                "custom_carriers_label": "Transporteurs personnalisés",
                "custom_carriers_description": "Si activé, affiche uniquement les transporteurs ayant le drapeau \"Custom\" coché dans MAGO",
                "usa_categoria_cliente_label": "Utiliser la catégorie client",
                "usa_categoria_cliente_description": "Si défini, affiche le code site uniquement pour les clients appartenant à cette catégorie"
            },
            "flash": {
                "travel_saved": "Itinéraire enregistré avec succès !",
                "travel_save_error": "Erreur lors de l'enregistrement : ",
                "travel_updated": "Itinéraire mis à jour avec succès !",
                "travel_update_error": "Erreur lors de la mise à jour : ",
                "travel_deleted": "Itinéraire supprimé avec succès.",
                "travel_delete_error": "Erreur lors de la suppression : ",
                "address_not_available": "Adresse non disponible pour ce site",
                "error_missing_carrier": "Impossible de générer l'itinéraire : les commandes suivantes n'ont pas de transporteur attribué : {orders}.",
                "error_no_trips_found_for_orders": "Aucun voyage trouvé pour les commandes sélectionnées : vérifiez qu'elles ont déjà été expédiées/facturées.",
                "error_orders_not_found": "Aucun document de préparation trouvé pour les commandes suivantes : {orders}. Vérifiez qu'elles ont déjà été expédiées/facturées.",
                "error_multiple_carriers": "Impossible de générer l'itinéraire : les commandes sélectionnées sont associées à des transporteurs différents ({carriers}). Veuillez sélectionner des commandes avec le même transporteur."
            },
            "confronto_headers": {
                "code": "Code",
                "company_name": "Raison Sociale",
                "status": "Statut"
            },
            "csv_headers": {
                "stop": "Étape",
                "company_name": "Raison Sociale",
                "customer_code": "Code Client",
                "address": "Adresse",
                "doc_num": "N° Doc",
                "doc_type": "Type Doc",
                "packages": "Colis",
                "rimes": "Retours",
                "mdp": "MdP",
                "notes": "Notes",
                "warnings": "Avertissements",
                "departure": "DÉPART",
                "arrival": "ARRIVÉE"
            },
            "shared": {
                "add_waypoint": "Ajouter Étape",
                "search_address_placeholder": "Rechercher une adresse...",
                "delete_waypoint_title": "Supprimer l'étape",
                "options": "Options",
                "avoid_tolls": "Éviter les Péages",
                "avoid_highways": "Éviter les Autoroutes",
                "avoid_ferries": "Éviter les Ferries",
                "distance_label": "Distance :",
                "duration_label": "Durée :",
                "saving": "Enregistrement...",
                "calculating": "Calcul...",
                "geocode_failed": "Échec du géocodage : ",
                "new_waypoint": "Nouvelle Étape",
                "departure": "Départ",
                "arrival": "Arrivée"
            },
            "confronto": {
                "title": "Comparaison d'adresses",
                "verify_page_button": "Vérifier toutes les adresses de la page",
                "verifying_in_progress": "Vérification en cours…",
                "th_branch": "Site",
                "th_registered_address": "Adresse Enregistrée",
                "th_google_address": "Adresse Google",
                "th_status": "Statut",
                "main_branch": "★ Siège",
                "branch_label": "Filiale",
                "address_not_found": "Adresse non trouvée sur Google",
                "partial_match": "(correspondance partielle)",
                "verification_failed": "vérification échouée",
                "error_prefix": "Erreur :",
                "to_verify": "À vérifier…",
                "verify": "Vérifier",
                "verify_all_branches": "Vérifier tous les sites",
                "no_secondary_branches": "Aucun site secondaire",
                "unknown_error": "Erreur inconnue",
                "badge_ok": "✓ OK",
                "badge_partial": "~ Partiel",
                "badge_mismatch": "✗ Différent",
                "badge_not_found": "∅ Introuvable",
                "badge_error": "! Erreur",
                "badge_to_verify": "À vérifier",
                "badge_global_to_verify": "⏳ À vérifier",
                "badge_global_verified": "🔄 {done}/{total} vérifiés",
                "badge_global_all_ok": "✓ Tous OK ({total})",
                "badge_global_discrepancies": "⚠ {issues}/{total} divergences",
                "label_via": "Rue",
                "label_cap": "Code Postal",
                "label_city": "Ville",
                "label_county": "Dép.",
                "label_country": "Pays"
            },
            "gestione": {
                "history_title": "Historique Itinéraires",
                "page_summary": "Page {current} sur {last} — {total} itinéraires au total",
                "previous": "← Précédent",
                "next": "Suivant →",
                "field_date": "Date",
                "field_travel_name": "Nom du Voyage",
                "field_distance_stops": "Distance / Étapes",
                "custom_options_active": "Options personnalisées actives",
                "carrier_label": "Transporteur :",
                "route_config_label": "Configuration de l'Itinéraire :",
                "tag_optimized": "Optimisé",
                "tag_no_tolls": "Sans Péages",
                "tag_no_highways": "Sans Autoroutes",
                "tag_no_ferries": "Sans Ferries",
                "standard_options": "Options standard",
                "stops_detail": "Détail des Étapes :",
                "packages_short": "Colis :",
                "btn_edit_route": "Modifier le Trajet",
                "btn_print": "Imprimer",
                "btn_delete_route": "Supprimer l'Itinéraire",
                "btn_export_excel": "Exporter Excel",
                "no_saved_itineraries": "Aucun itinéraire enregistré trouvé.",
                "modal_edit_route_title": "Modifier l'Itinéraire",
                "modal_route_stops": "Étapes de l'Itinéraire",
                "avoid_pedaggi_short": "Éviter les Péages",
                "avoid_highways_short": "Éviter les Autoroutes",
                "avoid_ferries_short": "Éviter les Ferries",
                "travel_data": "Données du Voyage",
                "btn_optimize": "Optimiser",
                "btn_recalculate": "Recalculer",
                "btn_save_itinerary": "Enregistrer l'Itinéraire",
                "confirm_delete": "Voulez-vous vraiment supprimer l'itinéraire \"{name}\" ? Cette action est irréversible.",
                "delete_error": "Erreur lors de la suppression de l'itinéraire.",
                "recalc_before_save": "Recalculez avant d'enregistrer.",
                "no_route_data": "Aucune donnée d'itinéraire disponible. Recalculez l'itinéraire avant d'enregistrer.",
                "save_error": "Erreur d'enregistrement.",
                "confirm_remove_grouped_docs": "Cette étape contient {count} documents groupés ({name}). Supprimer l'étape et tous les documents associés ?"
            },
            "generazione": {
                "header_title": "TABLEAU DE VOYAGE",
                "travel_of": "Voyage du",
                "travel_until": "au",
                "driver_label": "CHAUFFEUR / NOM :",
                "notes_label": "NOTES :",
                "total_distance": "Distance Totale",
                "expected_time": "Temps Prévu",
                "route_configuration": "Configuration du Trajet",
                "tag_avoid_tolls": "Éviter les Péages",
                "tag_avoid_highways": "Éviter les Autoroutes",
                "tag_avoid_ferries": "Éviter les Ferries",
                "tag_tolls_allowed": "Péages autorisés",
                "tag_highways_allowed": "Autoroutes autorisées",
                "tag_ferries_allowed": "Ferries autorisés",
                "btn_route": "Itinéraire",
                "btn_print": "Imprimer",
                "btn_export_excel": "Exporter Excel",
                "btn_new": "Nouveau",
                "btn_reload": "Recharger",
                "departure_point": "Point de Départ",
                "add_custom_address": "+ Ajouter une adresse personnalisée",
                "add_departure_address": "Ajouter une adresse de départ",
                "search_google_placeholder": "Rechercher une adresse sur Google...",
                "arrival_point": "Point d'Arrivée",
                "add_arrival_address": "Ajouter une adresse d'arrivée",
                "route_name_label": "Nom de l'Itinéraire (Optionnel)",
                "route_name_placeholder": "Exemple : Tournée Livraisons Nord, Voyage d'essai...",
                "qr_waiting": "QR Code en attente de l'itinéraire",
                "merge_same_address": "Fusionner les étapes avec la même adresse",
                "loading_trips": "Chargement des voyages...",
                "th_n": "N°",
                "th_company_name": "Raison Sociale",
                "th_shipping_address": "Adresse de Livraison",
                "th_doc_num": "N° Doc.",
                "th_warnings": "Avertissements",
                "th_nc": "N.C.",
                "th_rimes": "Retours",
                "th_mdp": "MdP",
                "row_partenza_prefix": "DÉPART :",
                "row_arrivo_prefix": "ARRIVÉE :",
                "tag_manual": "MANUEL",
                "no_trips_found": "Aucun voyage trouvé pour les critères sélectionnés.",
                "select_carrier_period": "Sélectionnez un transporteur et une période",
                "modal_title": "Sélectionner Transporteur et Période",
                "carrier_label": "Transporteur",
                "carrier_placeholder": "Sélectionnez un transporteur...",
                "search_mode": "Mode de Recherche",
                "single_date": "Date Unique",
                "date_range": "Plage de Dates",
                "select_date": "Sélectionner Date",
                "select_dates": "Sélectionner Dates",
                "date_from": "Du",
                "date_to": "Au",
                "btn_search_trips": "Rechercher des Voyages",
                "route_editor_title": "Modifier l'Itinéraire",
                "stops_count": "Étapes",
                "saving_in_progress": "Enregistrement en cours...",
                "route_calculating": "Calcul de l'itinéraire...",
                "option_avoid_tolls_desc": "Itinéraires sans autoroute",
                "option_avoid_highways_desc": "Routes nationales, départementales ou communales. Évite aussi les autoroutes gratuites",
                "option_avoid_ferries_desc": "Itinéraires terrestres uniquement",
                "btn_optimize_route": "Optimiser l'Itinéraire",
                "btn_calculate_route": "🔄 Calculer l'Itinéraire",
                "route_info_title": "📊 Informations",
                "distance_label": "Distance :",
                "duration_label": "Durée :",
                "btn_save_route": "✓ Enregistrer l'Itinéraire",
                "route_error_min_stops": "Au moins 2 étapes requises",
                "route_error_maps_not_init": "Google Maps non initialisé",
                "route_error_origin_dest_missing": "Point de départ ou d'arrivée manquant",
                "route_error_calc_prefix": "Erreur de calcul d'itinéraire : ",
                "route_error_generic_prefix": "Erreur : ",
                "fetch_error_default": "Erreur lors du chargement des voyages. Réessayez.",
                "partenza_marker_title": "Départ",
                "arrivo_marker_title": "Arrivée",
                "stop_marker_title": "Étape {index} : {name}",
                "alert_select_address_from_suggestions": "Sélectionnez une adresse parmi les suggestions",
                "alert_select_from_google_suggestions": "Veuillez sélectionner une adresse parmi les suggestions Google.",
                "alert_no_geometry": "L'adresse sélectionnée ne contient pas de coordonnées géographiques.",
                "alert_calc_route_first": "Calculez l'itinéraire sur la carte avant d'enregistrer.",
                "alert_save_before_export": "Enregistrez l'itinéraire avant d'exporter.",
                "alert_route_save_default_error": "Erreur lors de l'enregistrement de l'itinéraire.",
                "alert_route_saved": "Itinéraire enregistré avec succès !",
                "manual_waypoint_note": "Étape ajoutée manuellement",
                "default_travel_name": "Transporteur {carrier} - Itinéraire du {date}",
                "confirm_remove_grouped_docs": "Cette étape contient {count} documents groupés ({name}). Supprimer l'étape et tous les documents associés ?",
                "label_sede_legale": "Siège Social",
                "label_deposito": "Dépôt",
                "generate_ddt": "Générer DDT",
                "vehicle_selection": "Sélection du Véhicule"
            }
        },
        "at": {
            "breadcrumb": {
                "pianificazione_attivita": "Planification des activités",
                "lista_attivita": "Liste des activités",
                "lista_ordini": "Liste des commandes"
            },
            "fields": {
                "title": "Titre",
                "description": "Description",
                "client": "Client",
                "job": "Affaire",
                "owner": "Assigné",
                "start_date": "Date de début",
                "end_date": "Date de fin",
                "delivery_date": "Date de livraison",
                "priority": "Priorité",
                "status": "Statut",
                "date": "Date",
                "user": "Utilisateur",
                "hours": "Heures",
                "total_hours": "Heures totales",
                "work_date": "Date de travail",
                "hours_worked": "Heures travaillées",
                "work_description": "Description du travail effectué",
                "order_number": "N° Commande",
                "order_date": "Du",
                "actions": "Actions",
                "expected_delivery_date": "Livraison prévue"
            },
            "filters": {
                "all_select": "Toutes"
            },
            "actions": {
                "new_activity": "+ Nouvelle Activité",
                "edit": "Modifier",
                "add": "Ajouter",
                "update": "Mettre à jour",
                "close": "Fermer",
                "details": "Détails",
                "register_time": "Enregistrer le temps",
                "work_details": "Détails du travail",
                "delete": "Supprimer",
                "cancel": "Annuler",
                "confirm": "Confirmer",
                "generate_activities": "Générer des activités",
                "add_activity_btn": "+ Ajouter une activité",
                "remove_activity": "Supprimer l'activité",
                "select_user": "Sélectionnez un utilisateur",
                "searching": "🔍 Recherche en cours...",
                "start_typing_client": "Commencez à taper pour rechercher un client..."
            },
            "priority": {
                "bassa": "Basse",
                "media": "Moyenne",
                "alta": "Haute",
                "critica": "Critique"
            },
            "status": {
                "nuova": "Nouvelle",
                "assegnata": "Assignée",
                "schedulata": "Planifiée",
                "in_lavorazione": "En cours",
                "completata": "Terminée"
            },
            "messages": {
                "success": "Succès",
                "error": "Erreur",
                "creating": "Création en cours...",
                "updating": "Mise à jour en cours...",
                "deleting": "Suppression en cours...",
                "registering": "Enregistrement...",
                "activity_created": "Activité créée avec succès",
                "activity_updated": "Activité mise à jour avec succès",
                "activity_deleted": "Activité supprimée avec succès",
                "error_create": "Une erreur s'est produite lors de la création de l'activité",
                "error_update": "Une erreur s'est produite lors de la mise à jour de l'activité",
                "error_delete": "Une erreur s'est produite lors de la suppression de l'activité",
                "time_registered_title": "Temps enregistré",
                "creation_completed_title": "Création d'activités terminée",
                "loading_details": "Chargement des détails...",
                "loading_activities": "Chargement des activités...",
                "no_time_records": "Aucun enregistrement de temps trouvé pour cette activité.",
                "activity_not_found": "Activité non trouvée",
                "work_time_registered": "Temps de travail enregistré avec succès"
            },
            "lista_attivita": {
                "title": "Liste des Activités",
                "details_modal_title": "Détails de l'activité",
                "edit_modal_title": "Modifier l'activité",
                "add_modal_title": "Ajouter une activité",
                "time_modal_title": "Enregistrer le Temps de Travail",
                "work_details_modal_title": "Détails du Travail",
                "delete_confirm_title": "Confirmer la Suppression de l'Activité",
                "delete_confirm_text": "Êtes-vous sûr de vouloir procéder à la suppression de l'activité ?",
                "client_label": "Client :",
                "total_hours_label": "Heures totales :",
                "current_total_hours": "Heures totales actuelles :",
                "total_registered_hours": "Total des heures enregistrées :",
                "hours_placeholder": "Ex. 2.5",
                "work_description_placeholder": "Décrivez brièvement le travail effectué...",
                "work_date_placeholder": "Sélectionnez la date de travail"
            },
            "lista_ordini": {
                "preview_modal_title": "Aperçu des Activités à Créer",
                "activities_to_create_prefix": "Seront créées",
                "activities_to_create_suffix": "nouvelles activités pour la commande sélectionnée",
                "existing_activities_suffix": "activités existent déjà",
                "invalid_activities_suffix": "activités invalides (description manquante)",
                "description_label": "Description :",
                "description_placeholder": "Saisissez la description de l'activité",
                "description_required": "La description est obligatoire",
                "start_date_label": "Date de début :",
                "end_date_label": "Date de fin :",
                "delivery_date_label": "Livraison prévue :",
                "owner_label": "Assigné :",
                "creating": "Création...",
                "confirm_creation": "Confirmer la Création",
                "activities_created_count_suffix": "activités ont été créées."
            }
        },
        "go": {
            "breadcrumb": {
                "gestione_ordini": "Gestion des commandes",
                "lista_ordini": "Liste des commandes",
                "lista_proposte_offerte": "Liste des propositions/devis",
                "visualizza_mail": "Voir l'e-mail"
            },
            "doc_status": {
                "order": "Commande",
                "offert": "Devis",
                "draft": "Proposition"
            },
            "tabs": {
                "main": "DONNÉES PRINCIPALES",
                "document_notes": "NOTES DU DOCUMENT",
                "shipping": "LIVRAISON",
                "charges": "FRAIS"
            },
            "actions": {
                "save_changes": "Enregistrer les modifications",
                "save_changes_unsaved": "⚠️ Enregistrer les modifications",
                "convert_to_offer": "Convertir en devis",
                "import_from_offer": "Importer depuis devis",
                "send_to_mago": "Envoyer à Mago",
                "edit_on_mago": "Modifier sur Mago",
                "customer_signature": "Signature client",
                "dms": "DMS",
                "delete": "Supprimer",
                "cancel": "Annuler",
                "confirm": "Confirmer",
                "apply": "Appliquer",
                "send": "Envoyer",
                "save": "Enregistrer",
                "new": "Nouveau",
                "open": "Ouvrir",
                "continue": "Continuer",
                "back_to_orders": "Retour à la gestion des commandes",
                "back_to_list": "Retour à la liste",
                "download_eml": "Télécharger .EML",
                "new_order": "Nouvelle commande",
                "open_related_order": "Ouvrir la commande associée",
                "clear_signature": "Effacer la signature",
                "save_signature": "Enregistrer la signature",
                "load_customer_notes": "Charger les notes client",
                "request_approval": "Demander l'approbation",
                "request_correction": "Demander une correction",
                "approve_document": "Approuver le document",
                "reject_document": "Rejeter le document",
                "add_goods": "Ajouter des marchandises",
                "add_service": "Ajouter un service",
                "add_note": "Ajouter une note",
                "add_descriptive": "Ajouter une description",
                "insert_as_out_of_stock": "Insérer comme hors stock",
                "no_only_main": "Non, principal seulement",
                "yes_include_all": "Oui, inclure tous",
                "print": "Imprimer le document",
                "select": "Sélectionner",
                "send_mail": "Envoyer un e-mail"
            },
            "fields": {
                "number": "Numéro",
                "doc_type": "Type de document",
                "customer": "Client",
                "contact": "Contact",
                "date": "Du",
                "validity_end": "Fin de validité",
                "expected_delivery": "Date de livraison prévue",
                "mago_order_number": "Numéro de commande Mago",
                "mago_quota_number": "Numéro d'offre Mago",
                "customer_order_ref": "Réf. commande client",
                "agent": "Agent",
                "customer_discount": "Remise client",
                "payment": "Paiement",
                "priority": "Priorité",
                "created_by": "Créé par :",
                "last_modified_by": "Dernière modification par :",
                "document_details": "Détails du document",
                "row_type": "Type de ligne",
                "item_code": "Code article",
                "description": "Description",
                "position": "Position",
                "row_status": "Statut",
                "pricelist": "Tarif",
                "uom": "Unité de mesure",
                "uom_short": "UM",
                "qty": "Quantité",
                "price": "Prix",
                "discount": "Remise",
                "taxable": "Base imposable",
                "row_note": "Note",
                "tax_code_col": "Code TVA",
                "row_total": "Total ligne",
                "tax_code_full": "Code TVA",
                "tax_amount": "Taxe",
                "total": "Total",
                "item_article": "Article",
                "homogeneous_ctg": "Catégorie homogène",
                "commodity_ctg": "Catégorie de marchandise",
                "product_ctg": "Catégorie de produit",
                "item_type": "Type d'article",
                "producer": "Producteur",
                "info": "Info",
                "subject": "Objet",
                "sender": "Expéditeur",
                "date_label": "Date",
                "assigned_user": "Utilisateur assigné",
                "priority_label": "Priorité :",
                "tax_code_iva": "Code TVA",
                "taxable_total": "Total imposable",
                "vat_percentage": "% TVA",
                "vat_amount": "Montant TVA",
                "row_total_vat": "Total ligne (TVA incluse)",
                "allowances": "Montant remise",
                "goods_total": "Total marchandises",
                "services_total": "Total services",
                "discount_total": "Total remise",
                "vat_total": "Total TVA",
                "document_total": "Total document",
                "freesample_total": "Total échantillons",
                "to_pay": "Total à payer",
                "raee_total": "Total RAEE",
                "transport_charges": "Frais de transport :",
                "collection_charges": "Frais d'encaissement :",
                "accessory_charges": "Frais accessoires :",
                "vat_breakdown": "Détail TVA",
                "delivery_branch": "Site de livraison",
                "generic_branch": "Site générique",
                "selected_branch": "Site sélectionné :",
                "carrier": "Premier transporteur",
                "select_carrier": "Sélectionner transporteur",
                "to_determine": "À déterminer",
                "select_placeholder": "Sélectionner",
                "sale_type": "Type de vente",
                "sale_type_normal": "Normal",
                "sale_type_total_free_sample": "Cadeau total",
                "sale_type_taxable_free_sample": "Cadeau imposable",
                "none_specified": "Aucun spécifié",
                "unit_value": "Valeur unitaire",
                "net_price": "Prix net",
                "extra_discount_default": "Remise supplémentaire par défaut :",
                "item_notes": "Notes article",
                "cod_iva_label": "Code TVA :",
                "packages": "Colis",
                "exclude_print": "Exclure de l'impression",
                "exclude_invoice": "Exclure de la facture",
                "exclude_ddt": "Exclure du DDT"
            },
            "line_types": {
                "goods": "Marchandises",
                "service": "Service",
                "descriptive": "Descriptive",
                "note": "Note"
            },
            "availability": {
                "available": "Disponible",
                "not_available_with_orders": "Non disponible avec commandes entrantes",
                "not_available": "Non disponible",
                "no_info": "Information non disponible"
            },
            "vat_breakdown": {
                "no_details": "Aucun détail TVA disponible",
                "total_row": "TOTAL"
            },
            "document_notes_placeholder": "Saisir les notes du document (elles seront incluses dans l'impression et sur Mago)",
            "private_note_placeholder": "Saisir des notes à usage interne (elles ne seront pas incluses dans l'impression)",
            "modals": {
                "confirm_delete_title": "Confirmer la suppression",
                "confirm_delete_content": "Êtes-vous sûr de vouloir supprimer ce document ?",
                "confirm_delete_mago_note": "(Le document MAGO correspondant {doc_no} sera également supprimé.)",
                "confirm_delete_mago_quota_note": "(L'offre MAGO correspondante {doc_no} sera également supprimée.)",
                "confirm_delete_row_title": "Confirmer la suppression de la ligne",
                "confirm_delete_row_content": "Êtes-vous sûr de vouloir supprimer cette ligne ? Les modifications ne seront appliquées qu'en enregistrant le document.",
                "confirm_signature_title": "Confirmer l'enregistrement de la signature",
                "confirm_signature_content": "Êtes-vous sûr de vouloir enregistrer la signature ? Cela bloquera toute modification future du document.",
                "min_reorder_qty_title": "Quantité minimale de réapprovisionnement",
                "min_reorder_qty_content": "La quantité sélectionnée dépasse la disponibilité totale. Cet article a une quantité minimale de réapprovisionnement fournisseur de {qty}, voulez-vous continuer ?",
                "email_addresses_title": "Sélection des adresses e-mail",
                "email_addresses_content": "Voulez-vous également inclure les adresses e-mail des personnes de contact liées au client ?",
                "confirm_delete_mail_title": "Confirmer la suppression de l'e-mail",
                "confirm_delete_mail_content": "Êtes-vous sûr de vouloir supprimer cet e-mail ?",
                "detail_modal_title": "Détail de la ligne",
                "out_of_stock_label": "hors stock",
                "select_goods": "marchandises",
                "select_service": "service",
                "select_article": "article",
                "select_kit_component": "composant de kit",
                "customer_notes_title": "Notes client :",
                "internal_notes": "Notes à usage interne",
                "internal_notes_2": "Notes internes",
                "other_notes": "Autres notes",
                "no_customer_notes": "Aucune note trouvée pour ce client.",
                "dms_attachments": "Pièces jointes DMS",
                "attachment_label": "° Pièce jointe",
                "email_send_title": "Envoi d'e-mail",
                "to_placeholder": "Destinataires",
                "cc_placeholder": "Ajouter en copie (séparés par un point-virgule)",
                "subject_placeholder": "Objet",
                "body_placeholder": "Texte du message..."
            },
            "deep_tables": {
                "select_payment": "Sélectionner paiement",
                "select_customer": "Sélectionner client",
                "select_contact": "Sélectionner contact",
                "select_homogeneous_ctg": "Sélectionner catégorie homogène",
                "select_commodity_ctg": "Sélectionner catégorie de marchandise",
                "select_product_ctg": "Sélectionner catégorie de produit",
                "select_producer": "Sélectionner producteur",
                "select_tax_code": "Sélectionner code TVA",
                "select_collection_tax_code": "Sélectionner code TVA pour frais d'encaissement",
                "select_offer": "Sélectionner devis",
                "select_item_type": "Sélectionner type d'article",
                "show_disabled": "Afficher aussi les désactivés",
                "use_contacts": "Utiliser les contacts",
                "no_elements": "Aucun élément disponible"
            },
            "lista_ordini": {
                "title": "Liste des commandes",
                "title_drafts": "Liste des propositions/devis",
                "label": "Liste des commandes web",
                "label_drafts": "Liste des propositions/devis web"
            },
            "lista_mail": {
                "title": "Liste des e-mails",
                "show_filter": "Afficher e-mails",
                "new_unread": "Nouveaux/utilisateur",
                "all_active": "Tous actifs",
                "mail_detail": "Détail e-mail",
                "loading": "Chargement...",
                "select_email": "Sélectionnez un e-mail pour le visualiser",
                "attachments_title": "Liste des pièces jointes"
            },
            "messages": {
                "positions_modified": "Positions modifiées. N'oubliez pas d'enregistrer le document.",
                "import_success": "Importation effectuée avec succès",
                "import_error": "Erreur lors de l'importation",
                "import_data_update_error": "Importation terminée mais erreur lors de la mise à jour des données",
                "qty_must_be_positive": "La quantité doit être supérieure à 0",
                "item_already_in_mago": "Article déjà enregistré dans Mago, modifiez le code article ou utilisez Ajouter marchandises/service",
                "validation_error": "Erreur lors de la validation de la ligne personnalisée",
                "uom_required": "L'unité de mesure doit être spécifiée",
                "item_or_desc_required": "L'article ou la description doivent être spécifiés",
                "row_added": "Ligne ajoutée. N'oubliez pas d'enregistrer le document.",
                "changes_applied": "Modifications appliquées. N'oubliez pas d'enregistrer le document.",
                "add_cancelled": "Ajout d'article annulé.",
                "row_removed": "Ligne supprimée. N'oubliez pas d'enregistrer le document.",
                "doc_deleted": "Document supprimé avec succès.",
                "delete_error": "Erreur lors de la suppression",
                "doc_saved": "Document enregistré avec succès",
                "save_error": "Erreur lors de l'enregistrement",
                "save_data_error": "Document enregistré mais erreur lors de la mise à jour des données",
                "sending_to_mago": "Envoi de la commande à Mago en cours...",
                "sending_quote_to_mago": "Envoi du devis à Mago en cours...",
                "order_sent_to_mago": "Commande envoyée à Mago avec succès",
                "offer_sent_to_mago": "Offre envoyée à Mago avec succès",
                "mago_send_error": "Erreur lors de l'envoi à Mago",
                "mago_data_update_error": "Commande envoyée mais erreur lors de la mise à jour des données",
                "saving": "Enregistrement en cours...",
                "saving_signature": "Enregistrement du document signé sur Mago en cours...",
                "signature_saved": "Signature enregistrée avec succès sur Mago",
                "signature_error": "Erreur lors de l'enregistrement de la signature",
                "updating_prices": "Mise à jour des prix en cours...",
                "deleting": "Suppression en cours...",
                "signature_required": "Veuillez compléter la signature avant d'enregistrer.",
                "select_customer_before_mail": "Sélectionnez un client avant d'envoyer l'e-mail",
                "select_contact_before_mail": "Sélectionnez un contact avant d'envoyer l'e-mail",
                "fetching_emails": "Récupération des adresses e-mail...",
                "generating_pdf": "Génération du PDF et envoi de l'e-mail...",
                "email_recipient_required": "Veuillez saisir au moins un destinataire",
                "doc_deleted_success": "Document supprimé avec succès.",
                "doc_not_found": "Document non trouvé.",
                "invalid_doc_id": "ID de document invalide.",
                "loading": "Chargement...",
                "unit_value_required": "La valeur unitaire doit être spécifiée",
                "error_loading_emails": "Erreur lors de la récupération des e-mails",
                "error_sending_email": "Erreur lors de l'envoi de l'e-mail",
                "email_body_template": "Cher client {companyname},\nVeuillez trouver ci-joint le document en objet.\n\nCordialement."
            },
            "headers": {
                "sender": "Expéditeur",
                "subject": "Objet",
                "date": "Date",
                "doc_number": "Numéro",
                "doc_date": "Date",
                "status": "Statut",
                "customer_contact": "Client/Contact",
                "customer": "Client",
                "author": "Auteur",
                "approval": "Approbation",
                "sent_to_mago": "Envoyé à Mago",
                "converted_to_order": "Converti en commande",
                "code": "Code",
                "company_name": "Raison sociale",
                "address": "Adresse",
                "zip_code": "Code postal",
                "city": "Ville",
                "county": "Département",
                "country": "Pays",
                "fiscal_code": "Code fiscal",
                "email": "E-mail",
                "phone": "Téléphone",
                "payment_desc": "Description",
                "discount_pct": "Pourcentage de remise",
                "collection_charges": "Frais d'encaissement",
                "tax_rate": "% Taux de taxe",
                "department": "Département",
                "producer": "Producteur",
                "product_ctg": "Catégorie de produit",
                "item_type": "Type d'article",
                "homogeneous_ctg": "Catégorie homogène",
                "commodity_ctg": "Catégorie de marchandise",
                "to_approve": "À approuver",
                "to_correct": "À corriger"
            },
            "approval_status": {
                "not_requested": "Non demandée",
                "requested": "Demandée",
                "approved": "Approuvée",
                "rejected": "Rejetée"
            },
            "parameters": {
                "email_view_label": "Vue divisée",
                "email_view_description": "Vue divisée e-mail | Commandes",
                "email_send_label": "Envoi d'e-mail",
                "email_send_description": "Activer l'envoi d'e-mail depuis le portail avec PDF joint",
                "copy_docno_to_externalordno_label": "Copier numéro document portail vers ExternalOrdNo",
                "copy_docno_to_externalordno_description": "Écrire le numéro de document du portail dans ExternalOrdNo de Mago (ExternalOrderId sera rempli indépendamment)",
                "block_changes_after_mago_sent_label": "Bloquer les modifications après envoi à Mago",
                "block_changes_after_mago_sent_description": "Empêcher la suppression et la modification du document sur Mago une fois envoyé (ne pas utiliser avec e-mail ou gestion de signature)",
                "filter_customers_by_agent_label": "Filtrer les clients par agent",
                "filter_customers_by_agent_description": "Si activé, seuls les clients associés à l'agent du compte connecté seront affichés",
                "block_pricelist_change_label": "Bloquer le changement de tarif",
                "block_pricelist_change_description": "Empêche la modification du tarif dans les lignes de commande",
                "check_available_on_row_insert_label": "Vérifier la disponibilité à la création de ligne",
                "check_available_on_row_insert_description": "Vérifier la disponibilité de l'article lors de l'insertion d'une nouvelle ligne si la quantité minimale de réapprovisionnement fournisseur est > 0",
                "allow_pricerow_zero_label": "Autoriser les lignes à prix zéro",
                "allow_pricerow_zero_description": "Permet d'insérer des lignes avec un prix unitaire de zéro qui afficheront \"à déterminer\" aussi à l'impression",
                "use_thousand_separator_label": "Séparateur de milliers",
                "use_thousand_separator_description": "Si activé, les totaux du document sont affichés avec le séparateur de milliers (ex. 1 234,56)",
                "handle_signature_label": "Gestion de signature",
                "handle_signature_description": "Activer la gestion de signature de confirmation pour les commandes (0 désactivé, 1 client seulement)",
                "show_dms_content_label": "Afficher les contenus DMS",
                "show_dms_content_description": "Afficher les documents liés via DMS dans l'interface commande",
                "show_customers_extra_data_label": "Afficher données supplémentaires dans la recherche client",
                "show_customers_extra_data_description": "Afficher le code fiscal, l'e-mail et le numéro de téléphone du client dans la recherche depuis commande",
                "show_items_extra_data_label": "Afficher données supplémentaires dans la recherche article",
                "show_items_extra_data_description": "Afficher l'emplacement, la catégorie RAEE et le pourcentage de commission agent. 0 = désactivé, 1 = emplacement (MA_ItemsGoodsData.Location), 2 = emplacement (MA_ItemsWMSZones.FixedBinPicking)",
                "show_items_notes_label": "Afficher les notes d'article",
                "show_items_notes_description": "Afficher les notes d'article (de vente) dans le détail de ligne. Ralentit le calcul des totaux de ligne, utiliser seulement si nécessaire",
                "divide_documents_by_creator_label": "Séparer les documents par auteur (admin voit tout)",
                "divide_documents_by_creator_description": "Si activé, les utilisateurs ne verront que les documents qu'ils ont créés, les admins verront tous les documents",
                "pricelist_imel_label": "Gestion des tarifs personnalisés IMEL",
                "pricelist_imel_description": "Si activé, les critères de sélection des tarifs spécifiques à IMEL seront utilisés",
                "force_admin_approval_label": "Forcer l'approbation admin",
                "force_admin_approval_description": "Si activé, les commandes nécessiteront l'approbation d'un admin avant de pouvoir passer dans Mago",
                "reset_qty_on_uom_change_label": "Réinitialiser la quantité au changement d'unité de mesure",
                "reset_qty_on_uom_change_description": "Si activé, la quantité sera réinitialisée lorsque l'unité de mesure est changée",
                "filter_items_by_pricelist_label": "Filtrer les articles par tarif",
                "filter_items_by_pricelist_description": "Si ce tarif est spécifié, il est utilisé pour filtrer les articles disponibles et défini par défaut",
                "show_suggested_price_label": "Afficher le prix suggéré",
                "show_suggested_price_description": "Si activé, le prix de catalogue sera affiché dans le champ prix suggéré des infos article",
                "show_pricelist_info_label": "Afficher les infos tarifs article",
                "show_pricelist_info_description": "Affiche un bouton d'information sur les tarifs de l'article dans la ligne de commande et dans la fiche article",
                "personalizzazioni_imel_label": "Personnalisations IMEL",
                "personalizzazioni_imel_description": "Activer ou désactiver les personnalisations spécifiques à IMEL"
            }
        },
        "modules": {
            "anagrafiche": "Données personnelles",
            "visite-commerciali": "Visites Commerciales",
            "reception-digitale": "Registre des Visiteurs",
            "contratti": "Contrats",
            "attivita": "Activités",
            "estratto-conto": "Relevé de Compte",
            "gestione-magazzino": "Gestion du Magasin",
            "inventario": "Inventaire",
            "ricezione-merce": "Réception de Marchandise de Commande Fournisseur",
            "evasione-ordini": "Exécution des Commandes",
            "rettifica": "Rectification",
            "calendario": "Calendrier",
            "mappa": "Carte",
            "contatti": "Contacts",
            "clienti-fornitori": "Clients et Fournisseurs",
            "registro": "Registre",
            "visitatori-abituali": "Visiteurs Habituels",
            "badge": "Badge",
            "report": "Rapport",
            "real-time": "Temps réel",
            "rinnovo": "Renouvellement",
            "emissione": "Émission",
            "ricerca-contratti": "Recherche de Contrats",
            "nuovo-contratto": "Nouveau Contrat",
            "controllo-copie": "Contrôle des Copies",
            "report-pacchetti-ore": "Rapport des Paquets d'Heures",
            "lista-ordini": "Liste des Commandes",
            "lista-attivita": "Liste des Activités",
            "rapportini-intervento": "Rapports d'Intervention",
            "ricezione-veneta": "Réception de Marchandise Veneta",
            "conferma_bolle_carico": "Gestion des Bons de Livraison et Positionnement de la Marchandise",
            "analisi": "Analyse",
            "ordinato-agente": "Trié par Agent",
            "fatturato-agente": "Chiffre d'affaires par agent",
            "generazione-itinerari": "Génération d'Itinéraires",
            "ricezione-merce-senza-ordine": "Chargement de Marchandise sans Commande Fournisseur",
            "rilevazione-commesse": "Suivi des Commandes",
            "storico-rilevazioni": "Historique des Suivis",
            "rilevazione-ora-su-commessa": "Suivi des Heures sur Commande",
            "info-articoli": "Info Articles",
            "gestione-ordini": "Gestion des Commandes",
            "gestione-modelli-contratti": "Gestion des Modèles de Contrats",
            "lista-offerte": "Liste des Propositions/Offres",
            "report-odierno": "Rapport du Jour",
            "report-visite": "Rapport des Visites",
            "report-consegne": "Rapport des Livraisons",
            "sblocco-ingressi": "Déblocage des Entrées",
            "registro-uscita": "Registre de Sortie",
            "scarico-componenti": "Déchargement des Composants",
            "registri-personalizzati": "Registres Personnalisés",
            "percorsi-vettori": "Parcours des Transporteurs",
            "gestione_ubicazioni_icam": "Gestion des Emplacements ICAM",
            "accesso-totem": "Accès Totem",
            "commit-in-beta": "Commit en Beta",
            "confronto-stradari": "Comparaison des Cartes Routières",
            "carica-excel": "Charger Excel",
            "gestione-itinerari": "Gestion des Itinéraires",
            "associa-barcode": "Associer le Code-Barres",
            "approvazione-bolle-temp": "Approbation des Bons de Livraison Temporaires",
            "registrazione-ticket": "Enregistrement des Tickets",
            "gestione-produzione": "Gestion de la Production",
            "buono-prelievo": "Bon de Prélèvement",
            "consuntiva-produzione": "Consignation de la Production",
            "resoconto-odp": "Rapport des Ordres de Production",
            "picking-list": "Picking",
            "reminders-attivita": "Rappels",
            "riconoscimento-documenti": "Reconnaissance de Documents",
            "simulazione-costificazione": "Simulation de Coût",
            "riconoscimento-documenti-ai": "Reconnaissance de Documents AI",
            "prove-di-consegna": "Preuves de Livraison",
            "affidamenti": "Attributions"
        },
        "auth": {
            "failed": "Ces informations d'identification ne correspondent pas à nos enregistrements.",
            "password": "Le mot de passe fourni est incorrect.",
            "throttle": "Trop de tentatives de connexion. Veuillez réessayer dans {seconds} secondes.",
            "already_logged_in": "L'utilisateur est déjà connecté depuis un autre appareil ou emplacement.",
            "force_logout_prompt": "Cliquez ci-dessous pour forcer la déconnexion de l'autre session et continuer.",
            "force_logout_button": "Forcer la Déconnexion et Continuer",
            "too_many_customer_sessions": "Trop de sessions simultanées pour ce client.",
            "log_in_title": "Connexion",
            "email": "Email",
            "password_label": "Mot de passe",
            "remember_me": "Se souvenir de moi",
            "forgot_password": "Mot de passe oublié ?",
            "session_already_active": "Session Déjà Active"
        },
        "customers": {
            "molino-di-borgo": {
                "ui": {
                    "ulteriore_sconto": "Remise supplémentaire"
                }
            }
        },
        "vc": [],
        "passwords": {
            "reset": "La password è stata reimpostata!",
            "sent": "Ti abbiamo inviato una email con il link per il reset della password!",
            "throttled": "Per favore, attendi prima di riprovare.",
            "token": "Questo token di reset della password non è valido.",
            "user": "Non riusciamo a trovare un utente con questo indirizzo email."
        },
        "sc": {
            "scarico_component_title": "Déchargement de composant",
            "article": "Article:",
            "description": "Description:",
            "available": "Disponible:",
            "minimum_stock": "Stock minimum:",
            "quantity_less_than_minimum_stock": "La quantité prélevée est inférieure au stock minimum",
            "lot": "Lot",
            "quantity_picked": "Quantité prélevée:",
            "enter_barcode_and_select_storage": "Entrez un code-barres et sélectionnez un entrepôt",
            "item_not_found": "Article non trouvé",
            "search_error": "Erreur de recherche",
            "product_not_available": "Produit non disponible en entrepôt",
            "quantity_reduced_to_max": "Quantité réduite au maximum disponible",
            "invalid_quantity": "Quantité invalide",
            "quantity_exceeds_availability": "La quantité dépasse la disponibilité",
            "discharge_completed": "Déchargement terminé avec succès",
            "discharge_error": "Erreur lors du déchargement",
            "loading_discharge": "Déchargement in corso... ",
            "magiclink_note": "Déchargement composants - {item}",
            "select_product": "Sélectionner le produit",
            "multiple_products_found": "Plusieurs produits trouvés. Sélectionnez le bon:",
            "csv_preview": "Aperçu CSV",
            "quantity": "Quantité",
            "confirm_all": "Confirmer tout",
            "select_storage_first": "Veuillez d'abord sélectionner un entrepôt",
            "empty_or_invalid_csv": "CSV vide ou invalide",
            "processing_csv": "Traitement du CSV...",
            "all_items_discharged": "Tous les articles ont été déchargés avec succès",
            "discharge_with_errors": "Terminé: {success} succès, {errors} erreurs",
            "csv_data": "Données CSV",
            "not_found": "Non trouvé",
            "found": "Trouvé",
            "no_valid_items": "Aucun article valide à décharger",
            "storage": "Site:",
            "storage_mismatch": "Les dépôts ne correspondent pas",
            "lot_mismatch": "Les lots ne correspondent pas",
            "insufficient_stock": "Stock insuffisant",
            "storage_reason_mapping": "Association Dépôts - Motifs",
            "movement_reason": "Motif du mouvement",
            "select_reason": "Sélectionner un motif",
            "invalid_csv_format": "Format CSV invalide. L'en-tête doit avoir exactement {count} colonnes dans cet ordre: {header}",
            "to_discharge": "à décharger",
            "discharged": "déchargé",
            "discharge_with_errors_summary": "Terminé {success} sur {total} dépôts.",
            "missing_reason_for_storage": "Motif manquant pour le dépôt {storage}",
            "no_items_to_process": "Aucun article valide à traiter",
            "select_storage_placeholder": "-- Sélectionner un dépôt --",
            "select_reason_placeholder": "-- Sélectionner un motif --",
            "reason_after_first_item_info": "Le motif de mouvement pourra être sélectionné après l'ajout du premier article",
            "specificator_customer": "Client",
            "specificator_supplier": "Fournisseur",
            "stock_short": "Stock:",
            "stock": "Stock:",
            "duplicate_item_title": "Article déjà scanné",
            "duplicate_item_message": "Vous avez déjà scanné ce produit, voulez-vous l'ajouter à nouveau?",
            "pending_items_title": "Articles à décharger",
            "discharge_all": "Tout décharger",
            "reasons_per_storage": "Motifs par dépôt",
            "table_storage": "Dépôt",
            "table_reason": "Motif",
            "header_item": "Article",
            "header_description": "Description",
            "header_lot": "Lot",
            "header_quantity": "Quantité",
            "header_uom": "UdM",
            "csv_header_item": "Article",
            "csv_header_lot_comparison": "Lot (CSV - MAGO)",
            "csv_header_storage_comparison": "Dépôt (CSV - MAGO)",
            "csv_header_book_inv": "Stock",
            "csv_header_quantity": "Qté à décharger",
            "csv_header_status": "Statut",
            "batch_processing_error": "Erreur lors du traitement par lot",
            "error_generic": "Erreur",
            "discharge_during_error": "Erreur lors du déchargement",
            "lot_search": "Recherche par lot",
            "choose_quantity": "Choisir la quantité",
            "item": "Article",
            "item_or_barcode": "Article ou code-barres"
        },
        "ec": {
            "parameters": {
                "force_agent_label": "Forcer l'agent",
                "force_agent_description": "Si activé, les comptes avec un agent assigné ne pourront pas changer l'agent du relevé de compte"
            }
        },
        "ui": {
            "welcome_back": "Bon retour",
            "user_profile": {
                "link_label": "Profil utilisateur",
                "profile_information": {
                    "title": "Informations du profil",
                    "description": "Mettez à jour les informations de votre profil et votre adresse e-mail."
                },
                "password_update": {
                    "title": "Mettre à jour le mot de passe",
                    "description": "Assurez-vous d'utiliser un mot de passe long et aléatoire pour rester en sécurité."
                }
            },
            "user_management": "Gestion des utilisateurs",
            "customer_management": "Gestion des client",
            "customer_overview": "Aperçu des clients",
            "current_password": "Mot de passe actuel",
            "new_password": "Nouveau mot de passe",
            "confirm_password": "Confirmer le mot de passe",
            "proceed": "Procéder",
            "name": "Nom",
            "email": "Email",
            "choose_date": "Choisir une date",
            "choose_expired": "Date d'expiration",
            "delete_confirmation": {
                "title": "Confirmer la suppression",
                "description": "Êtes-vous sûr de vouloir supprimer cet élément ? Cette action ne peut pas être annulée."
            },
            "cancel": "Annuler",
            "delete": "Supprimer",
            "filters": "Filtres",
            "all_filters": "Tous les filtres",
            "change_customer": "Changer de client",
            "ui_policy": "Règles IU",
            "loading": "Chargement...",
            "order_management": "Gestion des commandes",
            "item_info": {
                "title": "Infos Article",
                "loading": "Chargement des données article...",
                "general_data": "Données Générales",
                "warehouse_status": "Situation du Magasin",
                "item_code": "Article",
                "description": "Description",
                "uom": "Unité de mesure",
                "homogeneous_ctg": "Catégorie homogène",
                "commodity_ctg": "Catégorie de marchandise",
                "item_type": "Type d'article",
                "tax_code": "Code TVA",
                "base_price": "Prix de base",
                "sale_bar_code": "Code-barres de vente",
                "internal_note": "Notes internes",
                "stock": "Stock",
                "availability": "Disponibilité",
                "ordered_purch": "Commandé au fournisseur",
                "reserved_sale_ord": "Réservé Commandes Clients",
                "reserved_by_prod": "Réservé Production",
                "ordered_to_prod": "Quantité en production",
                "theoretical_availability": "Disponibilité Théorique",
                "minimum_sale_qty": "Qté minimale vendable",
                "min_order_qty": "Qté min réapprov. fournisseur",
                "expected_arrival_date": "Date d'arrivée prévue",
                "suggested_price": "Prix conseillé",
                "no_data": "Aucune donnée trouvée pour l'article {item}.",
                "pricelist_section_title": "Tarifs article",
                "pricelist_loading": "Chargement des tarifs...",
                "pricelist_code": "Tarif",
                "pricelist_qty": "Qté max",
                "pricelist_price": "Prix",
                "pricelist_uom": "U.M.",
                "pricelist_discount": "Remise",
                "pricelist_no_data": "Aucun tarif trouvé pour cet article.",
                "last_sale_value": "Dernier prix de vente client",
                "never_sold_to_customer": "Article jamais vendu à ce client"
            },
            "out_of_inventory": "En rupture de stock",
            "loader": {
                "default_text": "Chargement en cours...",
                "subtitle": "Veuillez patienter"
            },
            "modal_message": {
                "close": "Fermer"
            },
            "notification": {
                "close": "Fermer"
            },
            "client_selector_modal": {
                "select_client": "Sélectionner un client",
                "active_filter": "Filtre actif :",
                "remove_filter": "Supprimer le filtre",
                "choose_client_title": "Choisir un Client",
                "search_placeholder": "Rechercher un client...",
                "all_clients": "Tous les clients",
                "no_clients_found": "Aucun client trouvé pour \"{query}\"",
                "close": "Fermer"
            },
            "richiesta_assistenza": {
                "title_it": "Richiesta assistenza",
                "title_en": "Assistance request",
                "sure_it": "Sei sicuro di voler contattare l'assistenza?",
                "sure_en": "Are you sure you want to contact support?",
                "cancel_it": "Annulla",
                "cancel_en": "Cancel",
                "confirm_it": "Conferma",
                "confirm_en": "Confirm",
                "sending_it": "Invio in corso...",
                "sending_en": "Sending...",
                "error_alert": "Une erreur s'est produite. Veuillez réessayer plus tard."
            },
            "emergency_info_modal": {
                "title": "Informations pour les Visiteurs",
                "understood": "J'ai compris"
            },
            "tables": {
                "select_default": "Sélectionner",
                "all": "Tous",
                "filter_input_placeholder": "🔎︎ Filtrer",
                "sort_by": "Trier par",
                "ascending": "Croissant",
                "descending": "Décroissant",
                "no_sort": "Aucun tri"
            }
        },
        "gm": {
            "scan_barcode_to_increment": "Scannez le code-barres pour augmenter la quantité reçues de",
            "reception_data": "Données de réception",
            "confirm_mismatched_quantities": "Confirmer les quantités non concordantes",
            "confirm_mismatched_quantities_description": "Certaines lignes ont une quantité totale (enregistrée + à enregistrer) différente de la quantité de commande.Voulez-vous continuer quand même ?",
            "item_not_found_or_already_pickedup": "Article {item} non trouvé ou déjà récupéré dans la liste de ces commandes",
            "barcode_mismatched": "Incohérence de code-barres",
            "normal": "Normal",
            "descriptive": "Descriptif",
            "kitchen": "Cuisine",
            "enter_the_quantity_to_be_shipped": "Indiquer la quantité à expédier de",
            "warehouse_choice": "Choix de l'entrepôt",
            "add_selected_items": "Ajouter les éléments sélectionnés",
            "insert_qty": "Saisir la quantité",
            "insert_qty_for": "Saisir la quantité pour",
            "article_details": "Détails de l'article",
            "select_inventory_session": "Sélectionner la session d'inventaire",
            "choose_session": "Choisir une session",
            "created_by": "Créé par",
            "deposit": "Dépôt",
            "delete_session": "Supprimer la session",
            "create_new_inventory_session": "Créer une nouvelle session d'inventaire",
            "choose_a_warehouse": "Choisir un entrepôt",
            "confirm_session_deletion": "Confirmer la suppression de la session",
            "confirm_session_deletion_confirm": "Êtes-vous sûr de vouloir supprimer cette session d'inventaire ? Cette action est irréversible.",
            "confirm_inventory": "Confirmer l'inventaire",
            "confirm_inventory_confirmation": "Voulez-vous confirmer et fermer cette session d'inventaire ? Elle ne sera plus modifiable.",
            "list_supplier_orders": "Liste des commandes fournisseurs",
            "list_client_orders": "Liste des commandes clients",
            "orphan_picking": "Prélèvement sans commande",
            "picking_rows": "Lignes de prélèvement",
            "select_same_customer_orders": "Veuillez sélectionner des commandes du même client.",
            "already_in_picking": "Déjà en prélèvement",
            "open_picking_overview": "Prélèvement en cours pour ce client",
            "open_picking_overview_desc": "Document n. {docno} avec {count} articles, dont {other} d'autres commandes du même client.",
            "other_order": "Autre commande",
            "confirm_picking": "Confirmer la collecte",
            "no_qty_to_confirm": "Veuillez saisir une quantité à prélever pour au moins une ligne.",
            "customer_not_found": "Client introuvable.",
            "picking_confirm_error": "Une erreur est survenue lors de la confirmation du prélèvement.",
            "picking_confirmed": "Prélèvement confirmé avec succès.",
            "select_item_variant": "Sélectionner la variante de l'article",
            "create_picking": "Créer le prélèvement",
            "search_customer": "Rechercher un client...",
            "start_typing_customer": "Commencez à taper pour rechercher un client...",
            "list_bills_of_lading": "Liste des bons de livraison",
            "filter_by": "Filtrer par",
            "client": "client",
            "confirm": "Confirmer",
            "icam_request_sent_successfully": "Demande ICAM envoyée avec succès",
            "confirm_bol": "Confirmer les bons de livraison",
            "confirm_bol_description": "Voulez-vous enregistrer les lignes des bons de livraison sélectionnés ? Cette opération est irréversible.",
            "send_request": "Envoyer la demande",
            "confirm_placing": "Confirmer la mise en place",
            "order_by_sales_person": "Liste des commandes par vendeur",
            "fatturato_per_agente": "Chiffre d'affair pour Agent",
            "search_by_warehouse": "Rechercher par dépôt",
            "search_by_lot_item": "Rechercher par lot ou article",
            "search_method": "Méthode de recherche",
            "by_storage": "Par Dépôt (Code-barres)",
            "by_item": "Par Code Article",
            "by_lot": "Par Lot",
            "by_barcode": "Code-barres uniquement",
            "select_item_lot": "Sélectionner Article/Lot",
            "insert_item_code": "Code Article...",
            "insert_lot": "Numéro de Lot...",
            "list_locations": "Liste des emplacements par article",
            "gestione_ubicazioni_icam": "Gestion des emplacements ICAM",
            "reset_filters": "Réinitialiser les filtres",
            "ordered_filter_period_1": "Filtre Commandé 1ère Période",
            "ordered_filter_period_2": "Filtre Commandé 2ème Période",
            "fatturato_filter_period_1": "Filtre Facturé 1ère Période",
            "fatturato_filter_period_2": "Filtre Facturé 2ème Période",
            "fatturato_filter_period_3": "Filtre Facturé 3ème Période",
            "from": "De",
            "to": "à",
            "agents_filter": "Filtre Agents",
            "all_agents": "ALL (tous les agents)",
            "totals": "Totaux",
            "agent": "Agent",
            "name": "Nom",
            "company_name": "Raison Sociale",
            "ordered": "Commandé",
            "ordered_period_2": "Commandé 2ème période",
            "agent_name": "Nom Agent",
            "city": "Ville",
            "address": "Adresse",
            "phone": "N° téléphone",
            "fatturato_period_1": "Facturé 1ère période",
            "fatturato_period_2": "Facturé 2ème période",
            "fatturato_period_3": "Facturé 3ème période",
            "order_analysis_by_agent_client": "Analyse des commandes par agent/client",
            "date_range_error": "La date \"De\" doit être inférieure ou égale à la date \"À\".",
            "overlap_error": "Attention!!! Vous avez sélectionné deux périodes temporelles qui se chevauchent.",
            "storage": "Dépôt",
            "qty_already_set": "Quantité déjà définie au maximum",
            "qty_exceeds_order": "La quantité pour l'article {item} dépasse la quantité commandée (max : {max}). Continuer ?",
            "confirm_bin": "Confirmer l'emplacement",
            "insert_bin_to_confirm": "Saisir l'emplacement pour confirmer",
            "qty_differs_from_bol": "La quantité saisie est différente de la quantité sur le bon de livraison",
            "qty_differs_from_remaining": "La quantité saisie est différente de la quantité restante dans la commande",
            "item_not_managed_by_lots": "Article non géré par lots",
            "lot_config_not_available": "Configuration de lot non disponible",
            "lot_generated": "Lot généré : ",
            "excess_material": "Matériel en excès",
            "excess_reason": "Raison de l'excédent",
            "same_as_order": "Identique à la commande",
            "item_found_not_in_order": "Article {item} ({description}) trouvé mais absent des commandes sélectionnées",
            "item_not_found_in_system": "Article introuvable dans le système",
            "barcode_not_found": "Code-barres introuvable dans le système",
            "added_to_excess": "Article ajouté aux excédents",
            "excess_items": "Articles en excédent",
            "clear_all": "Tout vider",
            "confirm_clear_excess": "Êtes-vous sûr de vouloir vider le tableau des excédents ?",
            "results_found": "Résultats trouvés :",
            "show_zero_stock": "Afficher aussi les articles avec un stock égal à 0",
            "stock_short": "Stock :",
            "lot_short": "LOT :",
            "storage_short": "DÉP :",
            "customer_short": "Client",
            "supplier_short": "Fournisseur",
            "carica_excel": {
                "drag_hint": "Faites glisser le fichier Excel ici",
                "click_hint": "ou cliquez pour parcourir les fichiers",
                "select_file": "Sélectionner un fichier",
                "upload_file": "Valider le fichier",
                "upload_other_file": "Charger un autre fichier",
                "cancel": "Annuler",
                "saving": "Enregistrement…",
                "save_data": "Enregistrer les données",
                "uploaded_files": "Fichiers chargés",
                "rows_info": "{rows} lignes · chargé le {date}",
                "delete": "Supprimer",
                "no_rows": "Aucune ligne.",
                "invalid_file_type": "Veuillez télécharger uniquement des fichiers Excel (.xlsx) ou CSV",
                "xls_not_supported": "Le format .xls n'est pas pris en charge. Enregistrez le fichier au format .xlsx ou .csv, puis réessayez.",
                "file_too_large": "Le fichier est trop volumineux. Taille maximale autorisée : {size} Mo.",
                "read_error": "Impossible de lire le fichier. Vérifiez qu'il s'agit d'un fichier .xlsx ou .csv valide, puis réessayez.",
                "save_error": "Erreur lors de l'enregistrement : ",
                "confirm_delete": "Supprimer ce fichier ?",
                "delete_error": "Erreur lors de la suppression : ",
                "print": "Imprimer pour lecture de code-barres"
            },
            "rettifica_headers": {
                "item": "Article",
                "description": "Description",
                "commodity_ctg": "Cat. Marchandises",
                "homogeneous_ctg": "Cat. Homogène",
                "lot": "Lot",
                "storage": "Dépôt",
                "specificator": "Client/Fournisseur",
                "resulting_qty": "Quantité Résultante",
                "current_qty": "Quantité Actuelle"
            },
            "reg-confirm": "Confirmer",
            "ddt_flow": {
                "confirm_title": "Confirmer l'enregistrement - Flux Excel",
                "bills_to_create": "📋 Bons de livraison à créer :",
                "assignment_title": "⚠️ Attribution du numéro de DDT",
                "assignment_description": "Les articles suivants n'ont pas été trouvés dans le fichier Excel. Attribuez un numéro de DDT à chacun :",
                "choose_ddt": "-- Choisir DDT --",
                "insert_ddt_placeholder": "Ou saisissez le DDT",
                "continue_save": "Continuer l'enregistrement",
                "assign_ddt_warning": "Attribuez un DDT à chaque article",
                "picking_no_orders": "(Prélèvements non générés - aucune commande client liée)",
                "bills_created_count": "Bons de livraison créés pour {count} DDT",
                "error_ddt_assignment": "Erreur lors de l'attribution des DDT"
            },
            "supplier_doc_date": "Date du document fournisseur",
            "bill_of_lading_date": "Date d'enregistrement du bon de livraison",
            "print_pickings": "Prélèvements générés"
        },
        "pagination": {
            "next": "Successivo &raquo;",
            "previous": "&laquo; Precedente"
        }
    },
    "it": {
        "http-statuses": {
            "0": "Erreur inconnue",
            "100": "Continue",
            "101": "Changement de protocole",
            "102": "En traitement",
            "200": "OK",
            "201": "Créé",
            "202": "Accepté",
            "203": "Information non autorisée",
            "204": "Aucun contenu",
            "205": "Réinitialiser le contenu",
            "206": "Contenu partiel",
            "207": "États multiples",
            "208": "Déjà signalé",
            "226": "IM utilisés",
            "300": "Choix multiples",
            "301": "Transféré définitivement",
            "302": "Trouvé",
            "303": "Voir autre",
            "304": "Non modifié",
            "305": "Utiliser un proxy",
            "307": "Redirection temporaire",
            "308": "Redirection permanente",
            "400": "Mauvaise requête",
            "401": "Non autorisé",
            "402": "Paiement requis",
            "403": "Accès interdit",
            "404": "Page non trouvée",
            "405": "Méthode non autorisée",
            "406": "Non acceptable",
            "407": "Authentification proxy requise",
            "408": "Délai d'attente de la requête expiré",
            "409": "Conflit",
            "410": "Disparu",
            "411": "Longueur requise",
            "412": "Précondition échouée",
            "413": "Charge utile trop volumineuse",
            "414": "URI trop long",
            "415": "Type de média non pris en charge",
            "416": "Plage insatisfaisable",
            "417": "Attente échouée",
            "418": "Je suis une théière",
            "419": "Session expirée",
            "421": "Requête mal dirigée",
            "422": "Entité non traitable",
            "423": "Verrouillé",
            "424": "Dépendance échouée",
            "425": "Trop tôt",
            "426": "Mise à niveau requise",
            "428": "Précondition requise",
            "429": "Trop de demandes",
            "431": "Champs d'en-tête de requête trop grands",
            "444": "Connexion fermée sans réponse",
            "449": "Réessayer avec",
            "451": "Non disponible pour des raisons juridiques",
            "499": "Requête client fermée",
            "500": "Erreur interne du serveur",
            "501": "Non implémenté",
            "502": "Mauvaise passerelle",
            "503": "En maintenance",
            "504": "Délai d'attente de la passerelle expiré",
            "505": "Version HTTP non prise en charge",
            "506": "La variante négocie également",
            "507": "Espace insuffisant",
            "508": "Boucle identifiée",
            "509": "Limite de bande dépassée",
            "510": "Non étendu",
            "511": "Authentification réseau requise",
            "520": "Erreur inconnue",
            "521": "Serveur Web hors service",
            "522": "Délai d'attente de la connexion expiré",
            "523": "Origine non accessible",
            "524": "Un délai d'attente s'est produit",
            "525": "Échec de la négociation SSL",
            "526": "Certificat SSL invalide",
            "527": "Erreur de canon à rail",
            "598": "Erreur de délai d'attente de lecture réseau",
            "599": "Erreur de délai d'attente de la connexion réseau",
            "unknownError": "Erreur inconnue"
        },
        "core": {
            "order_number": "N. Ordine",
            "supplier": "Fornitore",
            "supplier_docno": "Nr doc fornitore",
            "customer": "Cliente",
            "searching": "Ricerca in corso",
            "on_date": "Del",
            "date": "Data",
            "load": "Carica",
            "inventory_management": "Gestione magazzino",
            "receiving_goods": "Ricezione merce",
            "order_fulfillment": "Evasione ordini",
            "order": "Ordine",
            "position": "Pos.",
            "item": "Articolo",
            "description": "Descrizione",
            "qty_order": "Qtà ordine",
            "qty_registered": "Qtà registr.",
            "qty_to_register": "Qtà da registrare",
            "registration": "Registr.",
            "order_details": "Dettagli ordini",
            "barcode_search": "Ricerca per codice a barre",
            "item_search": "Ricerca articolo",
            "qty_received_of": "Inserisci la quantità ricevuta di",
            "in_order": "nell'ordine",
            "set": "Imposta",
            "confirm_receive": "Conferma ricezione",
            "document": "Documento",
            "item_not_found": "Articolo non trovato",
            "successful_operation": "Operazione riuscita",
            "error": "Errore",
            "receiving": "Ricezione",
            "shipped": "Spedito",
            "to_be_shipped": "Da spedire",
            "shipping": "Spedizione",
            "destination": "Destinazione",
            "shipping_type": "Tipo di spedizione",
            "gross_weight": "Peso lordo",
            "net_weight": "Peso netto",
            "number_of_packages": "Numero colli",
            "article_list": "Lista articoli",
            "available": "Disponibile",
            "code": "Codice",
            "product_category": "Categoria merceologica",
            "homogeneous_category": "Categoria omogenea",
            "lot": "Lotto",
            "storage": "Magazzino",
            "lot_required_warning": "Attenzione: il lotto non è stato impostato per tutti gli articoli con quantità da registrare",
            "bin_required_warning": "Attenzione: l'ubicazione non è stata impostata per tutti gli articoli con quantità da registrare",
            "generate_lot": "Genera Lotto",
            "lot_prefix": "Prefisso Lotto",
            "lot_year_format": "Formato Anno",
            "lot_separator": "Separatore",
            "lot_suffix": "Suffisso Lotto",
            "choose_item": "Scegli un articolo",
            "bol_number": "Numero bolla di carico",
            "bol_confirm": "Conferma Bolle di Carico",
            "bin": "Ubicazione",
            "icam_status": "Stato ICAM",
            "save": "Salva",
            "line": "Riga",
            "billofladings": "Bolle di carico",
            "saving_data": "Salvataggio dati",
            "items_list": "Lista articoli",
            "filters": "Filtri",
            "search": "Ricerca",
            "reference": "Rif.",
            "location": "Ubicazione",
            "saleordno": "Ordine Cliente",
            "purchaseordno": "Ordine Fornitore",
            "qty": "Qtà",
            "uom": "UdM",
            "price": "Prezzo",
            "discount": "Sconto",
            "warning": "Attenzione",
            "info": "Informazione",
            "ok": "OK",
            "sale_ord_no": "N. Ordine Cliente",
            "bill_number": "N. Bolla di carico",
            "commodity_ctg": "Categoria merceologica",
            "homogeneous_ctg": "Categoria omogenea",
            "close_and_continue": "Chiudi e prosegui",
            "barcode_lot_search": "Ricerca per codice a barre o lotto",
            "company_name": "Ragione Sociale",
            "server_error": "Errore interno del server",
            "connection_error": "Impossibile stabilire la connessione, controlla la rete",
            "unit_value": "Valore unitario",
            "item_supplier_code": "Cod. Forn."
        },
        "actions": {
            "accept": "Accettare",
            "action": "Azione",
            "actions": "Azioni",
            "add": "Aggiungi",
            "admin": "Ammin",
            "agree": "Essere d'accordo",
            "archive": "Archivio",
            "assign": "Assegnare",
            "associate": "Associare",
            "attach": "Allega",
            "browse": "Naviga",
            "cancel": "Annulla",
            "choose": "Scegli",
            "choose_file": "Scegli il file",
            "choose_image": "Scegli Immagine",
            "click_to_copy": "Fare clic per copiare",
            "close": "Chiudi",
            "collapse": "Comprimi",
            "collapse_all": "Comprimi tutto",
            "comment": "Commenta",
            "confirm": "Conferma",
            "confirm_and_save": "Conferma e salva",
            "connect": "Collega",
            "create": "Crea",
            "delete": "Elimina",
            "detach": "Scollega",
            "details": "Dettagli",
            "disable": "Disattiva",
            "discard": "Scarta",
            "done": "Fatto",
            "down": "Giù",
            "duplicate": "Duplica",
            "edit": "Modifica",
            "enable": "Abilita",
            "expand": "Espandi",
            "expand_all": "Espandi tutto",
            "explanation": "Spiegazione",
            "export": "Esporta",
            "file": "File",
            "files": "File",
            "go_home": "Torna alla Home",
            "hide": "Nascondi",
            "home": "Home",
            "image": "Immagine",
            "impersonate": "Impersona",
            "impersonation": "Impersonificazione",
            "import": "Importa",
            "introduction": "introduzione",
            "like": "Mi Piace",
            "load": "Carica",
            "localize": "Localizza",
            "log_in": "Login",
            "log_out": "Esci",
            "named": {
                "add": "Aggiungi {name}",
                "choose": "Scegli {name}",
                "create": "Crea {name}",
                "delete": "Cancella {name}",
                "duplicate": "Duplica: nome",
                "edit": "Modifica {name}",
                "export": "Esporta {name}",
                "hide": "Nascondi {name}",
                "import": "Importa {name}",
                "new": "Nuovo {name}",
                "restore": "Ripristina {name}",
                "save": "Salva {name}",
                "search": "Cerca {name}",
                "show": "Mostra {name}",
                "update": "Aggiorna {name}",
                "view": "Mostra {name}"
            },
            "new": "Nuovo",
            "no": "NO",
            "open": "Aprire",
            "open_website": "Apri sul sito",
            "preview": "Anteprima",
            "price": "Prezzo",
            "register": "Registra",
            "record": "Documentazione",
            "restore": "Ripristina",
            "save": "Salva",
            "save_and_close": "Salva e chiudi",
            "save_and_return": "Salva e ritorna",
            "search": "Ricerca",
            "select": "Seleziona",
            "select_all": "Seleziona tutto",
            "send": "Invia",
            "settings": "Impostazioni",
            "show": "Mostra",
            "show_all": "Mostra tutto",
            "sign_in": "Accedi",
            "solve": "Risolvere",
            "start": "Avvia",
            "stop": "Ferma",
            "submit": "Invia",
            "subscribe": "Sottoscrivi",
            "switch": "Passa",
            "switch_to_role": "Passa al ruolo",
            "tag": "Etichetta",
            "tags": "Etichette",
            "target_link": {
                "blank": "Apri in una nuova finestra",
                "parent": "Apri in un frame principale",
                "self": "Apri in una finestra corrente",
                "top": "Apri nel riquadro più in alto"
            },
            "translate": "Traduci",
            "translate_it": "Traducilo",
            "unpack": "Decomprimi",
            "unsubscribe": "Annulla l'iscrizione",
            "up": "Su",
            "update": "Aggiorna",
            "user": "Utente",
            "view": "Visualizza",
            "yes": "SI",
            "filters": "Filtri",
            "apply": "Applica",
            "empty": "Svuota",
            "reset": "Reset",
            "set": "Imposta",
            "zero": "Azzera",
            "clear": "Pulisci",
            "confirm_selected": "Scarica selezionati",
            "import_csv": "Importa CSV",
            "ok": "OK",
            "confirming_picking": "Creazione/aggiornamento picking in corso"
        },
        "rp": {
            "import": {
                "button": "Importa CSV/XLSX",
                "title": "Importazione CSV/XLSX",
                "steps": {
                    "upload": "Caricamento",
                    "mapping": "Mapping",
                    "validation": "Validazione",
                    "confirm": "Conferma"
                },
                "common": {
                    "next": "Avanti",
                    "back": "Indietro",
                    "thousandsNone": "Nessuno"
                },
                "types": {
                    "text": "Testo",
                    "number": "Numero",
                    "date": "Data",
                    "select": "Selezione",
                    "magoquery": "Query Mago",
                    "portalquery": "Query Portale"
                },
                "lookupModes": {
                    "value": "Codice/valore",
                    "label": "Descrizione",
                    "value_or_label": "Prima codice, poi descrizione"
                },
                "upload": {
                    "dropHint": "Seleziona un file .csv o .xlsx da importare",
                    "selectFile": "Seleziona file",
                    "fileName": "Nome file",
                    "fileSize": "Dimensione",
                    "rowsCount": "Righe",
                    "headers": "Colonne",
                    "preview": "Anteprima (prime 10 righe)",
                    "invalidExtension": "Formato non supportato. Sono ammessi solo file .csv e .xlsx.",
                    "tooLarge": "Il file supera la dimensione massima di {max} MB.",
                    "empty": "Il file non contiene righe."
                },
                "mapping": {
                    "field": "Campo registro",
                    "type": "Tipo",
                    "required": "Obbligatorio",
                    "sourceColumn": "Colonna file",
                    "interpretation": "Interpretazione",
                    "selectColumn": "Seleziona colonna",
                    "doNotImport": "Non importare",
                    "requiredNotMapped": "Campo obbligatorio: mappatura richiesta.",
                    "decimalSeparator": "Separatore decimale",
                    "thousandsSeparator": "Separatore delle migliaia",
                    "dateFormat": "Formato data sorgente",
                    "allowedOptions": "Opzioni ammesse",
                    "recognizeBoolean": "Riconosci sinonimi sì/no",
                    "lookupMode": "Cerca il valore come"
                },
                "validation": {
                    "running": "Validazione in corso…",
                    "total": "Righe totali",
                    "valid": "Righe valide",
                    "invalid": "Righe errate",
                    "errorsTable": "Errori",
                    "rowNumber": "Riga",
                    "field": "Campo",
                    "sourceColumn": "Colonna sorgente",
                    "originalValue": "Valore originale",
                    "message": "Messaggio",
                    "noErrors": "Nessun errore rilevato.",
                    "blocked": "Sono presenti righe non valide: correggi il file o il mapping per procedere."
                },
                "confirm": {
                    "registry": "Registro di destinazione",
                    "file": "File",
                    "rowsToImport": "Righe da importare",
                    "atomicWarning": "L'operazione è atomica: se una sola riga è invalida non verrà inserito alcun record.",
                    "import": "Importa record",
                    "importing": "Importazione in corso…",
                    "success": "Importazione completata: {count} record creati.",
                    "backToRegistry": "Torna al registro"
                },
                "errors": {
                    "generic": "Impossibile leggere il file.",
                    "http": "Si è verificato un errore durante la comunicazione con il server."
                }
            }
        },
        "validation": {
            "accepted": "{Attribute} deve essere accettato.",
            "accepted_if": "{Attribute} deve essere accettato quando {other} è {value}.",
            "active_url": "{Attribute} non è un URL valido.",
            "after": "{Attribute} deve essere una data successiva al {date}.",
            "after_or_equal": "{Attribute} deve essere una data successiva o uguale al {date}.",
            "alpha": "{Attribute} può contenere solo lettere.",
            "alpha_dash": "{Attribute} può contenere solo lettere, numeri e trattini.",
            "alpha_num": "{Attribute} può contenere solo lettere e numeri.",
            "array": "{Attribute} deve essere un array.",
            "ascii": "{Attribute} deve contenere solo caratteri alfanumerici single-byte e simboli.",
            "before": "{Attribute} deve essere una data precedente al {date}.",
            "before_or_equal": "{Attribute} deve essere una data precedente o uguale al {date}.",
            "between": {
                "array": "{Attribute} deve avere tra {min} - {max} elementi.",
                "file": "{Attribute} deve trovarsi tra {min} - {max} kilobyte.",
                "numeric": "{Attribute} deve trovarsi tra {min} - {max}.",
                "string": "{Attribute} deve trovarsi tra {min} - {max} caratteri."
            },
            "boolean": "Il campo {attribute} deve essere vero o falso.",
            "can": "Il campo {attribute} contiene un valore non autorizzato.",
            "confirmed": "Il campo di conferma per {attribute} non coincide.",
            "contains": "The {attribute} field is missing a required value.",
            "current_password": "Password non valida.",
            "date": "{Attribute} non è una data valida.",
            "date_equals": "{Attribute} deve essere una data e uguale a {date}.",
            "date_format": "{Attribute} non coincide con il formato {format}.",
            "decimal": "{Attribute} deve avere {decimal} cifre decimali.",
            "declined": "{Attribute} deve essere rifiutato.",
            "declined_if": "{Attribute} deve essere rifiutato quando {other} è {value}.",
            "different": "{Attribute} e {other} devono essere differenti.",
            "digits": "{Attribute} deve essere di {digits} cifre.",
            "digits_between": "{Attribute} deve essere tra {min} e {max} cifre.",
            "dimensions": "Le dimensioni dell'immagine di {attribute} non sono valide.",
            "distinct": "{Attribute} contiene un valore duplicato.",
            "doesnt_end_with": "{Attribute} non può terminare con uno dei seguenti valori: {values}.",
            "doesnt_start_with": "{Attribute} non può iniziare con uno dei seguenti valori: {values}.",
            "email": "{Attribute} non è valido.",
            "ends_with": "{Attribute} deve finire con uno dei seguenti valori: {values}",
            "enum": "Il campo {attribute} non è valido.",
            "exists": "{Attribute} selezionato non è valido.",
            "extensions": "Il campo {attribute} deve avere una delle seguenti estensioni: {values}.",
            "file": "{Attribute} deve essere un file.",
            "filled": "Il campo {attribute} deve contenere un valore.",
            "gt": {
                "array": "{Attribute} deve contenere più di {value} elementi.",
                "file": "{Attribute} deve essere maggiore di {value} kilobyte.",
                "numeric": "{Attribute} deve essere maggiore di {value}.",
                "string": "{Attribute} deve contenere più di {value} caratteri."
            },
            "gte": {
                "array": "{Attribute} deve contenere un numero di elementi uguale o maggiore di {value}.",
                "file": "{Attribute} deve essere uguale o maggiore di {value} kilobyte.",
                "numeric": "{Attribute} deve essere uguale o maggiore di {value}.",
                "string": "{Attribute} deve contenere un numero di caratteri uguale o maggiore di {value}."
            },
            "hex_color": "Il campo {attribute} deve essere un colore esadecimale valido.",
            "image": "{Attribute} deve essere un'immagine.",
            "in": "{Attribute} selezionato non è valido.",
            "in_array": "Il valore del campo {attribute} non esiste in {other}.",
            "integer": "{Attribute} deve essere un numero intero.",
            "ip": "{Attribute} deve essere un indirizzo IP valido.",
            "ipv4": "{Attribute} deve essere un indirizzo IPv4 valido.",
            "ipv6": "{Attribute} deve essere un indirizzo IPv6 valido.",
            "json": "{Attribute} deve essere una stringa JSON valida.",
            "list": "Il campo {attribute} deve essere un elenco.",
            "lowercase": "{Attribute} deve contenere solo caratteri minuscoli.",
            "lt": {
                "array": "{Attribute} deve contenere meno di {value} elementi.",
                "file": "{Attribute} deve essere minore di {value} kilobyte.",
                "numeric": "{Attribute} deve essere minore di {value}.",
                "string": "{Attribute} deve contenere meno di {value} caratteri."
            },
            "lte": {
                "array": "{Attribute} deve contenere un numero di elementi minore o uguale a {value}.",
                "file": "{Attribute} deve essere minore o uguale a {value} kilobyte.",
                "numeric": "{Attribute} deve essere minore o uguale a {value}.",
                "string": "{Attribute} deve contenere un numero di caratteri minore o uguale a {value}."
            },
            "mac_address": "Il campo {attribute} deve essere un indirizzo MAC valido .",
            "max": {
                "array": "{Attribute} non può avere più di {max} elementi.",
                "file": "{Attribute} non può essere superiore a {max} kilobyte.",
                "numeric": "{Attribute} non può essere superiore a {max}.",
                "string": "{Attribute} non può contenere più di {max} caratteri."
            },
            "max_digits": "{Attribute} non può contenere più di {max} cifre.",
            "mimes": "{Attribute} deve essere del tipo: {values}.",
            "mimetypes": "{Attribute} deve essere del tipo: {values}.",
            "min": {
                "array": "{Attribute} deve avere almeno {min} elementi.",
                "file": "{Attribute} deve essere almeno di {min} kilobyte.",
                "numeric": "{Attribute} deve essere almeno {min}.",
                "string": "{Attribute} deve contenere almeno {min} caratteri."
            },
            "min_digits": "{Attribute} deve contenere almeno {min} cifre.",
            "missing": "Il campo {attribute} deve mancare.",
            "missing_if": "Il campo {attribute} deve mancare quando {other} è {value}.",
            "missing_unless": "Il campo {attribute} deve mancare a meno che {other} non sia {value}.",
            "missing_with": "Il campo {attribute} deve mancare quando è presente {values}.",
            "missing_with_all": "Il campo {attribute} deve mancare quando sono presenti {values}.",
            "multiple_of": "{Attribute} deve essere un multiplo di {value}",
            "not_in": "Il valore selezionato per {attribute} non è valido.",
            "not_regex": "Il formato di {attribute} non è valido.",
            "numeric": "{Attribute} deve essere un numero.",
            "password": {
                "letters": "{Attribute} deve contenere almeno un carattere.",
                "mixed": "{Attribute} deve contenere almeno un carattere maiuscolo ed un carattere minuscolo.",
                "numbers": "{Attribute} deve contenere almeno un numero.",
                "symbols": "{Attribute} deve contenere almeno un simbolo.",
                "uncompromised": "{Attribute} è presente negli archivi dei dati trafugati. Per piacere scegli un valore differente per {attribute}."
            },
            "present": "Il campo {attribute} deve essere presente.",
            "present_if": "Il campo {attribute} deve essere presente quando {other} è {value}.",
            "present_unless": "Il campo {attribute} deve essere presente a meno che {other} non sia {value}.",
            "present_with": "Il campo {attribute} deve essere presente quando è presente {values}.",
            "present_with_all": "Il campo {attribute} deve essere presente quando sono presenti {values}.",
            "prohibited": "{Attribute} non consentito.",
            "prohibited_if": "{Attribute} non consentito quando {other} è {value}.",
            "prohibited_if_accepted": "The {attribute} field is prohibited when {other} is accepted.",
            "prohibited_if_declined": "The {attribute} field is prohibited when {other} is declined.",
            "prohibited_unless": "{Attribute} non consentito a meno che {other} sia contenuto in {values}.",
            "prohibits": "{Attribute} impedisce a {other} di essere presente.",
            "regex": "Il formato del campo {attribute} non è valido.",
            "required": "Il campo {attribute} è richiesto.",
            "required_array_keys": "Il campo {attribute} deve contenere voci per: {values}.",
            "required_if": "Il campo {attribute} è richiesto quando {other} è {value}.",
            "required_if_accepted": "{Attribute} è richiesto quando {other} è accettato.",
            "required_if_declined": "The {attribute} field is required when {other} is declined.",
            "required_unless": "Il campo {attribute} è richiesto a meno che {other} sia in {values}.",
            "required_with": "Il campo {attribute} è richiesto quando {values} è presente.",
            "required_with_all": "Il campo {attribute} è richiesto quando {values} sono presenti.",
            "required_without": "Il campo {attribute} è richiesto quando {values} non è presente.",
            "required_without_all": "Il campo {attribute} è richiesto quando nessuno di {values} è presente.",
            "same": "{Attribute} e {other} devono coincidere.",
            "size": {
                "array": "{Attribute} deve contenere {size} elementi.",
                "file": "{Attribute} deve essere {size} kilobyte.",
                "numeric": "{Attribute} deve essere {size}.",
                "string": "{Attribute} deve contenere {size} caratteri."
            },
            "starts_with": "{Attribute} deve iniziare con uno dei seguenti: {values}",
            "string": "{Attribute} deve essere una stringa.",
            "timezone": "{Attribute} deve essere una zona valida.",
            "ulid": "{Attribute} deve essere un ULID valido.",
            "unique": "{Attribute} è stato già utilizzato.",
            "uploaded": "{Attribute} non è stato caricato.",
            "uppercase": "{Attribute} deve contenere solo caratteri maiuscoli.",
            "url": "Il formato del campo {attribute} non è valido.",
            "uuid": "{Attribute} deve essere un UUID valido.",
            "attributes": {
                "address": "indirizzo",
                "affiliate_url": "URL di affiliazione",
                "age": "età",
                "amount": "Quantità",
                "announcement": "annuncio",
                "area": "la zona",
                "audience_prize": "premio del pubblico",
                "audience_winner": "audience winner",
                "available": "disponibile",
                "birthday": "compleanno",
                "body": "corpo",
                "city": "città",
                "company": "company",
                "compilation": "compilazione",
                "concept": "concetto",
                "conditions": "condizioni",
                "content": "contenuto",
                "contest": "contest",
                "country": "paese",
                "cover": "copertina",
                "created_at": "creato il",
                "creator": "Creatore",
                "currency": "valuta",
                "current_password": "password attuale",
                "customer": "cliente",
                "date": "data",
                "date_of_birth": "data di nascita",
                "dates": "date",
                "day": "giorno",
                "deleted_at": "cancellato il",
                "description": "descrizione",
                "display_type": "tipo di visualizzazione",
                "district": "quartiere",
                "duration": "durata",
                "email": "e-mail",
                "excerpt": "estratto",
                "filter": "filtro",
                "finished_at": "finito alle",
                "first_name": "nome",
                "gender": "genere",
                "grand_prize": "grand prize",
                "group": "gruppo",
                "hour": "ora",
                "image": "Immagine",
                "image_desktop": "immagine del desktop",
                "image_main": "immagine principale",
                "image_mobile": "immagine mobile",
                "images": "immagini",
                "is_audience_winner": "è il vincitore del pubblico",
                "is_hidden": "è nascosto",
                "is_subscribed": "è iscritto",
                "is_visible": "è visibile",
                "is_winner": "è vincitore",
                "items": "elementi",
                "key": "chiave",
                "last_name": "cognome",
                "lesson": "lezione",
                "line_address_1": "indirizzo di linea 1",
                "line_address_2": "indirizzo di linea 2",
                "login": "login",
                "message": "Messaggio",
                "middle_name": "secondo nome",
                "minute": "minuto",
                "mobile": "cellulare",
                "month": "mese",
                "name": "nome",
                "national_code": "codice nazionale",
                "number": "numero",
                "password": "password",
                "password_confirmation": "conferma password",
                "phone": "telefono",
                "photo": "foto",
                "portfolio": "portafoglio",
                "postal_code": "Codice Postale",
                "preview": "anteprima",
                "price": "prezzo",
                "product_id": "Codice prodotto",
                "product_uid": "ID del prodotto",
                "product_uuid": "UUID del prodotto",
                "promo_code": "codice promozionale",
                "province": "Provincia",
                "quantity": "quantità",
                "reason": "motivo",
                "recaptcha_response_field": "campo di risposta recaptcha",
                "referee": "arbitro",
                "referees": "arbitri",
                "reject_reason": "rifiutare la ragione",
                "remember": "ricordare",
                "restored_at": "ripristinato il",
                "result_text_under_image": "testo del risultato sotto l'immagine",
                "role": "ruolo",
                "rule": "regola",
                "rules": "regole",
                "second": "secondo",
                "sex": "sesso",
                "shipment": "spedizione",
                "short_text": "testo breve",
                "size": "dimensione",
                "skills": "competenze",
                "slug": "lumaca",
                "specialization": "specializzazione",
                "started_at": "iniziato alle",
                "state": "stato",
                "status": "stato",
                "street": "strada",
                "student": "alunno",
                "subject": "argomento",
                "tag": "etichetta",
                "tags": "tag",
                "teacher": "insegnante",
                "terms": "termini",
                "test_description": "descrizione del testo",
                "test_locale": "locale di prova",
                "test_name": "nome di prova",
                "text": "testo",
                "time": "ora",
                "title": "titolo",
                "type": "tipo",
                "updated_at": "aggiornato il",
                "user": "utente",
                "username": "nome utente",
                "value": "valore",
                "winner": "winner",
                "work": "work",
                "year": "anno"
            }
        },
        "an": {
            "breadcrumb": {
                "anagrafiche": "Anagrafiche",
                "clienti_fornitori": "Clienti e fornitori",
                "contatti": "Contatti"
            },
            "fields": {
                "id": "ID",
                "company_name": "Ragione sociale",
                "city": "Città",
                "address": "Indirizzo",
                "zip_code": "Codice postale",
                "county": "Provincia",
                "country": "Stato",
                "latitude": "Latitudine",
                "longitude": "Longitudine",
                "phone1": "Telefono 1",
                "phone2": "Telefono 2",
                "phone": "Telefono",
                "email_certified": "Email certificata",
                "vat": "P. IVA",
                "fiscal_code": "C.F.",
                "sdi_code": "Codice SDI",
                "abi": "ABI",
                "cab": "CAB",
                "bank": "Banca",
                "payment": "Pagamento",
                "typical_discount": "Sconto Tipico",
                "account": "Conto",
                "agent": "Agente",
                "type": "Tipologia",
                "customer_notes": "Note cliente",
                "actions": "Azioni",
                "contact": "Contatto"
            },
            "actions": {
                "choose_agent": "Scegli l'agente",
                "update": "Aggiorna",
                "add": "Aggiungi",
                "close": "Chiudi",
                "edit": "Modifica",
                "details": "Dettagli",
                "sites": "Sedi",
                "select_type": "Seleziona tipologia",
                "searching": "🔍 Ricerca in corso...",
                "start_typing": "Inizia a digitare..."
            },
            "gestione_clienti_fornitori": {
                "add_button": "Aggiungi Anagrafica",
                "search_placeholder": "Ricerca codice/ragione sociale",
                "customers": "Clienti",
                "suppliers": "Fornitori",
                "modal_edit_title": "Modifica Cliente/Fornitore",
                "modal_add_title": "Aggiungi Cliente/Fornitore",
                "sites_of": "Sedi di",
                "no_sites": "Nessuna sede trovata"
            },
            "gestione_contatti": {
                "add_button": "Aggiungi Contatto",
                "search_placeholder": "Ricerca codice/ragione sociale",
                "modal_edit_title": "Modifica Contatto",
                "modal_add_title": "Aggiungi Contatto"
            },
            "parameters": {
                "filter_entries_by_agent_label": "Filtra elementi per agente",
                "filter_entries_by_agent_description": "Se abilitato, verranno mostrati solo gli elementi associati all'agente collegato all'account loggato",
                "electronic_invoicing_label": "Fatturazione elettronica",
                "electronic_invoicing_description": "Se abilitato, i clienti vengono creati con il campo ElectronicInvoicing a 1, altrimenti a 0"
            },
            "validation": {
                "custsupptype_required": "Il tipo di cliente/fornitore è obbligatorio.",
                "taxid_already_exists": "La P.IVA indicata è già presente.",
                "company_name_required": "La ragione sociale è obbligatoria."
            },
            "messages": {
                "client_supplier_added": "Cliente/Fornitore aggiunto con successo.",
                "contact_added": "Contatto aggiunto con successo."
            }
        },
        "pv": {
            "breadcrumb": {
                "percorsi_vettori": "Percorsi Vettori",
                "gestione_itinerari": "Percorsi Salvati",
                "generazione_itinerari": "Crea Percorso",
                "confronto_stradari": "Confronto Stradari",
                "veicoli": "Veicoli e Sagome"
            },
            "parameters": {
                "group_by_companyName_and_address_label": "Raggruppa per",
                "group_by_companyName_and_address_description": "Raggruppa le tappe per indirizzo di consegna (CompanyName + Address) invece che per indirizzo singolo.",
                "custom_carriers_label": "Vettori personalizzati",
                "custom_carriers_description": "Se abilitato, mostra solo i vettori che su MAGO hanno campo flag \"Custom\" spuntato",
                "usa_categoria_cliente_label": "Usa categoria cliente",
                "usa_categoria_cliente_description": "Se valorizzato, mostra codice sede, solo per i clienti con questa categoria"
            },
            "flash": {
                "travel_saved": "Percorso salvato con successo!",
                "travel_save_error": "Errore durante il salvataggio: ",
                "travel_updated": "Percorso aggiornato con successo!",
                "travel_update_error": "Errore durante l'aggiornamento: ",
                "travel_deleted": "Itinerario eliminato con successo.",
                "travel_delete_error": "Errore durante l'eliminazione: ",
                "address_not_available": "Indirizzo non disponibile per questa sede",
                "error_missing_carrier": "Impossibile generare il percorso: i seguenti ordini non hanno un vettore assegnato: {orders}.",
                "error_no_trips_found_for_orders": "Nessun viaggio trovato per gli ordini selezionati: verifica che siano già stati evasi/fatturati.",
                "error_orders_not_found": "Nessun documento di picking trovato per i seguenti ordini: {orders}. Verifica che siano già stati evasi/fatturati.",
                "error_multiple_carriers": "Impossibile generare il percorso: gli ordini selezionati sono associati a vettori diversi ({carriers}). Seleziona ordini con lo stesso vettore."
            },
            "confronto_headers": {
                "code": "Codice",
                "company_name": "Ragione Sociale",
                "status": "Stato"
            },
            "csv_headers": {
                "stop": "Tappa",
                "company_name": "Ragione Sociale",
                "customer_code": "Cod. Cliente",
                "address": "Indirizzo",
                "doc_num": "N. Doc",
                "doc_type": "Tipo Doc",
                "packages": "Colli",
                "rimes": "Rimes",
                "mdp": "MDP",
                "notes": "Note",
                "warnings": "Avvertimenti",
                "departure": "PARTENZA",
                "arrival": "ARRIVO"
            },
            "shared": {
                "add_waypoint": "Aggiungi Tappa",
                "search_address_placeholder": "Cerca indirizzo...",
                "delete_waypoint_title": "Elimina tappa",
                "options": "Opzioni",
                "avoid_tolls": "Evita Pedaggi",
                "avoid_highways": "Evita Autostrade",
                "avoid_ferries": "Evita Traghetti",
                "distance_label": "Distanza:",
                "duration_label": "Durata:",
                "saving": "Salvataggio...",
                "calculating": "Calcolo...",
                "geocode_failed": "Geocodifica fallita: ",
                "new_waypoint": "Nuova Tappa",
                "departure": "Partenza",
                "arrival": "Arrivo"
            },
            "confronto": {
                "title": "Confronto stradari",
                "verify_page_button": "Verifica tutti gli indirizzi della pagina",
                "verifying_in_progress": "Verifica in corso…",
                "th_branch": "Sede",
                "th_registered_address": "Indirizzo registrato",
                "th_google_address": "Indirizzo Google",
                "th_status": "Stato",
                "main_branch": "★ Sede",
                "branch_label": "Filiale",
                "address_not_found": "Indirizzo non trovato su Google",
                "partial_match": "(corrispondenza parziale)",
                "verification_failed": "verifica fallita",
                "error_prefix": "Errore:",
                "to_verify": "Da verificare…",
                "verify": "Verifica",
                "verify_all_branches": "Verifica tutte le sedi",
                "no_secondary_branches": "Nessuna sede secondaria",
                "unknown_error": "Errore sconosciuto",
                "badge_ok": "✓ OK",
                "badge_partial": "~ Parziale",
                "badge_mismatch": "✗ Differente",
                "badge_not_found": "∅ Non trovato",
                "badge_error": "! Errore",
                "badge_to_verify": "Da verificare",
                "badge_global_to_verify": "⏳ Da verificare",
                "badge_global_verified": "🔄 {done}/{total} verificate",
                "badge_global_all_ok": "✓ Tutte OK ({total})",
                "badge_global_discrepancies": "⚠ {issues}/{total} discrepanze",
                "label_via": "Via",
                "label_cap": "CAP",
                "label_city": "Città",
                "label_county": "Prov.",
                "label_country": "Nazione"
            },
            "gestione": {
                "history_title": "Storico Itinerari",
                "page_summary": "Pagina {current} di {last} — {total} itinerari totali",
                "previous": "← Precedente",
                "next": "Successiva →",
                "field_date": "Data",
                "field_travel_name": "Nome Viaggio",
                "field_distance_stops": "Distanza / Tappe",
                "custom_options_active": "Opzioni personalizzate attive",
                "carrier_label": "Vettore:",
                "route_config_label": "Configurazione Percorso:",
                "tag_optimized": "Ottimizzato",
                "tag_no_tolls": "No Pedaggi",
                "tag_no_highways": "No Autostrade",
                "tag_no_ferries": "No Traghetti",
                "standard_options": "Opzioni standard",
                "stops_detail": "Dettaglio Tappe:",
                "packages_short": "Colli:",
                "btn_edit_route": "Modifica Tratta",
                "btn_print": "Stampa",
                "btn_delete_route": "Elimina Percorso",
                "btn_export_excel": "Esporta Excel",
                "no_saved_itineraries": "Nessun itinerario salvato trovato.",
                "modal_edit_route_title": "Modifica Percorso",
                "modal_route_stops": "Tappe del Percorso",
                "avoid_pedaggi_short": "Evita Pedaggi",
                "avoid_highways_short": "Evita Autostrade",
                "avoid_ferries_short": "Evita Traghetti",
                "travel_data": "Dati Viaggio",
                "btn_optimize": "Ottimizza",
                "btn_recalculate": "Ricalcola",
                "btn_save_itinerary": "Salva Itinerario",
                "confirm_delete": "Sei sicuro di voler eliminare l'itinerario \"{name}\"? Questa azione è irreversibile.",
                "delete_error": "Errore durante l'eliminazione dell'itinerario.",
                "recalc_before_save": "Ricalcola prima di salvare.",
                "no_route_data": "Nessun dato percorso disponibile. Ricalcola il percorso prima di salvare.",
                "save_error": "Errore al salvataggio.",
                "confirm_remove_grouped_docs": "Questa tappa contiene {count} documenti accorpati ({name}). Rimuovere la tappa e tutti i documenti associati?"
            },
            "generazione": {
                "header_title": "TABELLA DI VIAGGIO",
                "travel_of": "Viaggio del",
                "travel_until": "al",
                "driver_label": "AUTISTA / NOME:",
                "notes_label": "NOTE:",
                "total_distance": "Distanza Totale",
                "expected_time": "Tempo previsto",
                "route_configuration": "Configurazione Tragitto",
                "tag_avoid_tolls": "Evita Pedaggi",
                "tag_avoid_highways": "Evita Autostrade",
                "tag_avoid_ferries": "Evita Traghetti",
                "tag_tolls_allowed": "Pedaggi consentiti",
                "tag_highways_allowed": "Autostrade consentite",
                "tag_ferries_allowed": "Traghetti consentiti",
                "btn_route": "Percorso",
                "btn_print": "Stampa",
                "btn_export_excel": "Esporta Excel",
                "btn_new": "Nuovo",
                "btn_reload": "Ricarica",
                "departure_point": "Punto di Partenza",
                "add_custom_address": "+ Aggiungi indirizzo personalizzato",
                "add_departure_address": "Aggiungi indirizzo di partenza",
                "search_google_placeholder": "Cerca indirizzo su Google...",
                "arrival_point": "Punto di Arrivo",
                "add_arrival_address": "Aggiungi indirizzo di arrivo",
                "route_name_label": "Nome del Percorso (Opzionale)",
                "route_name_placeholder": "Esempio: Giro Consegne Nord, Viaggio di prova...",
                "qr_waiting": "QR Code in attesa del percorso",
                "merge_same_address": "Accorpa tappe con medesimo indirizzo",
                "loading_trips": "Caricamento viaggi...",
                "th_n": "N.",
                "th_company_name": "Ragione Sociale",
                "th_shipping_address": "Indirizzo Spedizione",
                "th_doc_num": "Nr. Doc.",
                "th_warnings": "Avvertimenti",
                "th_nc": "N.C.",
                "th_rimes": "Rimes",
                "th_mdp": "MDP",
                "row_partenza_prefix": "PARTENZA:",
                "row_arrivo_prefix": "ARRIVO:",
                "tag_manual": "MANUALE",
                "no_trips_found": "Nessun viaggio trovato per i criteri selezionati.",
                "select_carrier_period": "Seleziona un vettore e il periodo",
                "modal_title": "Seleziona Vettore e Periodo",
                "carrier_label": "Vettore",
                "carrier_placeholder": "Seleziona un vettore...",
                "search_mode": "Modalità Ricerca",
                "single_date": "Data Singola",
                "date_range": "Intervallo Date",
                "select_date": "Seleziona Data",
                "select_dates": "Seleziona Date",
                "date_from": "Dal",
                "date_to": "Al",
                "btn_search_trips": "Cerca Viaggi",
                "route_editor_title": "Modifica Percorso",
                "stops_count": "Tappe",
                "saving_in_progress": "Salvataggio in corso...",
                "route_calculating": "Calcolo percorso...",
                "option_avoid_tolls_desc": "Percorsi senza autostrada",
                "option_avoid_highways_desc": "Strade statali, provinciali o comunali. Evita anche autostrade gratuite",
                "option_avoid_ferries_desc": "Solo percorsi terrestri",
                "btn_optimize_route": "Ottimizza Percorso",
                "btn_calculate_route": "🔄 Calcola Percorso",
                "route_info_title": "📊 Informazioni",
                "distance_label": "Distanza:",
                "duration_label": "Durata:",
                "btn_save_route": "✓ Salva Percorso",
                "route_error_min_stops": "Servono almeno 2 tappe",
                "route_error_maps_not_init": "Google Maps non inizializzato",
                "route_error_origin_dest_missing": "Punto di partenza o arrivo mancante",
                "route_error_calc_prefix": "Errore calcolo percorso: ",
                "route_error_generic_prefix": "Errore: ",
                "fetch_error_default": "Errore nel caricamento dei viaggi. Riprova.",
                "partenza_marker_title": "Partenza",
                "arrivo_marker_title": "Arrivo",
                "stop_marker_title": "Tappa {index}: {name}",
                "alert_select_address_from_suggestions": "Seleziona un indirizzo dai suggerimenti",
                "alert_select_from_google_suggestions": "Per favore, seleziona un indirizzo dai suggerimenti di Google.",
                "alert_no_geometry": "L'indirizzo selezionato non contiene coordinate geografiche.",
                "alert_calc_route_first": "Calcola il percorso sulla mappa prima di salvare.",
                "alert_save_before_export": "Salva il percorso prima di esportare.",
                "alert_route_save_default_error": "Errore durante il salvataggio del percorso.",
                "alert_route_saved": "Percorso salvato con successo!",
                "manual_waypoint_note": "Tappa aggiunta manualmente",
                "default_travel_name": "Vettore {carrier} - Percorso del {date}",
                "confirm_remove_grouped_docs": "Questa tappa contiene {count} documenti accorpati ({name}). Rimuovere la tappa e tutti i documenti associati?",
                "label_sede_legale": "Sede Legale",
                "label_deposito": "Deposito",
                "generate_ddt": "Genera DDT",
                "vehicle_selection": "Selezione Veicolo"
            },
            "veicoli": {
                "title": "Gestione Veicoli e Sagome",
                "subtitle": "Configura le dimensioni fisiche, i pesi e le restrizioni dei veicoli per il calcolo avanzato degli itinerari.",
                "btn_new": "Nuovo Veicolo",
                "btn_templates": "Sagome Predefinite",
                "btn_export": "Esporta JSON",
                "btn_import": "Importa JSON",
                "btn_reset_default": "Ripristina Predefiniti",
                "routing_impact_title": "Impatto sul Calcolo Itinerari (HERE / Google Truck Routing)",
                "routing_impact_desc": "Le dimensioni (altezza, larghezza, lunghezza), il peso totale (PTT), il carico per asse e le classi merci (ADR) vengono utilizzate dai motori di routing per evitare ponti bassi, strade strette, divieti di transito ai mezzi pesanti e gallerie con restrizioni.",
                "stat_total": "Totale Veicoli",
                "stat_heavy": "Mezzi Pesanti (> 3.5t)",
                "stat_light": "Furgoni / Leggeri (<= 3.5t)",
                "stat_special": "Con ADR o Sponda",
                "search_placeholder": "Cerca per nome, targa, modello o vettore...",
                "filter_all_types": "Tutti i tipi",
                "filter_all_carriers": "Tutti i vettori",
                "view_cards": "Schede",
                "view_table": "Tabella",
                "no_vehicles": "Nessun veicolo trovato",
                "no_vehicles_desc": "Nessun veicolo corrisponde ai filtri di ricerca impostati.",
                "col_plate": "Targa",
                "col_name": "Nome Veicolo",
                "col_type": "Tipologia",
                "col_carrier": "Vettore",
                "col_dimensions": "Dimensioni (L x P x H)",
                "col_weight": "Peso Totale / Asse",
                "col_payload": "Portata Utile",
                "col_features": "Dotazioni",
                "col_actions": "Azioni",
                "badge_height": "Alt",
                "badge_width": "Larg",
                "badge_length": "Lung",
                "badge_weight": "PTT",
                "badge_axle_weight": "Max Asse",
                "badge_axles": "Assi",
                "badge_trailers": "Rimorchi",
                "badge_adr": "ADR",
                "badge_tail_lift": "Sponda",
                "badge_euro": "Euro",
                "modal_new_title": "Aggiungi Nuovo Veicolo",
                "modal_edit_title": "Modifica Veicolo: {name}",
                "tab_general": "Dati Generali",
                "tab_dimensions": "Dimensioni e Pesi",
                "tab_capacity": "Capacità e Dotazioni",
                "tab_preview": "Anteprima Sagoma",
                "field_name": "Nome / Identificativo Veicolo",
                "field_name_placeholder": "Es. Iveco Daily 35C, Eurocargo Nord, Bilico 1...",
                "field_plate": "Targa Veicolo",
                "field_plate_placeholder": "Es. AA 123 BB",
                "field_type": "Tipologia Sagoma Veicolo",
                "field_carrier": "Vettore Assegnato",
                "field_carrier_placeholder": "Seleziona vettore o lascia non assegnato...",
                "field_brand_model": "Marca e Modello",
                "field_brand_model_placeholder": "Es. Iveco Daily 3.0 HPI, Mercedes Actros 1845...",
                "field_notes": "Note / Avvertimenti Operativi",
                "field_notes_placeholder": "Note per la logistica, istruzioni o limitazioni particolari...",
                "field_height": "Altezza Massima (metri)",
                "field_width": "Larghezza Massima (metri)",
                "field_length": "Lunghezza Totale (metri)",
                "field_total_weight": "Massa a Pieno Carico - PTT (tonnellate)",
                "field_axle_weight": "Carico Massimo per Asse (tonnellate)",
                "field_axles_count": "Numero di Assi",
                "field_trailers_count": "Numero di Rimorchi",
                "field_payload": "Portata Utile (kg)",
                "field_cargo_volume": "Volume Vano Carico (m³)",
                "field_max_speed": "Velocità Massima Mezzo (km/h)",
                "field_euro_class": "Classe Ambientale / Emissioni",
                "field_has_tail_lift": "Dotato di Sponda Idraulica di Carico",
                "field_has_adr": "Abilitato Trasporto Merci Pericolose (ADR)",
                "field_adr_tunnel_category": "Categoria Restrizione Tunnel ADR",
                "field_is_active": "Veicolo Attivo nella Flotta",
                "btn_apply_template": "Carica Sagoma Rapida",
                "btn_save": "Salva Veicolo",
                "modal_templates_title": "Seleziona Sagoma Veicolo Predefinita",
                "templates_desc": "Scegli una sagoma standard per compilare rapidamente le dimensioni e i vincoli fisici del veicolo.",
                "btn_use_template": "Usa questa sagoma",
                "confirm_delete_title": "Elimina Veicolo",
                "confirm_delete_msg": "Sei sicuro di voler eliminare il veicolo \"{name}\" ({plate})? Questa azione non può essere annullata.",
                "confirm_reset_msg": "Sei sicuro di voler ripristinare la flotta veicoli predefinita? Tutte le modifiche locali andranno perse.",
                "import_success": "Flotta veicoli importata con successo ({count} veicoli caricate).",
                "import_error": "File JSON non valido o formato non riconosciuto."
            }
        },
        "at": {
            "breadcrumb": {
                "pianificazione_attivita": "Pianificazione attività",
                "lista_attivita": "Lista attività",
                "lista_ordini": "Lista ordini"
            },
            "fields": {
                "title": "Titolo",
                "description": "Descrizione",
                "client": "Cliente",
                "job": "Commessa",
                "owner": "Assegnatario",
                "start_date": "Data Inizio",
                "start_time": "Ora Inizio",
                "end_date": "Data Fine",
                "end_time": "Ora Fine",
                "delivery_date": "Data consegna",
                "priority": "Priorità",
                "status": "Stato",
                "date": "Data",
                "user": "Utente",
                "hours": "Ore",
                "total_hours": "Ore totali",
                "work_date": "Data di lavoro",
                "hours_worked": "Ore lavorate",
                "work_description": "Descrizione del lavoro svolto",
                "order_number": "N. Ordine",
                "order_date": "Del",
                "actions": "Azioni",
                "unit": "Reparto",
                "expected_delivery_date": "Consegna prevista"
            },
            "filters": {
                "all_select": "Tutte"
            },
            "actions": {
                "new_activity": "+ Nuova Attività",
                "new_activity_due": "Nuova Attività",
                "edit": "Modifica",
                "add": "Aggiungi",
                "update": "Aggiorna",
                "close": "Chiudi",
                "details": "Dettagli",
                "register_time": "Registra tempo",
                "work_details": "Dettagli lavorazione",
                "delete": "Elimina",
                "cancel": "Annulla",
                "confirm": "Conferma",
                "generate_activities": "Genera attività",
                "add_activity_btn": "+ Aggiungi attività",
                "remove_activity": "Rimuovi attività",
                "select_user": "Seleziona un utente",
                "searching": "🔍 Ricerca in corso...",
                "start_typing_client": "Inizia a digitare per cercare un cliente...",
                "select_unit": "Seleziona reparto"
            },
            "priority": {
                "bassa": "Bassa",
                "media": "Media",
                "alta": "Alta",
                "critica": "Critica"
            },
            "status": {
                "nuova": "Nuova",
                "assegnata": "Assegnata",
                "schedulata": "Schedulata",
                "in_lavorazione": "In Lavorazione",
                "completata": "Completata"
            },
            "messages": {
                "success": "Successo",
                "error": "Errore",
                "creating": "Creazione in corso...",
                "updating": "Aggiornamento in corso...",
                "deleting": "Eliminazione in corso...",
                "registering": "Registrando...",
                "activity_created": "Attività creata con successo",
                "activity_updated": "Attività aggiornata con successo",
                "activity_deleted": "Attività eliminata con successo",
                "error_create": "Si è verificato un errore durante la creazione dell'attività",
                "error_update": "Si è verificato un errore durante l'aggiornamento dell'attività",
                "error_delete": "Si è verificato un errore durante l'eliminazione dell'attività",
                "time_registered_title": "Tempo registrato",
                "creation_completed_title": "Creazione attività completata",
                "loading_details": "Caricamento dettagli...",
                "loading_activities": "Caricamento attività...",
                "no_time_records": "Nessuna registrazione di tempo trovata per questa attività.",
                "activity_not_found": "Attività non trovata",
                "work_time_registered": "Tempo di lavoro registrato con successo",
                "start_datetime_required": "La data/ora di inizio è obbligatoria",
                "start_datetime_invalid": "La data/ora di inizio non è valida",
                "end_datetime_required": "La data/ora di fine è obbligatoria",
                "end_datetime_invalid": "La data/ora di fine non è valida",
                "end_datetime_after_start": "La data/ora di fine deve essere successiva alla data/ora di inizio",
                "start_time_format": "L'orario di inizio deve essere nel formato HH{mm}",
                "end_time_format": "L'orario di fine deve essere nel formato HH{mm}"
            },
            "params": {
                "work_hours_config": "Configurazione Orari di Lavoro",
                "daily_work_hours": "Ore Lavorative Giornaliere",
                "working_hours": "Orari di Lavoro",
                "morning_start": "Inizio Turno Mattina",
                "morning_end": "Fine Turno Mattina",
                "afternoon_start": "Inizio Turno Pomeriggio",
                "afternoon_end": "Fine Turno Pomeriggio"
            },
            "lista_attivita": {
                "title": "Lista Attività",
                "details_modal_title": "Dettagli attività",
                "edit_modal_title": "Modifica attività",
                "add_modal_title": "Aggiungi attività",
                "time_modal_title": "Registra Tempo di Lavoro",
                "work_details_modal_title": "Dettagli Lavorazione",
                "delete_confirm_title": "Conferma Eliminazione Attività",
                "delete_confirm_text": "Sei sicuro di voler procedere con l'eliminazione dell'attività?",
                "client_label": "Cliente:",
                "total_hours_label": "Ore totali:",
                "current_total_hours": "Ore totali attuali:",
                "total_registered_hours": "Totale ore registrate:",
                "hours_placeholder": "Es. 2.5",
                "work_description_placeholder": "Descrivi brevemente il lavoro svolto...",
                "work_date_placeholder": "Seleziona la data di lavoro"
            },
            "lista_ordini": {
                "preview_modal_title": "Anteprima Attività da Creare",
                "activities_to_create_prefix": "Verranno create",
                "activities_to_create_suffix": "nuove attività per l'ordine selezionato",
                "existing_activities_suffix": "attività già esistenti",
                "invalid_activities_suffix": "attività non valide (descrizione mancante)",
                "description_label": "Descrizione:",
                "description_placeholder": "Inserisci la descrizione dell'attività",
                "description_required": "La descrizione è obbligatoria",
                "start_date_label": "Data inizio:",
                "end_date_label": "Data fine:",
                "delivery_date_label": "Prevista consegna:",
                "owner_label": "Assegnatario:",
                "creating": "Creazione...",
                "confirm_creation": "Conferma Creazione",
                "activities_created_count_suffix": "attività sono state create."
            }
        },
        "go": {
            "breadcrumb": {
                "gestione_ordini": "Gestione ordini",
                "lista_ordini": "Lista Ordini",
                "lista_proposte_offerte": "Lista Proposte/Offerte",
                "visualizza_mail": "Visualizza Mail"
            },
            "doc_status": {
                "order": "Ordine",
                "offert": "Offerta",
                "draft": "Proposta"
            },
            "tabs": {
                "main": "DATI PRINCIPALI",
                "document_notes": "NOTE DOCUMENTO",
                "shipping": "SPEDIZIONE",
                "charges": "SPESE"
            },
            "actions": {
                "save_changes": "Salva modifiche",
                "save_changes_unsaved": "⚠️ Salva modifiche",
                "convert_to_offer": "Converti in offerta",
                "import_from_offer": "Importa da offerta",
                "send_to_mago": "Invia a Mago",
                "edit_on_mago": "Modifica su Mago",
                "customer_signature": "Firma Cliente",
                "dms": "DMS",
                "delete": "Elimina",
                "cancel": "Annulla",
                "confirm": "Conferma",
                "apply": "Applica",
                "send": "Invia",
                "save": "Salva",
                "new": "Nuovo",
                "open": "Apri",
                "continue": "Continua",
                "back_to_orders": "Torna alla gestione ordini",
                "back_to_list": "Torna alla lista",
                "download_eml": "Scarica .EML",
                "new_order": "Nuovo ordine",
                "open_related_order": "Apri Ordine associato",
                "clear_signature": "Cancella firma",
                "save_signature": "Salva firma",
                "load_customer_notes": "Carica note cliente",
                "request_approval": "Richiedi Approvazione",
                "request_correction": "Richiedi Correzione",
                "approve_document": "Approva documento",
                "reject_document": "Rifiuta documento",
                "add_goods": "Aggiungi Merce",
                "add_service": "Aggiungi Servizio",
                "add_note": "Aggiungi Nota",
                "add_descriptive": "Aggiungi Descrittiva",
                "insert_as_out_of_stock": "Inserisci come fuori Magazzino",
                "no_only_main": "No, solo principale",
                "yes_include_all": "Sì, includi tutti",
                "print": "Stampa documento",
                "select": "Seleziona",
                "send_mail": "Invio Mail"
            },
            "fields": {
                "number": "Numero",
                "doc_type": "Tipo documento",
                "customer": "Cliente",
                "contact": "Contatto",
                "date": "Del",
                "validity_end": "Fine Validità",
                "expected_delivery": "Data prevista consegna",
                "mago_order_number": "Numero ordine mago",
                "mago_quota_number": "Numero offerta mago",
                "customer_order_ref": "Rif. Ordine Cliente",
                "agent": "Agente",
                "customer_discount": "Sconto cliente",
                "payment": "Pagamento",
                "priority": "Priorità",
                "created_by": "Creato da:",
                "last_modified_by": "Ultima modifica di:",
                "document_details": "Dettagli documento",
                "row_type": "Tipo riga",
                "item_code": "Codice Articolo",
                "description": "Descrizione",
                "position": "Posizione",
                "row_status": "Stato",
                "pricelist": "Listino",
                "uom": "Unità di misura",
                "uom_short": "UM",
                "qty": "Quantità",
                "price": "Prezzo",
                "discount": "Sconto",
                "taxable": "Imponibile",
                "row_note": "Nota",
                "tax_code_col": "Cod. IVA",
                "row_total": "Totale Riga",
                "tax_code_full": "Codice IVA",
                "tax_amount": "Imposta",
                "total": "Totale",
                "item_article": "Articolo",
                "homogeneous_ctg": "Categoria Omogenea",
                "commodity_ctg": "Categoria Merceologica",
                "product_ctg": "Categoria Prodotto",
                "item_type": "Tipo Articolo",
                "producer": "Produttore",
                "info": "Info",
                "subject": "Oggetto",
                "sender": "Mittente",
                "date_label": "Data",
                "assigned_user": "Utente assegnato",
                "priority_label": "Priorità:",
                "tax_code_iva": "Codice Iva",
                "taxable_total": "Totale Imponibile",
                "vat_percentage": "% IVA",
                "vat_amount": "Importo IVA",
                "row_total_vat": "Totale Riga (IVA inclusa)",
                "allowances": "Importo Abbuono",
                "goods_total": "Totale merci",
                "services_total": "Totale servizi",
                "discount_total": "Totale sconto",
                "vat_total": "Totale IVA",
                "document_total": "Totale Documento",
                "freesample_total": "Totale omaggi",
                "to_pay": "Totale da pagare",
                "raee_total": "Totale RAEE",
                "transport_charges": "Spese di trasporto:",
                "collection_charges": "Spese di incasso:",
                "accessory_charges": "Spese accessorie:",
                "vat_breakdown": "Castelletto IVA",
                "delivery_branch": "Sede di consegna",
                "generic_branch": "Sede generica",
                "selected_branch": "Sede selezionata:",
                "carrier": "Primo Vettore",
                "select_carrier": "Seleziona vettore",
                "to_determine": "Da determinare",
                "select_placeholder": "Seleziona",
                "sale_type": "Tipo Vendita",
                "sale_type_normal": "Normale",
                "sale_type_total_free_sample": "Omaggio totale",
                "sale_type_taxable_free_sample": "Omaggio imponibile",
                "none_specified": "Nessuno specificato",
                "unit_value": "Valore unitario",
                "net_price": "Prezzo Netto",
                "extra_discount_default": "Ulteriore sconto default:",
                "item_notes": "Note articolo",
                "cod_iva_label": "Cod. IVA:",
                "packages": "Confezioni",
                "exclude_print": "Escludi dalla stampa",
                "exclude_invoice": "Escludi dalla fattura",
                "exclude_ddt": "Escludi dal DDT"
            },
            "line_types": {
                "goods": "Merce",
                "service": "Servizio",
                "descriptive": "Descrittiva",
                "note": "Nota"
            },
            "availability": {
                "available": "Disponibile",
                "not_available_with_orders": "Non disponibile con ordini in arrivo",
                "not_available": "Non disponibile",
                "no_info": "Informazione non disponibile"
            },
            "vat_breakdown": {
                "no_details": "Nessun dettaglio IVA disponibile",
                "total_row": "TOTALE"
            },
            "document_notes_placeholder": "Inserisci note documento (verranno riportate in stampa e su Mago)",
            "private_note_placeholder": "Inserisci note ad uso interno (non verranno riportate in stampa)",
            "modals": {
                "confirm_delete_title": "Conferma eliminazione",
                "confirm_delete_content": "Sei sicuro di voler eliminare questo documento?",
                "confirm_delete_mago_note": "(Il documento corrispondente di MAGO {doc_no} verrà eliminato anch'esso.)",
                "confirm_delete_mago_quota_note": "(L'offerta corrispondente di MAGO {doc_no} verrà eliminata anch'essa.)",
                "confirm_delete_row_title": "Conferma eliminazione riga",
                "confirm_delete_row_content": "Sei sicuro di voler eliminare questa riga? Le modifiche saranno applicate solo salvando il documento.",
                "confirm_signature_title": "Conferma registrazione firma",
                "confirm_signature_content": "Sei sicuro di voler registrare la firma? Questo bloccherà qualsiasi modifica futura al documento.",
                "min_reorder_qty_title": "Quantità minima riordino",
                "min_reorder_qty_content": "La quantità selezionata supera la disponibilità totale. Questo articolo prevede una quantità minima di riordino al fornitore pari a {qty}, vuoi continuare?",
                "email_addresses_title": "Selezione Indirizzi Email",
                "email_addresses_content": "Vuoi includere anche gli indirizzi email delle persone di riferimento collegate al cliente?",
                "confirm_delete_mail_title": "Conferma eliminazione mail",
                "confirm_delete_mail_content": "Sei sicuro di voler eliminare questa mail?",
                "detail_modal_title": "Dettaglio riga",
                "out_of_stock_label": "fuori magazzino",
                "select_goods": "merce",
                "select_service": "servizio",
                "select_article": "articolo",
                "select_kit_component": "componente kit",
                "customer_notes_title": "Note Cliente:",
                "internal_notes": "Note a uso interno",
                "internal_notes_2": "Note interne",
                "other_notes": "Altre note",
                "no_customer_notes": "Nessuna nota presente per questo cliente.",
                "dms_attachments": "Allegati DMS",
                "attachment_label": "° Allegato",
                "email_send_title": "Invio Mail",
                "to_placeholder": "Destinatari",
                "cc_placeholder": "Aggiungi in copia (separati da punto e virgola)",
                "subject_placeholder": "Oggetto",
                "body_placeholder": "Testo del messaggio...",
                "document_locked_title": "Documento in uso",
                "document_locked_content": "Questo documento è attualmente aperto da {user}. Non puoi modificarlo finché l'altro utente non lo chiude.",
                "document_locked_force_title": "Documento in uso da altro utente",
                "document_locked_force_content": "Il documento è aperto da {user}. Vuoi forzare l'accesso? L'altro utente verrà espulso.",
                "document_force_access": "Forza accesso",
                "document_view_readonly": "Visualizza in sola lettura",
                "document_kicked_title": "Sessione terminata",
                "document_kicked_content": "Un amministratore ha forzato l'accesso a questo documento. Verrai riportato alla lista."
            },
            "deep_tables": {
                "select_payment": "Seleziona Pagamento",
                "select_customer": "Seleziona Cliente",
                "select_contact": "Seleziona Contatto",
                "select_homogeneous_ctg": "Seleziona Categoria Omogenea",
                "select_commodity_ctg": "Seleziona Categoria Merceologica",
                "select_product_ctg": "Seleziona Categoria Prodotto",
                "select_producer": "Seleziona Produttore",
                "select_tax_code": "Seleziona Codice IVA",
                "select_collection_tax_code": "Seleziona Codice IVA per le spese di incasso",
                "select_offer": "Seleziona Offerta",
                "select_item_type": "Seleziona Tipo Articolo",
                "show_disabled": "Mostra anche disabilitati",
                "use_contacts": "Usa Contatti",
                "no_elements": "Nessun elemento disponibile"
            },
            "lista_ordini": {
                "title": "Lista Ordini",
                "title_drafts": "Lista Bozze/Offerte",
                "label": "Lista ordini web",
                "label_drafts": "Lista bozze/offerte web"
            },
            "lista_mail": {
                "title": "Lista mail",
                "show_filter": "Mostra Mail",
                "new_unread": "Nuove/utente",
                "all_active": "Tutte attive",
                "mail_detail": "Dettaglio Mail",
                "loading": "Caricamento...",
                "select_email": "Seleziona un'email per visualizzarla",
                "attachments_title": "Lista Allegati"
            },
            "messages": {
                "positions_modified": "Posizioni modificate. Ricorda di salvare il documento.",
                "import_success": "Importazione effettuata con successo",
                "import_error": "Errore durante l'importazione",
                "import_data_update_error": "Importazione completata ma errore nell'aggiornamento dati",
                "qty_must_be_positive": "La quantità deve essere maggiore di 0",
                "item_already_in_mago": "Articolo già censito in Mago, modifica il codice articolo o usa Aggiungi Merce/Servizio",
                "validation_error": "Errore durante la validazione della riga personalizzata",
                "uom_required": "L'unità di misura deve essere specificata",
                "item_or_desc_required": "L'articolo o la descrizione devono essere specificati",
                "row_added": "Linea aggiunta. Ricorda di salvare il documento.",
                "changes_applied": "Modifiche applicate. Ricorda di salvare il documento.",
                "add_cancelled": "Aggiunta articolo annullata.",
                "row_removed": "Riga rimossa. Ricorda di salvare il documento.",
                "doc_deleted": "Documento eliminato con successo.",
                "delete_error": "Errore durante la cancellazione",
                "doc_saved": "Documento salvato con successo",
                "save_error": "Errore durante il salvataggio",
                "save_data_error": "Documento salvato ma errore nell'aggiornamento dati",
                "sending_to_mago": "Invio ordine Mago in corso...",
                "sending_quote_to_mago": "Invio offerta Mago in corso...",
                "order_sent_to_mago": "Ordine correttamente inviato a Mago",
                "offer_sent_to_mago": "Offerta correttamente inviata a Mago",
                "mago_send_error": "Errore durante l'invio a Mago",
                "mago_data_update_error": "Ordine inviato ma errore nell'aggiornamento dati",
                "saving": "Salvataggio in corso...",
                "saving_signature": "Registrazione documento firmato su Mago in corso...",
                "signature_saved": "Firma salvata con successo su Mago",
                "signature_error": "Errore durante il salvataggio della firma",
                "updating_prices": "Aggiornamento prezzi in corso...",
                "deleting": "Cancellazione in corso...",
                "signature_required": "Per favore, completa la firma prima di salvare.",
                "select_customer_before_mail": "Seleziona un cliente prima di inviare la mail",
                "select_contact_before_mail": "Seleziona un contatto prima di inviare la mail",
                "fetching_emails": "Recupero indirizzi email...",
                "generating_pdf": "Generazione PDF e invio email...",
                "email_recipient_required": "Inserisci almeno un destinatario",
                "doc_deleted_success": "Documento eliminato con successo.",
                "doc_not_found": "Documento non trovato.",
                "invalid_doc_id": "ID documento non valido.",
                "loading": "Caricamento...",
                "unit_value_required": "Il valore unitario deve essere specificato",
                "error_loading_emails": "Errore nel recupero email",
                "error_sending_email": "Errore durante l'invio dell'email",
                "email_body_template": "Gentile cliente {companyname},\nin allegato Le inviamo il documento in oggetto.\n\nCordiali saluti."
            },
            "headers": {
                "sender": "Mittente",
                "subject": "Oggetto",
                "date": "Data",
                "doc_number": "Numero",
                "doc_date": "Del",
                "status": "Stato",
                "customer_contact": "Cliente/Contatto",
                "customer": "Cliente",
                "author": "Autore",
                "approval": "Approvazione",
                "sent_to_mago": "Inviato Mago",
                "converted_to_order": "Convertito Ordine",
                "code": "Codice",
                "company_name": "Ragione Sociale",
                "address": "Indirizzo",
                "zip_code": "CAP",
                "city": "Città",
                "county": "Provincia",
                "country": "Stato",
                "fiscal_code": "Codice Fiscale",
                "email": "Email",
                "phone": "Telefono",
                "payment_desc": "Descrizione",
                "discount_pct": "Percentuale Sconto",
                "collection_charges": "Spese di incasso",
                "tax_rate": "% Aliquota",
                "department": "Reparto",
                "producer": "Produttore",
                "product_ctg": "Categoria Prodotto",
                "item_type": "Tipo Articolo",
                "homogeneous_ctg": "Categoria Omogenea",
                "commodity_ctg": "Categoria Merceologica",
                "to_approve": "Da approvare",
                "to_correct": "Da correggere"
            },
            "approval_status": {
                "not_requested": "Non richiesta",
                "requested": "Richiesta",
                "approved": "Approvata",
                "rejected": "Rifiutata"
            },
            "parameters": {
                "email_view_label": "Split View",
                "email_view_description": "Visualizzazione divisa email | Ordini",
                "email_send_label": "Invio email",
                "email_send_description": "Abilita invio email da portale con PDF allegato",
                "copy_docno_to_externalordno_label": "Riporta numero documento portale su ExternalOrdNo",
                "copy_docno_to_externalordno_description": "Scrivi il numero documento del portale su ExternalOrdNo di Mago (ExternalOrderId sarà popolato a prescindere)",
                "block_changes_after_mago_sent_label": "Blocca modifiche dopo invio a Mago",
                "block_changes_after_mago_sent_description": "Inibisci possibilità di eliminare e modificare documento su mago una volta inviato (non usare insieme a email o gestione firma)",
                "filter_customers_by_agent_label": "Filtra clienti per agente",
                "filter_customers_by_agent_description": "Se abilitato, verranno mostrati solo i clienti associati all'agente collegato all'account loggato",
                "block_pricelist_change_label": "Blocca modifica listino prezzi",
                "block_pricelist_change_description": "Impedisce la modifica del listino prezzi nelle righe dell'ordine",
                "check_available_on_row_insert_label": "Controlla disponibilità alla creazione riga",
                "check_available_on_row_insert_description": "Controlla la disponibilità dell'articolo al momento dell'inserimento di una nuova riga ordine se la quantità minima di riordino fornitore è > 0",
                "allow_pricerow_zero_label": "Permetti righe a prezzo zero",
                "allow_pricerow_zero_description": "Consente di inserire righe con prezzo unitario pari a zero che verranno mostrate con \"da determinare\" anche in stampa",
                "use_thousand_separator_label": "Separatore delle migliaia",
                "use_thousand_separator_description": "Se abilitato, i totali del documento vengono visualizzati con il separatore delle migliaia (es. 1.234,56)",
                "handle_signature_label": "Gestione firma",
                "handle_signature_description": "Abilita la gestione della firma di conferma per gli ordini (0 disattivo, 1 solo cliente)",
                "show_dms_content_label": "Mostra contenuti DMS",
                "show_dms_content_description": "Mostra i documenti collegati tramite DMS nell'interfaccia ordine",
                "show_customers_extra_data_label": "Mostra dati aggiuntivi in ricerca cliente",
                "show_customers_extra_data_description": "Mostra il codice fiscale, l'email e il numero di telefono del cliente nella ricerca da ordine",
                "show_items_extra_data_label": "Mostra dati aggiuntivi in ricerca articolo",
                "show_items_extra_data_description": "Mostra la locazione, categoria RAEE e percentuale provvigione agente. 0 = disabilitato, 1 = locazione (MA_ItemsGoodsData.Location), 2 = locazione (MA_ItemsWMSZones.FixedBinPicking)",
                "show_items_notes_label": "Mostra note articolo",
                "show_items_notes_description": "Mostra le note articolo (di vendita) nel dettaglio riga. Rallenta il calcolo dei totali di riga, usare solo se necessario",
                "divide_documents_by_creator_label": "Separa i documenti per autore (admin vede tutto)",
                "divide_documents_by_creator_description": "Se abilitato, gli utenti vedranno solo i documenti che hanno creato, gli admin vedranno tutti i documenti",
                "pricelist_imel_label": "Gestione listini prezzi personalizzati IMEL",
                "pricelist_imel_description": "Se abilitato verranno utilizzati i criteri di selezione listini prezzi specifici per IMEL",
                "force_admin_approval_label": "Forza approvazione admin",
                "force_admin_approval_description": "Se abilitato, gli ordini richiederanno l'approvazione di un admin prima di poter passare in mago",
                "reset_qty_on_uom_change_label": "Reset quantità al cambio unità di misura",
                "reset_qty_on_uom_change_description": "Se abilitato, la quantità verrà resettata quando si cambia l'unità di misura",
                "filter_items_by_pricelist_label": "Filtra articoli per listino prezzi",
                "filter_items_by_pricelist_description": "Se viene specificato questo listino prezzi, lo utilizza per filtrare gli articoli disponibili e lo imposta come default",
                "show_suggested_price_label": "Mostra prezzo suggerito",
                "show_suggested_price_description": "Se abilitato, verrà mostrato il prezzo di listino nella voce prezzo suggerito delle info articolo",
                "show_pricelist_info_label": "Mostra info listini articolo",
                "show_pricelist_info_description": "Mostra un pulsante informativo sui listini dell'articolo nella riga ordine e nella scheda articolo",
                "personalizzazioni_imel_label": "Personalizzazioni IMEL",
                "personalizzazioni_imel_description": "Abilita o disabilita le personalizzazioni specifiche per IMEL"
            }
        },
        "modules": {
            "anagrafiche": "Anagrafiche",
            "visite-commerciali": "Visite Commerciali",
            "reception-digitale": "Reception Digitale",
            "contratti": "Contratti",
            "attivita": "Attività",
            "estratto-conto": "Estratto Conto",
            "gestione-magazzino": "Gestione Magazzino",
            "gestione-ordini": "Gestione Ordini",
            "inventario": "Inventario",
            "ricezione-merce": "Ricezione Merce da Ordine Fornitore",
            "evasione-ordini": "Evasione Ordini",
            "rettifica": "Rettifica",
            "calendario": "Calendario",
            "mappa": "Mappa",
            "contatti": "Contatti",
            "clienti-fornitori": "Clienti e Fornitori",
            "registro": "Registro",
            "visitatori-abituali": "Visitatori Abituali",
            "badge": "Badge",
            "report": "Report",
            "real-time": "Tempo reale",
            "rinnovo": "Rinnovo",
            "emissione": "Emissione",
            "gestione-modelli-contratti": "Gestione Modelli Contratti",
            "ricerca-contratti": "Ricerca Contratti",
            "nuovo-contratto": "Nuovo Contratto",
            "controllo-copie": "Controllo Copie",
            "report-pacchetti-ore": "Report Pacchetti Ore",
            "lista-ordini": "Ordini Cliente",
            "lista-offerte": "Lista Proposte/Offerte",
            "lista-ordini-attivita": "Attività da Ordini Cliente",
            "lista-attivita": "Attività",
            "calendario-attivita": "Calendario Attività",
            "gantt-attivita": "Gantt Attività",
            "rapportini-intervento": "Rapportini Intervento",
            "report-odierno": "Report odierno",
            "report-visite": "Report visite",
            "report-consegne": "Report consegne",
            "sblocco-ingressi": "Sblocco Ingressi",
            "registro-uscita": "Registro Uscita",
            "scarico-componenti": "Scarico Componenti",
            "ricezione-veneta": "Ricezione Veneta",
            "registri-personalizzati": "Registri Personalizzati",
            "conferma_bolle_carico": "Gestione Bolle di Carico e Posizionamento Merce",
            "percorsi-vettori": "Percorsi Vettori",
            "analisi": "Analisi",
            "ordinato-agente": "Ordinato per Agente",
            "fatturato-agente": "Fatturato per Agente",
            "gestione_ubicazioni_icam": "Gestione Ubicazioni ICAM",
            "generazione-itinerari": "Crea Percorso",
            "gestione-itinerari": "Percorsi Salvati",
            "accesso-totem": "Accesso Totem",
            "ricezione-merce-senza-ordine": "Carico Merce senza Ordine Fornitore",
            "rilevazione-commesse": "Rilevazione Commesse",
            "storico-rilevazioni": "Storico Rilevazioni",
            "rilevazione-ora-su-commessa": "Rilevazione ora su commessa",
            "info-articoli": "Info Articoli",
            "commit-in-beta": "Commit in Beta",
            "confronto-stradari": "Confronto Stradari",
            "carica-excel": "Carica Excel",
            "reparti-attivita": "Reparti",
            "contratti-attivita": "Attività da Contratti",
            "info-ordini": "Info Ordini",
            "associa-barcode": "Associa Barcode",
            "approvazione-bolle-temp": "Approvazione Bolle Temporanee",
            "registrazione-ticket": "Registrazione Ticket",
            "pannello-di-controllo": "Pannello di Controllo",
            "gestione-produzione": "Gestione Produzione",
            "buono-prelievo": "Buono di Prelievo",
            "consuntiva-produzione": "Consuntiva Produzione",
            "resoconto-odp": "Resoconto Ordini di Produzione",
            "picking-list": "Picking",
            "reminders-attivita": "Promemoria",
            "riconoscimento-documenti": "Riconoscimento Documenti",
            "simulazione-costificazione": "Simulazione Costificazione",
            "veicoli": "Veicoli",
            "riconoscimento-documenti-ai": "Riconoscimento Documenti AI",
            "prove-di-consegna": "Prove di Consegna",
            "affidamenti": "Affidamenti",
            "riconoscimento-affidamenti": "Riconoscimento Affidamenti"
        },
        "auth": {
            "failed": "Credenziali non valide.",
            "password": "Il campo {attribute} non è corretto.",
            "throttle": "Troppi tentativi di accesso. Riprova tra {seconds} secondi.",
            "already_logged_in": "L'utente è già connesso da un altro dispositivo o posizione.",
            "force_logout_prompt": "Clicca qui sotto per forzare il logout dell'altra sessione e continuare.",
            "force_logout_button": "Forza Logout e Continua",
            "too_many_customer_sessions": "Troppe utenze connesse per questo cliente.",
            "log_in_title": "Accedi",
            "email": "Email",
            "password_label": "Password",
            "remember_me": "Ricordami",
            "forgot_password": "Password dimenticata?",
            "session_already_active": "Sessione Già Attiva"
        },
        "customers": {
            "imel": {
                "go": {
                    "actions": {
                        "insert_as_out_of_stock": "Inserisci come su Misura"
                    },
                    "modals": {
                        "out_of_stock_label": "su misura"
                    }
                },
                "modules": {
                    "lista-offerte": "Lista Preventivi"
                },
                "ui": {
                    "out_of_inventory": "Su Misura"
                },
                "gm": {
                    "reg-confirm": "Salva letture"
                }
            },
            "molino-di-borgo": {
                "ui": {
                    "ulteriore_sconto": "Sconto Pagamento"
                }
            }
        },
        "vc": [],
        "passwords": {
            "reset": "Votre mot de passe a été réinitialisé.",
            "sent": "Nous vous avons envoyé un lien de réinitialisation de mot de passe par e-mail.",
            "throttled": "Veuillez patienter avant de réessayer.",
            "token": "Ce jeton de réinitialisation de mot de passe n'est pas valide.",
            "user": "Nous ne trouvons pas d'utilisateur avec cette adresse e-mail."
        },
        "sc": {
            "scarico_component_title": "Scarico Componente",
            "article": "Articolo:",
            "description": "Descrizione:",
            "available": "Disponibile:",
            "minimum_stock": "Minimo stock:",
            "quantity_less_than_minimum_stock": "La quantità prelevata è inferiore al minimo stock",
            "lot": "Lotto",
            "quantity_picked": "Quantità prelevata:",
            "enter_barcode_and_select_storage": "Inserire un codice a barre e selezionare un magazzino",
            "item_not_found": "Articolo non trovato",
            "search_error": "Errore nella ricerca",
            "product_not_available": "Prodotto non disponibile in magazzino",
            "quantity_reduced_to_max": "Quantità ridotta al massimo disponibile",
            "invalid_quantity": "Quantità non valida",
            "quantity_exceeds_availability": "Quantità superiore alla disponibilità",
            "discharge_completed": "Scarico completato con successo",
            "discharge_error": "Errore durante lo scarico",
            "loading_discharge": "Scarico in corso... ",
            "magiclink_note": "Scarico componenti - {item}",
            "select_product": "Seleziona Prodotto",
            "multiple_products_found": "Sono stati trovati più prodotti. Seleziona quello corretto:",
            "csv_preview": "Anteprima CSV",
            "quantity": "Quantità",
            "confirm_all": "Conferma tutto",
            "select_storage_first": "Seleziona prima un magazzino",
            "empty_or_invalid_csv": "CSV vuoto o non valido",
            "processing_csv": "Elaborazione CSV in corso...",
            "all_items_discharged": "Tutti gli articoli scaricati con successo",
            "discharge_with_errors": "Completato: {success} successi, {errors} errori",
            "csv_data": "Dati CSV",
            "not_found": "Non trovato",
            "found": "Trovato",
            "no_valid_items": "Nessun articolo valido da scaricare",
            "storage": "Sede:",
            "storage_mismatch": "Depositi non combaciano",
            "lot_mismatch": "Lotti non combaciano",
            "insufficient_stock": "Giacenza insufficiente",
            "storage_reason_mapping": "Associazione Depositi - Causali",
            "movement_reason": "Causale Movimento",
            "select_reason": "Seleziona Causale",
            "invalid_csv_format": "Formato CSV non valido. L'header deve avere esattamente {count} colonne in questo ordine: {header}",
            "to_discharge": "da scaricare",
            "discharged": "scaricato",
            "discharge_with_errors_summary": "Completati {success} su {total} depositi.",
            "missing_reason_for_storage": "Manca causale per deposito {storage}",
            "no_items_to_process": "Nessun articolo valido da elaborare",
            "select_storage_placeholder": "-- Seleziona deposito --",
            "select_reason_placeholder": "-- Seleziona Causale --",
            "reason_after_first_item_info": "La causale di movimentazione potrà essere selezionata dopo l'inserimento del primo articolo",
            "specificator_customer": "Cliente",
            "specificator_supplier": "Fornitore",
            "stock_short": "Giac:",
            "stock": "Giacenza:",
            "duplicate_item_title": "Item già scannerizzato",
            "duplicate_item_message": "Hai già scannerizzato questo prodotto, vuoi inserirlo nuovamente?",
            "pending_items_title": "Articoli da scaricare",
            "discharge_all": "Scarica tutti",
            "reasons_per_storage": "Causali per deposito",
            "table_storage": "Deposito",
            "table_reason": "Causale",
            "header_item": "Articolo",
            "header_description": "Descrizione",
            "header_lot": "Lotto",
            "header_quantity": "Quantità",
            "header_uom": "UdM",
            "csv_header_item": "Articolo",
            "csv_header_lot_comparison": "Lotto (CSV - MAGO)",
            "csv_header_storage_comparison": "Deposito (CSV - MAGO)",
            "csv_header_book_inv": "Giacenza",
            "csv_header_quantity": "Qta da scaricare",
            "csv_header_status": "Stato",
            "batch_processing_error": "Errore durante l'elaborazione batch",
            "error_generic": "Errore",
            "discharge_during_error": "Errore durante lo scarico",
            "lot_search": "Ricerca per lotto",
            "choose_quantity": "Seleziona quantità",
            "item": "Articolo",
            "item_or_barcode": "Codice articolo o codice a barre"
        },
        "ec": {
            "parameters": {
                "force_agent_label": "Forza agente",
                "force_agent_description": "Se abilitato, gli account con agente assegnato non potranno cambiare l'agente di estratto conto"
            }
        },
        "ui": {
            "welcome_back": "Bentornato",
            "user_profile": {
                "link_label": "Profilo utente",
                "profile_information": {
                    "title": "Informazioni sul profilo",
                    "description": "Aggiorna le informazioni del tuo profilo e l'indirizzo email."
                },
                "password_update": {
                    "title": "Aggiorna password",
                    "description": "Assicurati di utilizzare una password lunga e casuale per rimanere al sicuro."
                }
            },
            "user_management": "Gestione utenti",
            "customer_management": "Gestione cliente",
            "customer_overview": "Riepilogo clienti",
            "current_password": "Password corrente",
            "new_password": "Nuova password",
            "confirm_password": "Conferma password",
            "proceed": "Procedi",
            "name": "Nome",
            "email": "Email",
            "choose_date": "Seleziona data",
            "choose_expired": "Scadenza Lotto",
            "delete_confirmation": {
                "title": "Conferma eliminazione",
                "description": "Sei sicuro di voler eliminare questo elemento? Questa azione non può essere annullata."
            },
            "cancel": "Annulla",
            "delete": "Elimina",
            "filters": "Filtri",
            "all_filters": "Tutti i filtri",
            "change_customer": "Cambia cliente",
            "dashboard": "Dashboard",
            "ui_policy": "Regole IU",
            "datepicker_locale": "it",
            "datepicker_format": "dd/MM/yyyy",
            "ulteriore_sconto": "Ulteriore sconto",
            "loading": "Caricamento...",
            "order_management": "Gestione ordini",
            "item_info": {
                "title": "Info articolo",
                "loading": "Caricamento dati articolo...",
                "general_data": "Dati Generali",
                "warehouse_status": "Situazione Magazzino",
                "item_code": "Articolo",
                "description": "Descrizione",
                "uom": "Unità di misura",
                "homogeneous_ctg": "Categoria omogenea",
                "commodity_ctg": "Categoria merceologica",
                "item_type": "Tipo Articolo",
                "tax_code": "Codice Iva",
                "base_price": "Prezzo base",
                "sale_bar_code": "Codice a barre di vendita",
                "internal_note": "Note interne",
                "stock": "Giacenza",
                "availability": "Disponibilità",
                "ordered_purch": "Ordinato Fornitore",
                "reserved_sale_ord": "Impegnato Ordini Clienti",
                "reserved_by_prod": "Impegnato Produzione",
                "ordered_to_prod": "Quantità in produzione",
                "theoretical_availability": "Disponibile Teorico",
                "minimum_sale_qty": "Qtà minima vendibile",
                "min_order_qty": "Qtà minima riordino fornitore",
                "expected_arrival_date": "Data di previsto arrivo",
                "suggested_price": "Prezzo consigliato",
                "no_data": "Nessun dato trovato per l'articolo {item}.",
                "pricelist_section_title": "Listini prezzi articolo",
                "pricelist_loading": "Caricamento listini...",
                "pricelist_code": "Listino",
                "pricelist_qty": "Qtà max",
                "pricelist_price": "Prezzo",
                "pricelist_uom": "U.M.",
                "pricelist_discount": "Sconto",
                "pricelist_no_data": "Nessun listino trovato per questo articolo.",
                "last_sale_value": "Ultimo prezzo di vendita cliente",
                "never_sold_to_customer": "Articolo mai venduto a questo cliente"
            },
            "out_of_inventory": "Fuori Magazzino",
            "loader": {
                "default_text": "Caricamento in corso...",
                "subtitle": "Attendere prego"
            },
            "modal_message": {
                "close": "Chiudi"
            },
            "notification": {
                "close": "Chiudi"
            },
            "client_selector_modal": {
                "select_client": "Seleziona cliente",
                "active_filter": "Filtro attivo:",
                "remove_filter": "Rimuovi filtro",
                "choose_client_title": "Scegli Cliente",
                "search_placeholder": "Cerca cliente...",
                "all_clients": "Tutti i clienti",
                "no_clients_found": "Nessun cliente trovato per \"{query}\"",
                "close": "Chiudi"
            },
            "richiesta_assistenza": {
                "title_it": "Richiesta assistenza",
                "title_en": "Assistance request",
                "sure_it": "Sei sicuro di voler contattare l'assistenza?",
                "sure_en": "Are you sure you want to contact support?",
                "cancel_it": "Annulla",
                "cancel_en": "Cancel",
                "confirm_it": "Conferma",
                "confirm_en": "Confirm",
                "sending_it": "Invio in corso...",
                "sending_en": "Sending...",
                "error_alert": "Si è verificato un errore. Riprova più tardi."
            },
            "emergency_info_modal": {
                "title": "Informativa per gli Ospiti",
                "understood": "Ho capito"
            },
            "tables": {
                "select_default": "Seleziona",
                "all": "Tutti",
                "filter_input_placeholder": "🔎︎ Filtra",
                "sort_by": "Ordina per",
                "ascending": "Crescente",
                "descending": "Decrescente",
                "no_sort": "Nessun ordinamento"
            }
        },
        "gm": {
            "scan_barcode_to_increment": "Passa il barcode per aumentare la quantità ricevuta di",
            "reception_data": "Dati di ricezione",
            "confirm_mismatched_quantities": "Conferma quantità non corrispondenti",
            "confirm_mismatched_quantities_description": "Alcune righe hanno una quantità totale (registrata + da registrare) diversa dalla quantità ordine.Vuoi continuare comunque?",
            "item_not_found_or_already_pickedup": "Articolo {item} non trovato o già prelevato nella lista di questi ordini",
            "barcode_mismatched": "Codice a barre non corrisponde a quello inserito",
            "normal": "Normale",
            "descriptive": "Descrittivo",
            "kitchen": "Cucina",
            "enter_the_quantity_to_be_shipped": "Indicare la quantità da spedire di",
            "warehouse_choice": "Scelta del magazzino",
            "add_selected_items": "Aggiungi selezionati",
            "insert_qty": "Inserisci quantità",
            "insert_qty_for": "Inserisci la quantità per",
            "article_details": "Dettagli articolo",
            "select_inventory_session": "Seleziona la sessione di inventario",
            "choose_session": "Scegli una sessione",
            "created_by": "Creato da",
            "deposit": "Deposito",
            "delete_session": "Elimina sessione",
            "create_new_inventory_session": "Crea nuova sessione inventario",
            "choose_a_warehouse": "Scegli un magazzino",
            "confirm_session_deletion": "Conferma eliminazione sessione",
            "confirm_session_deletion_confirm": "Sei sicuro di voler eliminare questa sessione di inventario? L'operazione non è reversibile.",
            "confirm_inventory": "Conferma inventario",
            "confirm_inventory_confirmation": "Vuoi confermare e chiudere questa sessione di inventario? Non sarà più modificabile",
            "list_supplier_orders": "Lista ordini fornitore",
            "list_client_orders": "Lista ordini cliente",
            "orphan_picking": "Picking senza ordine",
            "picking_rows": "Righe picking",
            "select_same_customer_orders": "Selezionare ordini dello stesso cliente.",
            "already_in_picking": "Già in picking",
            "open_picking_overview": "Picking in corso per questo cliente",
            "open_picking_overview_desc": "Documento n. {docno} con {count} articoli, di cui {other} da altri ordini dello stesso cliente.",
            "other_order": "Altro ordine",
            "confirm_picking": "Conferma prelievo",
            "no_qty_to_confirm": "Inserire una quantità da prelevare per almeno una riga.",
            "customer_not_found": "Cliente non trovato.",
            "picking_confirm_error": "Errore durante la conferma del picking.",
            "picking_confirmed": "Picking confermato con successo.",
            "select_item_variant": "Seleziona la variante articolo",
            "create_picking": "Crea picking",
            "search_customer": "Cerca cliente...",
            "start_typing_customer": "Inizia a digitare per cercare un cliente...",
            "list_bills_of_lading": "Lista bolle di carico",
            "filter_by": "Filtra per",
            "client": "cliente",
            "confirm": "Conferma",
            "icam_request_sent_successfully": "Richiesta ICAM inviata con successo",
            "confirm_bol": "Conferma Bolle di Carico",
            "confirm_bol_description": "Vuoi registrare le righe delle bolle di carico selezionate? L'operazione non è reversibile.",
            "send_request": "Invia Richiesta",
            "confirm_placing": "Conferma posizionamento",
            "order_by_sales_person": "Lista ordinato per Agente",
            "fatturato_per_agente": "Lista fatturato per agente",
            "search_by_warehouse": "Cerca per deposito",
            "search_by_lot_item": "Cerca per lotto o articolo",
            "search_method": "Metodo di ricerca",
            "by_storage": "Per Deposito (Barcode)",
            "by_item": "Per Codice Articolo",
            "by_lot": "Per Lotto",
            "by_barcode": "Solo Barcode",
            "select_item_lot": "Seleziona Articolo/Lotto",
            "insert_item_code": "Codice Articolo...",
            "insert_lot": "Numero Lotto...",
            "list_locations": "Lista ubicazioni per articolo",
            "gestione_ubicazioni_icam": "Gestione Ubicazioni ICAM",
            "reset_filters": "Reset filtri",
            "ordered_filter_period_1": "Filtro Ordinato 1° Periodo",
            "ordered_filter_period_2": "Filtro Ordinato 2° Periodo",
            "fatturato_filter_period_1": "Filtro Fatturato 1° periodo",
            "fatturato_filter_period_2": "Filtro Fatturato 2° Periodo",
            "fatturato_filter_period_3": "Filtro Fatturato 3° Periodo",
            "from": "Da",
            "to": "a",
            "agents_filter": "Filtro Agenti",
            "all_agents": "ALL (tutti gli agenti)",
            "totals": "Totali",
            "agent": "Agente",
            "name": "Nome",
            "company_name": "Rag. Sociale",
            "ordered": "Ordinato",
            "ordered_period_2": "Ordinato 2° periodo",
            "agent_name": "Nome Agente",
            "city": "Città",
            "address": "Indirizzo",
            "phone": "N° telefono",
            "fatturato_period_1": "Fatturato 1° periodo",
            "fatturato_period_2": "Fatturato 2° periodo",
            "fatturato_period_3": "Fatturato 3° periodo",
            "order_analysis_by_agent_client": "Analisi ordini per agente/cliente",
            "date_range_error": "La data \"Da\" deve essere minore o uguale alla data \"A\".",
            "overlap_error": "Attenzione!!! Hai scelto due periodi temporali che si sovrappongono.",
            "storage": "Deposito",
            "qty_already_set": "Quantità già impostata al massimo",
            "qty_exceeds_order": "La quantità per l'articolo {item} supera quella ordinata (max: {max}). Continuare?",
            "confirm_bin": "Conferma ubicazione",
            "insert_bin_to_confirm": "Inserisci l'ubicazione per confermare",
            "qty_differs_from_bol": "La quantità inserita è diversa dalla quantità su bolla",
            "qty_differs_from_remaining": "La quantità inserita è diversa dalla quantità rimanente nell'ordine",
            "item_not_managed_by_lots": "Articolo non gestito a lotti",
            "lot_config_not_available": "Configurazione lotto non disponibile",
            "lot_generated": "Lotto generato: ",
            "excess_material": "Materiale in eccedenza",
            "excess_reason": "Causale eccedenza",
            "same_as_order": "Uguale all'ordine",
            "item_found_not_in_order": "Articolo {item} ({description}) trovato ma non presente negli ordini selezionati",
            "item_not_found_in_system": "Articolo non trovato nel sistema",
            "barcode_not_found": "Codice a barre non trovato nel sistema",
            "added_to_excess": "Articolo aggiunto agli eccessi",
            "excess_items": "Articoli in eccesso",
            "clear_all": "Svuota tutto",
            "confirm_clear_excess": "Sei sicuro di voler svuotare la tabella degli eccessi?",
            "results_found": "Risultati trovati:",
            "show_zero_stock": "Mostra anche articoli con giacenza uguale a 0",
            "stock_short": "Giac:",
            "lot_short": "LOT:",
            "storage_short": "DEP:",
            "customer_short": "Cliente",
            "supplier_short": "Fornitore",
            "carica_excel": {
                "drag_hint": "Trascina qui il file Excel",
                "click_hint": "o clicca per sfogliare i documenti",
                "select_file": "Seleziona File",
                "upload_file": "Convalida file",
                "upload_other_file": "Carica un altro file",
                "cancel": "Annulla",
                "saving": "Salvataggio…",
                "save_data": "Salva dati",
                "uploaded_files": "File caricati",
                "rows_info": "{rows} righe · caricato il {date}",
                "delete": "Elimina",
                "no_rows": "Nessuna riga.",
                "invalid_file_type": "Per favore carica solo file Excel (.xlsx) o CSV",
                "xls_not_supported": "Il formato .xls non è supportato. Salva il file in formato .xlsx oppure .csv e riprova.",
                "file_too_large": "Il file è troppo grande. Dimensione massima consentita: {size} MB.",
                "read_error": "Impossibile leggere il file. Verifica che sia un file .xlsx o .csv valido e riprova.",
                "save_error": "Errore durante il salvataggio: ",
                "confirm_delete": "Eliminare questo file?",
                "delete_error": "Errore durante l'eliminazione: ",
                "print": "Stampa per lettura barcode"
            },
            "rettifica_headers": {
                "item": "Articolo",
                "description": "Descrizione",
                "commodity_ctg": "Cat. Merceologica",
                "homogeneous_ctg": "Cat. Omogenea",
                "lot": "Lotto",
                "storage": "Deposito",
                "specificator": "Cliente/Fornitore",
                "resulting_qty": "Quantità Risultante",
                "current_qty": "Quantità Attuale"
            },
            "reg-confirm": "Conferma",
            "ddt_flow": {
                "confirm_title": "Conferma salvataggio - Flusso Excel",
                "bills_to_create": "📋 Bolle di carico da creare:",
                "assignment_title": "⚠️ Assegnazione Numero DDT",
                "assignment_description": "I seguenti articoli non sono stati trovati nel file Excel. Assegna un numero DDT per ciascuno:",
                "choose_ddt": "-- Scegli DDT --",
                "insert_ddt_placeholder": "O inserisci DDT",
                "continue_save": "Continua salvataggio",
                "assign_ddt_warning": "Assegna un DDT per ogni articolo",
                "picking_no_orders": "(Picking non generati - nessun ordine cliente collegato)",
                "bills_created_count": "Bolle di carico create per {count} DDT",
                "error_ddt_assignment": "Errore nell'assegnazione dei DDT"
            },
            "supplier_doc_date": "Data Documento Fornitore",
            "bill_of_lading_date": "Data Registrazione Bolla di Carico",
            "print_pickings": "Picking Generati"
        },
        "pagination": {
            "next": "Prossimo &raquo;",
            "previous": "&laquo; Precedente"
        }
    }
}
